import axios from "axios";
import { notification } from "antd";

// Local URL
// export const API_URL = "http://localhost:7376";
// export const LAPI_URL = "http://localhost:8000/api";
// export const MEDIA_URL = "http://localhost:8000/";

// Production URLs
// export const API_URL = 'https://api.turningpointonline.in'
export const API_URL = 'https://cmstvision.tenagents.com/api';
export const LAPI_URL = "https://cmstvision.tenagents.com/api";
export const MEDIA_URL = "https://cmstvision.tenagents.com/";


let authAxios = axios.create({
  baseURL: API_URL,
});

let authLAxios = axios.create({
  baseURL: LAPI_URL,
})

class Request {
  error = (err) => {
    try {
      if (err.response.status === 401) {
        if (err.response && err.response.data && err.response.data.message != undefined) {
          notification.error({
            message: err.response.data.message
          });
        } else {
          notification.error({
            message: "Sorry You Cannot Access Software Here, Please login again to access this software.",
          });
        }

        localStorage.clear();
        setTimeout(function () {
          window.location.href = "/login";
        }, 1000);
      }
    } catch (e) { }
  };

  constructor() {
    if (localStorage.getItem("token")) {
      this.loadUserRights().then((x) => {
        if (x && !x.error) {
          localStorage.setItem("rights", JSON.stringify(x.userRights));
        }
      });
    }
  }



  // loadUserRights() {
  //   return new Promise((next, error) => {
  //     authAxios
  //       .post(
  //         "/fetchUserRights",
  //         {},
  //         {
  //           headers: {
  //             Authorization: "Bearer " + localStorage.getItem("token"),
  //           },
  //         }
  //       )
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadUserRights() {
    return new Promise((next, error) => {
      authLAxios
        .post(
          "/fetchUserRights",
          {},
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        )
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // deleteHeads(data) {
  //   return new Promise((next, error) => {
  //     authAxios
  //       .delete(
  //         "/heads",
  //         { data: { _id: data } },
  //         {
  //           headers: {
  //             Authorization: "Bearer " + localStorage.getItem("token"),
  //           },
  //         }
  //       )
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  // login(data) {
  //   return new Promise((next, error) => {
  //     authAxios
  //       .post("/login", data)
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  login(data) {
    return new Promise((next, error) => {
      authLAxios
        .post("/auth/login", data)
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  forgotPassword(data) {
    return new Promise((next, error) => {
      authLAxios
        .post("/auth/forgotPassword", data)
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  syncUserSessionWithLogin(data) {
    return new Promise((next, error) => {
      authLAxios
        .post("/auth/tenagents-login", data)
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  getImpersonationLink(data) {
    return new Promise((next, error) => {
      authLAxios
        .post("/auth/generateImpersonationLink", data)
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });

  }

  getAuthorizationTokenUser(token, verifyIP) {
    return new Promise((next, error) => {
      authLAxios
        .post(
          "/auth/getAuthorizationTokenUser?verifyIP=" + verifyIP,
          {},
          {
            headers: {
              Authorization: token,
            },
          }
        )
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  impersonateLogin(token) {
    return new Promise((next, error) => {
      authLAxios
        .post(
          "/auth/impersonateLogin",
          {},
          {
            headers: {
              Authorization: token,
            },
          }
        )
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // loginWithOtp(data) {
  //   return new Promise((next, error) => {
  //     authAxios
  //       .post("/loginWithOtp", data)
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  // getLoginTime(data) {
  //   return new Promise((next, error) => {
  //     authAxios
  //       .get("/getLoginTime", getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getLoginTime(data) {
    return new Promise((next, error) => {
      authLAxios
        .get("/getLoginTime", getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }


  // startTimer(data) {
  //   return new Promise((next, error) => {
  //     authAxios
  //       .post("/timerStarted", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  startTimer(data) {
    return new Promise((next, error) => {
      authLAxios
        .post("/timerStarted", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // stopEmployeeTimer(data) {
  //   return new Promise((next) => {
  //     authAxios.post("/stopEmployeeTimer", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  stopEmployeeTimer(data) {
    return new Promise((next) => {
      authLAxios.post("/stopEmployeeTimer", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // editEmployeeAttendence(data) {
  //   return new Promise((next) => {
  //     authAxios.post("/editEmployeeAttendence", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  editEmployeeAttendence(data) {
    return new Promise((next) => {
      authLAxios.post("/editEmployeeAttendence", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // stopTimer(data) {
  //   return new Promise((next, error) => {
  //     authAxios
  //       .post("/timerStopped", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  stopTimer(data) {
    return new Promise((next, error) => {
      authLAxios
        .post("/timerStopped", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // updatePolicyAccept(data) {
  //   return new Promise((next) => {
  //     authAxios.post("/updatePolicyAccept", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  updatePolicyAccept(data) {
    return new Promise((next) => {
      authLAxios.post("/updatePolicyAccept", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // updateProfile(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/updateProfile`, data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  updateProfile(data) {
    return new Promise((next) => {
      authLAxios
        .post(`/updateProfile`, data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // sendProfileUpdateNotification(data) {
  //   return new Promise((next) => {
  //     authAxios.post("/sendProfileUpdateNotification", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  sendProfileUpdateNotification(data) {
    return new Promise((next) => {
      authLAxios.post("/sendProfileUpdateNotification", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }
  // getUpdateProfile() {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/updateProfile`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getUpdateProfile() {
    return new Promise((next) => {
      authLAxios
        .get(`/updateProfile`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  //region University

  // addUniversity(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/university", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  addUniversity(data) {
    return new Promise((next) => {
      authLAxios
        .post("/university", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getUniversity(universityId) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/universityById/${universityId}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getUniversity(universityId) {
    return new Promise((next) => {
      authLAxios
        .get(`/universityById/${universityId}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // deleteUniversity(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .delete("/university", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  deleteUniversity(data) {
    return new Promise((next) => {
      authLAxios
        .delete("/university", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // restoreUniversity(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/universityRestore", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  restoreUniversity(data) {
    return new Promise((next) => {
      authLAxios
        .post("/universityRestore", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getUniversities(params) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/university`, { params: { ...params }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getUniversities(params) {
    return new Promise((next) => {
      authLAxios
        .get(`/university`, { params: { ...params }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }


  // Overall Reports Start


  getBranchWiseConversionReport(data) {
    return new Promise((next) => {
      authLAxios.get('/branchConversionReport', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  getCounsellorDailyReport(data) {
    return new Promise((next) => {
      authLAxios.get('/getCounsellorDailyReport', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  getVisaDepartmentReport(data) {
    return new Promise((next) => {
      authLAxios.get('/getVisaDepartmentReport', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  getVisaApprovalReport(data) {
    return new Promise((next) => {
      authLAxios.get('/getVisaApprovalReport', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  getVisaSubmissionApprovalReport(data) {
    return new Promise((next) => {
      authLAxios.get('/getVisaSubmissionApprovalReport', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  getVisaApprovalReportBranches(data) {
    return new Promise((next) => {
      authLAxios.get('/getVisaApprovalReportBranches', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }


  getVisaApprovedStudentReport(data) {
    return new Promise((next) => {
      authLAxios.get('/getVisaApprovedStudentReport', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }


  // getBusinessReportsByYear(data) {
  //   return new Promise((next) => {
  //     authAxios.get('/getBusinessReportsByYear', { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  // getBusinessReportsByCounsellor(data) {
  //   return new Promise((next) => {
  //     authAxios.get("/getBusinessReportsByCounsellor", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  // getBusinessReportsByBranch(data) {
  //   return new Promise((next) => {
  //     authAxios.get("/getBusinessReportsByBranch", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  // getBusinessReportsByCountry(data) {
  //   return new Promise((next) => {
  //     authAxios.get("http://127.0.0.1:8000/api/getCountryWiseBusinessReport", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  // getBusinessReportsByUniversity(data) {
  //   return new Promise((next) => {
  //     authAxios.get("http://127.0.0.1:8000/api/getUniversityWiseBusinessReport", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  // getBusinessReportsByCountry(data) {
  //   return new Promise((next)=>{
  //     authAxios.get("/getBusinessReportsByCountry", {params:{...data}, ...getToken()})
  //     .then((d)=>{
  //       next(d.data)
  //     })
  //     .catch((err)=>{
  //       this.error(err)
  //     })
  //   })
  // }

  // getOverallBusinessReport(data) {
  //   return new Promise((next) => {
  //     authAxios.get('/overallBusinessReport', { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  // viewReportDetails(data) {
  //   return new Promise((next) => {
  //     authAxios.get('/businessReportDetail', { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }


  // Overall Reports End


  // Call Details Start

  // addCallDetail(data) {
  //   return new Promise((next)=>{
  //     authAxios.post('/callDetails', data, getToken())
  //     .then((d)=>{
  //       next(d.data)
  //     })
  //     .catch((err)=>{
  //       this.error(err)
  //     })
  //   })
  // }
  addCallDetail(data) {
    return new Promise((next) => {
      authLAxios.post('/callDetails', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getCallDetails(data) {
  //   return new Promise((next) => {
  //     authAxios.get("/callDetails", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  getCallDetails(data) {
    return new Promise((next) => {
      authLAxios.get("/callDetails", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getCallDetailsByStudent(data) {
  //   return new Promise((next) => {
  //     authAxios.get("/callDetailsByStudent", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getCallDetailsByStudent(data) {
    return new Promise((next) => {
      authLAxios.get("/callDetailsByStudent", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getCallDetailsByCaller(data) {
  //   return new Promise((next) => {
  //     authAxios.get("/callDetailsByUser", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getCallDetailsByCaller(data) {
    return new Promise((next) => {
      authLAxios.get("/callDetailsByUser", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // deleteCallRecord(data) {
  //   return new Promise((next) => {
  //     authAxios.delete(`/callDetails?_id=${data.id}`, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  deleteCallRecord(data) {
    return new Promise((next) => {
      authLAxios.delete(`/callDetails?_id=${data.id}`, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // sendThankyouToConncetedCalls(data) {
  //   return new Promise((next) => {
  //     authAxios.post("/sendThankyouMessage", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  sendThankyouToConncetedCalls(data) {
    return new Promise((next) => {
      authLAxios.post("/sendThankyouMessage", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }


  // Call Details End

  // Service Provider Agreement Start

  // getServiceAgreements(data) {
  //   return new Promise((next) => {
  //     authAxios.get("/serviceAgreements", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getServiceAgreements(data) {
    return new Promise((next) => {
      authLAxios.get("/serviceAgreements", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // addServiceProviderAgreement(data) {
  //   return new Promise((next) => {
  //     authAxios.post("/serviceAgreements", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  addServiceProviderAgreement(data) {
    return new Promise((next) => {
      authLAxios.post("/serviceAgreements", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // updateServiceProviderAgreement(data) {
  //   return new Promise((next) => {
  //     authAxios.put("/serviceAgreements", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  updateServiceProviderAgreement(data) {
    return new Promise((next) => {
      authLAxios.put("/serviceAgreements", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // deleteServiceProviderAgreement(data) {
  //   return new Promise((next) => {
  //     authAxios.delete(`/serviceAgreements?_id=${data.id}`, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  deleteServiceProviderAgreement(data) {
    return new Promise((next) => {
      authLAxios.delete(`/serviceAgreements?_id=${data.id}`, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getServiceProviderAgreement(data) {
  //   return new Promise((next) => {
  //     authAxios.get('/serviceProviderAgreementById/' + data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getServiceProviderAgreement(data) {
    return new Promise((next) => {
      authLAxios.get('/serviceProviderAgreementById/' + data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }




  // Service Provider Agreement End

  // addAgreement(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/addAgreement", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  addAgreement(data) {
    return new Promise((next) => {
      authLAxios
        .post("/addAgreement", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getAgreementManagement(params) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/agreementManagement`, { params: { ...params }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }


  getAgreementManagement(params) {
    return new Promise((next) => {
      authLAxios
        .get(`/agreementManagement`, { params: { ...params }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // Channel Partner Commission Start
  addChannelPartnerCommission(data) {
    return new Promise((next) => {
      authLAxios.post('/channelPartnerCommission', data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  updateChannelPartnerCommission(data) {
    return new Promise((next) => {
      authLAxios.put('/channelPartnerCommission', data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  getChannelPartnerCommission(data) {
    return new Promise((next) => {
      authLAxios.get('/channelPartnerCommission', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }


  deleteChannelPartnerCommission(data) {
    return new Promise((next) => {
      authLAxios
        .delete(`/channelPartnerCommission?_id=${data._id}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  updateChannelPartnerCommActiveStatus(data) {
    return new Promise((next) => {
      authLAxios.post('/updateChannelPartnerCommActiveStatus', data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  getCPCommissionById(data) {
    return new Promise((next) => {
      authLAxios
        .get("/partnerCommissionsByID/" + data.id, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }



  // Channel Partner Commission End

  // getCommissionUniversities(params) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/universityCommissions`, { params: { ...params }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getCommissionUniversities(params) {
    return new Promise((next) => {
      authLAxios
        .get(`/universityCommissions`, { params: { ...params }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  getPendingUniversityCommApproval(params) {
    return new Promise((next) => {
      authLAxios.get('/getPendingUniversityCommApproval', { params: { ...params }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  // exportUniversityCommission(data) {
  //   return new Promise((next) => {
  //     authAxios.post("/universityCommissions/export", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   })
  // }
  exportUniversityCommission(data) {
    return new Promise((next) => {
      authLAxios.post("/universityCommissions/export", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  // addUniversityCommission(obj) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/universityCommissions`, obj, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  addUniversityCommission(obj) {
    return new Promise((next) => {
      authLAxios
        .post(`/universityCommissions`, obj, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // updateUniversityCommission(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put("/universityCommissions", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  updateUniversityCommission(data) {
    return new Promise((next) => {
      authLAxios
        .put("/universityCommissions", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // deleteCommission(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .delete(`/universityCommissions?_id=${data._id}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  deleteCommission(data) {
    return new Promise((next) => {
      authLAxios
        .delete(`/universityCommissions?_id=${data._id}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getCommissionById(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/universityCommissionsByID/" + data.id, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getCommissionById(data) {
    return new Promise((next) => {
      authLAxios
        .get("/universityCommissionsByID/" + data.id, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getuniversityCommissionsByUniversityID(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/universityCommissionsByUniversityID/" + data.id, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getuniversityCommissionsByUniversityID(data) {
    return new Promise((next) => {
      authLAxios
        .get("/universityCommissionsByUniversityID/" + data.id, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }


  getuniversityCommissionsInquiryId(data) {
    return new Promise((next) => {
      authLAxios.get('/universityCommmissionsByInquiryId/' + data.id, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }


  /* Finance company Details */

  // getCompanyDetails(params) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/financeCompanyDetails`, { params: { ...params }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getCompanyDetails(params) {
    return new Promise((next) => {
      authLAxios
        .get(`/financeCompanyDetails`, { params: { ...params }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  addMultiCompanyDetails(data) {
    return new Promise((next) => {
      authLAxios.post('/addMultiCompanyDetails', data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  // addCompanyDetails(obj) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/financeCompanyDetails`, obj, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  addCompanyDetails(obj) {
    return new Promise((next) => {
      authLAxios
        .post(`/financeCompanyDetails`, obj, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // updateCompanyDetails(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put("/financeCompanyDetails", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  updateCompanyDetails(data) {
    return new Promise((next) => {
      authLAxios
        .put("/financeCompanyDetails", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // deleteCompanyDetails(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .delete(`/financeCompanyDetails?_id=${data._id}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  deleteCompanyDetails(data) {
    return new Promise((next) => {
      authLAxios
        .delete(`/financeCompanyDetails?_id=${data._id}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // financeCompanyDetailsByID(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/financeCompanyDetailsByID/" + data.id, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  financeCompanyDetailsByID(data) {
    return new Promise((next) => {
      authLAxios
        .get("/financeCompanyDetailsByID/" + data.id, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  /**Finance company details end */

  // Finance Claims Secion Start
  // getAllFinanceClaims(data) {
  //   return new Promise((next) => {
  //     authAxios.get("/financeClaim", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getAllFinanceClaims(data) {
    return new Promise((next) => {
      authLAxios.get("/financeClaim", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }




  // Finance Claims Section End

  /* Finance Invoice To Details */

  // getInvoiceToDetails(params) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/financeInvoiceTo`, { params: { ...params }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getInvoiceToDetails(params) {
    return new Promise((next) => {
      authLAxios
        .get(`/financeInvoiceTo`, { params: { ...params }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // addInvoiceToDetails(obj) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/financeInvoiceTo`, obj, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  addInvoiceToDetails(obj) {
    return new Promise((next) => {
      authLAxios
        .post(`/financeInvoiceTo`, obj, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // updateInvoiceToDetails(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put("/financeInvoiceTo", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  updateInvoiceToDetails(data) {
    return new Promise((next) => {
      authLAxios
        .put("/financeInvoiceTo", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // deleteInvoiceToDetails(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .delete(`/financeInvoiceTo?_id=${data._id}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  deleteInvoiceToDetails(data) {
    return new Promise((next) => {
      authLAxios
        .delete(`/financeInvoiceTo?_id=${data._id}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // financeInvoiceToDetailsByID(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/financeInvoiceToDetailsByID/" + data.id, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  financeInvoiceToDetailsByID(data) {
    return new Promise((next) => {
      authLAxios
        .get("/financeInvoiceToDetailsByID/" + data.id, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  /**Finance Invoice To details end */

  /* Finance Tax Details */

  // getTaxDetails(params) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/financeTaxDetails`, { params: { ...params }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getTaxDetails(params) {
    return new Promise((next) => {
      authLAxios
        .get(`/financeTaxDetails`, { params: { ...params }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // addTaxDetails(obj) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/financeTaxDetails`, obj, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  addTaxDetails(obj) {
    return new Promise((next) => {
      authLAxios
        .post(`/financeTaxDetails`, obj, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // updateTaxDetails(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put("/financeTaxDetails", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  updateTaxDetails(data) {
    return new Promise((next) => {
      authLAxios
        .put("/financeTaxDetails", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // deleteTaxDetails(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .delete(`/financeTaxDetails?_id=${data._id}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  deleteTaxDetails(data) {
    return new Promise((next) => {
      authLAxios
        .delete(`/financeTaxDetails?_id=${data._id}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // financeTaxDetailsByID(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/financeTaxDetailsByID/" + data.id, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  financeTaxDetailsByID(data) {
    return new Promise((next) => {
      authLAxios
        .get("/financeTaxDetailsByID/" + data.id, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  /**Finance Tax details end */

  // getUniversityCourseCommissions(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/courseCommissions", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getUniversityCourseCommissions(data) {
    return new Promise((next) => {
      authLAxios
        .get("/courseCommissions", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getNextInvoiceGenerated(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/getNextInvoiceGenerated", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getNextInvoiceGenerated(data) {
    return new Promise((next) => {
      authLAxios
        .get("/getNextInvoiceGenerated", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // updateAPinvoiceInfo(data) {
  //   return new Promise((next, error) => {
  //     authAxios
  //       .post("/updateAPinvoiceInfo", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  updateAPinvoiceInfo(data) {
    return new Promise((next, error) => {
      authLAxios
        .post("/updateAPinvoiceInfo", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  resetInvoiceTerm(data) {
    return new Promise((next, error) => {
      authLAxios
        .post("/inquiry/reset-invoice-term", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // uploadMultipleInvoice(data) {
  //   return new Promise((next) => {
  //     authAxios.post('/uploadMultipleInvoice', data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  uploadMultipleInvoice(data) {
    return new Promise((next) => {
      authLAxios.post('/uploadMultipleInvoice', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // updateCPinvoiceInfo(data) {
  //   return new Promise((next, error) => {
  //     authAxios.post('/updateCPinvoiceInfo', data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  updateCPinvoiceInfo(data) {
    return new Promise((next, error) => {
      authLAxios.post('/updateCPinvoiceInfo', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // financeGenerateInvoice(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/financeGenerateInvoice", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  financeGenerateInvoice(data) {
    return new Promise((next) => {
      authLAxios
        .post("/financeGenerateInvoice", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  generateAutoPI(data) {
    return new Promise((next) => {
      authLAxios.post('/generateAutoPI', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err);
        })
    })
  }

  financeGenerateGroupInvoice(data) {
    return new Promise((next) => {
      authLAxios.post('/financeGenerateGroupInvoice', data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  financeUpdateGroupInvoice(data) {
    return new Promise((next) => {
      authLAxios.post('/financeUpdateGroupInvoice', data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  // financeUpdateInvoice(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/financeUpdateInvoice", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  financeUpdateInvoice(data) {
    return new Promise((next) => {
      authLAxios
        .post("/financeUpdateInvoice", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // withdrawStudent(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/withdrawStudent", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  withdrawStudent(data) {
    return new Promise((next) => {
      authLAxios
        .post("/withdrawStudent", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  withStudentFinalStage(data) {
    return new Promise((next) => {
      authLAxios.post('/withStudentFinalStage', data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  // withdrawStudentFinanceUpdate(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/withdrawStudentFinanceUpdate", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  withdrawStudentFinanceUpdate(data) {
    return new Promise((next) => {
      authLAxios
        .post("/withdrawStudentFinanceUpdate", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // withdrawStudentFinalUpdate(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/withdrawStudentFinalUpdate", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  withdrawStudentFinalUpdate(data) {
    return new Promise((next) => {
      authLAxios
        .post("/withdrawStudentFinalUpdate", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // rollbackStudentToFinanceClaimDesk(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/rollbackStudentToFinanceClaimDesk", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  rollbackStudentToFinanceClaimDesk(data) {
    return new Promise((next) => {
      authLAxios
        .post("/rollbackStudentToFinanceClaimDesk", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getInvoiceWithdrawRequests(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/getInvoiceWithdrawRequests", {
  //         params: { ...data },
  //         ...getToken(),
  //       })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getInvoiceWithdrawRequests(data) {
    return new Promise((next) => {
      authLAxios
        .get("/getInvoiceWithdrawRequests", {
          params: { ...data },
          ...getToken(),
        })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getInvoiceWithdrawalList(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/getInvoiceWithdrawalList", {
  //         params: { ...data },
  //         ...getToken(),
  //       })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getInvoiceWithdrawalList(data) {
    return new Promise((next) => {
      authLAxios
        .get("/getInvoiceWithdrawalList", {
          params: { ...data },
          ...getToken(),
        })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getInvoiceWithdrawFinalStageRequests(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/getInvoiceWithdrawFinalStageRequests", {
  //         params: { ...data },
  //         ...getToken(),
  //       })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getInvoiceWithdrawFinalStageRequests(data) {
    return new Promise((next) => {
      authLAxios
        .get("/getInvoiceWithdrawFinalStageRequests", {
          params: { ...data },
          ...getToken(),
        })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getCompanyBankDetails() {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/getCompanyBankDetails", getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getCompanyBankDetails() {
    return new Promise((next) => {
      authLAxios
        .get("/getCompanyBankDetails", getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getInvoiceDetail(invoiceId) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/getInvoiceDetail/" + invoiceId, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getInvoiceDetail(invoiceId) {
    return new Promise((next) => {
      authLAxios
        .get("/getInvoiceDetail/" + invoiceId, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  getInvoiceDetails(data) {
    return new Promise((next) => {
      authLAxios.get('/getInvoiceDetails', { params: data, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  // createNewInvoice(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/createNewInvoice", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  createNewInvoice(data) {
    return new Promise((next) => {
      authLAxios
        .post("/createNewInvoice", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getGeneratedInvoices(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/getGeneratedInvoices", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getGeneratedInvoices(data) {
    return new Promise((next) => {
      authLAxios
        .get("/getGeneratedInvoices", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // loadTodayInvoiceFollowUp(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/loadTodayInvoiceFollowUp", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadTodayInvoiceFollowUp(data) {
    return new Promise((next) => {
      authLAxios
        .get("/loadTodayInvoiceFollowUp", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // loadInvoiceFollowUps(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/loadInvoiceFollowUps", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadInvoiceFollowUps(data) {
    return new Promise((next) => {
      authLAxios
        .get("/loadInvoiceFollowUps", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // addInvoiceFollowUp(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/addInvoiceFollowUp", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  addInvoiceFollowUp(data) {
    return new Promise((next) => {
      authLAxios
        .post("/addInvoiceFollowUp", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // getGeneratedBranchInvoices(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/getGeneratedBranchInvoices", {
  //         params: { ...data },
  //         ...getToken(),
  //       })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getGeneratedBranchInvoices(data) {
    return new Promise((next) => {
      authLAxios
        .get("/getGeneratedBranchInvoices", {
          params: { ...data },
          ...getToken(),
        })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // getBranchClaimDeskInvoices(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/getBranchClaimDeskInvoices", {
  //         params: { ...data },
  //         ...getToken(),
  //       })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getBranchClaimDeskInvoices(data) {
    return new Promise((next) => {
      authLAxios
        .get("/getBranchClaimDeskInvoices", {
          params: { ...data },
          ...getToken(),
        })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  getPaidBranchInvoiceCount(data) {
    return new Promise((next) => {
      authLAxios.get('/getPaidBranchInvoices', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  updateBranchPaidInvoiceStatus(data) {
    return new Promise((next) => {
      authLAxios.post('/updateBranchPaidInvoiceStatus', data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  uploadBranchClaimInvoice(data) {
    return new Promise((next) => {
      authLAxios.post('/uploadBranchClaimInvoice', data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  generateBranchClaimInvoice(data) {
    return new Promise((next) => {
      authLAxios.post('/generateBranchClaimInvoice', data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  getApBranchInvoicesData(data) {
    return new Promise((next) => {
      authLAxios.get('/getApBranchInvoicesData', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  getBranchGeneratedInvoices(data) {
    return new Promise((next) => {
      authLAxios.get('/getBranchGeneratedInvoices', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  changeBranchInvoiceStatus(data) {
    return new Promise((next) => {
      authLAxios.post('/changeBranchInvoiceStatus', data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }
  getGeneratedBranchInvoices(data) {
    return new Promise((next) => {
      authLAxios.get('/getGeneratedBranchInvoices', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }
  updateBranchAPInvoiceStatus(data) {
    return new Promise((next) => {
      authLAxios.post('/updateBranchAPInvoiceStatus', data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }
  // getBranchDetails() {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/getBranchDetails", getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getBranchDetails(data) {
    return new Promise((next) => {
      authLAxios
        .get("/getBranchDetails", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // getGeneratedBranchInvoicesRequests() {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/getGeneratedBranchInvoicesRequests", getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getGeneratedBranchInvoicesRequests() {
    return new Promise((next) => {
      authLAxios
        .get("/getGeneratedBranchInvoicesRequests", getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // doGeneratedBranchInvoices(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/doGeneratedBranchInvoices", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  // sendAgreementRenewalMail(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/sendRenewalEmail", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  sendAgreementRenewalMail(data) {
    return new Promise((next) => {
      authLAxios
        .post("/sendRenewalEmail", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // sendInvoiceToUniversity(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/sendEmailInvoice", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  sendInvoiceToUniversity(data) {
    return new Promise((next) => {
      authLAxios
        .post("/sendEmailInvoice", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // sendBranchInvoice(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/sendBranchInvoice", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  // completeBranchInvoice(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/completeBranchInvoice", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  completeBranchInvoice(data) {
    return new Promise((next) => {
      authLAxios
        .post("/completeBranchInvoice", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // updateInvoiceData(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/updateInvoiceData", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  updateInvoiceData(data) {
    return new Promise((next) => {
      authLAxios
        .post("/updateInvoiceData", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  updateNewInvoiceStatus(data) {
    return new Promise((next) => {
      authLAxios.post("/updateNewInvoiceStatus", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  getInvoiceStatusUpdateRequests(data) {
    return new Promise((next) => {
      authLAxios.get('/getInvoiceStatusUpdateRequests', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  updateInvoiceUpdateRequest(data) {
    return new Promise((next) => {
      authLAxios.post('/updateInvoiceUpdateRequest', data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  // removeStudentFromInvoice(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/removeStudentFromInvoice", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  removeStudentFromInvoice(data) {
    return new Promise((next) => {
      authLAxios
        .post("/removeStudentFromInvoice", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // addCourseCommission(obj) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/courseCommissions`, obj, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  addCourseCommission(obj) {
    return new Promise((next) => {
      authLAxios
        .post(`/courseCommissions`, obj, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // updateCourseCommission(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put("/courseCommissions", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  updateCourseCommission(data) {
    return new Promise((next) => {
      authLAxios
        .put("/courseCommissions", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // deleteCourseCommission(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .delete(`/courseCommissions?_id=${data._id}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  deleteCourseCommission(data) {
    return new Promise((next) => {
      authLAxios
        .delete(`/courseCommissions?_id=${data._id}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getCourseCommissionById(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/courseCommissionsByID/" + data.id, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getCourseCommissionById(data) {
    return new Promise((next) => {
      authLAxios
        .get("/courseCommissionsByID/" + data.id, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getClaimDeskReportStates(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/getClaimDeskReportStates", {
  //         params: { ...data },
  //         ...getToken(),
  //       })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  // loadSimpleUniversities(data = {}) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/universitySimpleList`, { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadSimpleUniversities(data = {}) {
    return new Promise((next) => {
      authLAxios
        .get(`/universitySimpleList`, { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // loadCompanyPartners(data = {}) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/loadCompanyPartners`, { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadCompanyPartners(data = {}) {
    return new Promise((next) => {
      authLAxios
        .get(`/loadCompanyPartners`, { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getAllEveryUniversity(data = {}) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/universitySimpleList`, { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getAllEveryUniversity(data = {}) {
    return new Promise((next) => {
      authLAxios
        .get(`/universitySimpleList`, { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // loadSimpleUniversityCourse(universityId) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/university/allCourses/${universityId}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadSimpleUniversityCourse(universityId) {
    return new Promise((next) => {
      authLAxios
        .get(`/university/allCourses/${universityId}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // loadSimpleUniversitiesByCountry(params) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/universitySimpleListByCountry`, {
  //         params: { ...params },
  //         ...getToken(),
  //       })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadSimpleUniversitiesByCountry(params) {
    return new Promise((next) => {
      authLAxios
        .get(`/universitySimpleListByCountry`, {
          params: { ...params },
          ...getToken(),
        })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // loadSuggestUni(obj) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/loadSuggestUni`, obj, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadSuggestUni(obj) {
    return new Promise((next) => {
      authLAxios
        .post(`/loadSuggestUni`, obj, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // updateUniversity(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put("/university", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  updateUniversity(data) {
    return new Promise((next) => {
      authLAxios
        .put("/university", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  //endregion

  // updateUniversityCommissionStatus(data) {
  //   return new Promise((next) => {
  //     authAxios.post("/updateUniversityCommissionStatus", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   })
  // }
  updateUniversityCommissionStatus(data) {
    return new Promise((next) => {
      authLAxios.post("/updateUniversityCommissionStatus", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  updateCourseCommissionStatus(data) {
    return new Promise((next) => {
      authLAxios.put('/updateCourseCommissionStatus', data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  updateUniversityCommissionActiveStatus(data) {
    return new Promise((next) => {
      authLAxios.post("/updateUniversityCommissionActiveStatus", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  updateUniversityAgreement(data) {
    return new Promise((next) => {
      authLAxios
        .put("/updateUniversityAgreement", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // updateUniversityAgreement(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put("/updateUniversityAgreement", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  //region Country

  // saveCountrySetup(data) {
  //   return new Promise((next) => {
  //     authAxios.post("/saveCountrySetup", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  saveUniversitySetup(data) {
    return new Promise((next) => {
      authLAxios.post("/saveUniversitySetup", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // checkSetupStatus(data = null) {
  //   return new Promise((next) => {
  //     authAxios.get("/checkSetupStatus", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  // addCountry(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/country", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  addCountry(data) {
    return new Promise((next) => {
      authLAxios
        .post("/country", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getAllCountryProcesses(data) {
  //   return new Promise((next) => {
  //     authAxios.get("/countryProcesses", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getAllCountryProcesses(data) {
    return new Promise((next) => {
      authLAxios.get("/countryProcesses", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // changeCountryProcess(data) {
  //   return new Promise((next) => {
  //     authAxios.put("/countryProcesses", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  changeCountryProcess(data) {
    return new Promise((next) => {
      authLAxios.put("/countryProcesses", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // changeCountryProcessStatus(data) {
  //   return new Promise((next) => {
  //     authAxios.post("/changeProcessStatus", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  changeCountryProcessStatus(data) {
    return new Promise((next) => {
      authLAxios.post("/changeProcessStatus", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // deleteCountryProcess(data) {
  //   return new Promise((next) => {
  //     authAxios.delete("/countryProcesses", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  deleteCountryProcess(data) {
    return new Promise((next) => {
      authLAxios.delete("/countryProcesses", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getProcessedCountryDetailsById(data) {
  //   return new Promise((next) => {
  //     authAxios.get("/processCountry", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getProcessedCountryDetailsById(data) {
    return new Promise((next) => {
      authLAxios.get("/processCountry", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // loadProcessedCountryDocumentTitles(data) {
  //   return new Promise((next) => {
  //     authAxios.get("/getProcessedCountryTitle", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  loadProcessedCountryDocumentTitles(data) {
    return new Promise((next) => {
      authLAxios.get("/getProcessedCountryTitle", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getDocumentTypeTitles(data) {
  //   return new Promise((next) => {
  //     authAxios.get("/getDocumentTypeTitles", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  getDocumentTypeTitles(data) {
    return new Promise((next) => {
      authLAxios.get("/getDocumentTypeTitles", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // updateCountryProcessed(data) {
  //   return new Promise((next) => {
  //     authAxios.put("/processCountry", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  updateCountryProcessed(data) {
    return new Promise((next) => {
      authLAxios.put("/processCountry", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }
  // deleteProcessDetail(data) {
  //   return new Promise((next) => {
  //     authAxios.delete("/processCountry", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  // deleteProcessDetail(data) {
  //   return new Promise((next) => {
  //     authAxios.delete("/processCountry", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  deleteProcessDetail(data) {
    return new Promise((next) => {
      authLAxios.delete("/processCountry", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }
  // addCountryProcessed(data) {
  //   return new Promise((next) => {
  //     authAxios.post("/processCountry", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  addCountryProcessed(data) {
    return new Promise((next) => {
      authLAxios.post("/processCountry", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getProcessDetailsById(data) {
  //   return new Promise((next) => {
  //     authAxios.get("/processCountryById", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getProcessDetailsById(data) {
    return new Promise((next) => {
      authLAxios.get("/processCountryById", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }
  // printCourseDetails(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/printCourse`, data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  printCourseDetails(data) {
    return new Promise((next) => {
      authLAxios
        .post(`/printCourse`, data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getCourseDetailsForFact(data) {
  //   return new Promise((next) => {
  //     authAxios.post('/getCourseDetailsForFact', data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getCourseDetailsForFact(data) {
    return new Promise((next) => {
      authLAxios.post('/getCourseDetailsForFact', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // saveMasterDoc(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/master/media/add", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  saveMasterDoc(data) {
    return new Promise((next) => {
      authLAxios
        .post("/master/media/add", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  saveMasterDocument(data) {
    return new Promise((next) => {
      authLAxios
        .post("/master/documents/add", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // saveStudentDoc(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/student/media/add", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  saveStudentDoc(data) {
    return new Promise((next) => {
      authLAxios
        .post("/student/media/add", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // uploadOffer(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/student/offer/upload", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  uploadOffer(data) {
    return new Promise((next) => {
      authLAxios
        .post("/student/offer/upload", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // reUploadOffer(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/student/offer/reUpload", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  reUploadOffer(data) {
    return new Promise((next) => {
      authLAxios
        .post("/student/offer/reUpload", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // masterMediaList(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/master/media/list", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  masterMediaList(data) {
    return new Promise((next) => {
      authLAxios
        .post("/master/media/list", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  fetchMasterMediaList(data) {
    return new Promise((next) => {
      authLAxios.post('/master/documents/list', data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  // studentMediaList(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/student/media/list", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  studentMediaList(data) {
    return new Promise((next) => {
      authLAxios
        .post("/student/media/list", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // updateCountry(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put("/country", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  updateCountry(data) {
    return new Promise((next) => {
      authLAxios
        .put("/country", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getCountries(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/country", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         // this.error(err)
  //       });
  //   });
  // }
  getCountries(data) {
    return new Promise((next) => {
      authLAxios
        .get("/country", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          // this.error(err)
        });
    });
  }

  getCountryWiseStudentReport(data) {
    return new Promise((next) => {
      authLAxios.get('/getCountryWiseStudentReport', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err)
        });
    })
  }

  // getCounsellorUsers(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/counsellorUsers", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         // this.error(err)
  //       });
  //   });
  // }
  getCounsellorUsers(data) {
    return new Promise((next) => {
      authLAxios
        .get("/counsellorUsers", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          // this.error(err)
        });
    });
  }


  // Announcements

  addAnnouncement(data) {
    return new Promise((next) => {
      authLAxios.post('/announcements', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }


  // addAnnouncement(data) {
  //   return new Promise((next) => {
  //     authAxios.post('/annoucements', data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  getAnnouncements(data) {
    return new Promise((next) => {
      authLAxios.get('/announcements', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  getAllAnnouncements(data) {
    return new Promise((next) => {
      authLAxios.get('/getAnnoucements', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getAnnouncements(data) {
  //   return new Promise((next) => {
  //     authAxios.get('/annoucements', { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  // updateAnnoucement(data) {
  //   return new Promise((next) => {
  //     authAxios.put('/annoucements', data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  updateAnnoucement(data) {
    return new Promise((next) => {
      authLAxios.put('/annoucements', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }
  getUnreadAnnoucements(data) {
    return new Promise((next) => {
      authLAxios.get('/getUnreadAnnoucements', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }
  // getAnnouncementById(data) {
  //   return new Promise((next) => {
  //     authAxios.get('/announcementById/' + data.id, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  // applyLeave(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/leaveApplication", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  applyLeave(data) {
    return new Promise((next) => {
      authLAxios
        .post("/leaveApplication", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // getLeaveApplications(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/leaveApplication", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getLeaveApplications(data) {
    return new Promise((next) => {
      authLAxios
        .get("/leaveApplication", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  getLeaveTypes(data) {
    return new Promise((next) => {
      authLAxios.get('/getLeaveTypes', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }
  // getStaffLeaveApplications(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/staffLeaves", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getStaffLeaveApplications(data) {
    return new Promise((next) => {
      authLAxios
        .get("/staffLeaves", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // getTeamLeaveApplications(data) {
  //   return new Promise((next) => {
  //     authAxios.get("/teamLeaves", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getTeamLeaveApplications(data) {
    return new Promise((next) => {
      authLAxios.get("/teamLeaves", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // updateStaffLeave(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put("/leaveApplication", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  updateStaffLeave(data) {
    return new Promise((next) => {
      authLAxios
        .put("/leaveApplication", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // getUserLeaves(data) {
  //   return new Promise((next) => {
  //     authAxios.get('/getUserLeaves', { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getUserLeaves(data) {
    return new Promise((next) => {
      authLAxios.get('/getUserLeaves', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }
  // getAbsentEmployees(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/absentEmployees", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getAbsentEmployees(data) {
    return new Promise((next) => {
      authLAxios
        .get("/absentEmployees", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // getPresentEmployees(data) {
  //   return new Promise((next) => {
  //     authAxios.get("/presentEmployees", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getPresentEmployees(data) {
    return new Promise((next) => {
      authLAxios.get("/presentEmployees", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // Departments

  // addDepartment(data) {
  //   return new Promise((next) => {
  //     authAxios.post("/departments", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  addDepartment(data) {
    return new Promise((next) => {
      authLAxios.post("/departments", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // updateDepartment(data) {
  //   return new Promise((next) => {
  //     authAxios.put('/departments', data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  updateDepartment(data) {
    return new Promise((next) => {
      authLAxios.put('/departments', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getAllDepartments(data) {
  //   return new Promise((next) => {
  //     authAxios.get('/departments', { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getAllDepartments(data) {
    return new Promise((next) => {
      authLAxios.get('/departments', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getDepartmentById(data) {
  //   return new Promise((next) => {
  //     authAxios.get('/departmentById/' + data.id, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getDepartmentById(data) {
    return new Promise((next) => {
      authLAxios.get('/departmentById/' + data.id, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // deleteDepartment(data) {
  //   return new Promise((next) => {
  //     authAxios.delete(`/departments?_id=${data._id}`, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  deleteDepartment(data) {
    return new Promise((next) => {
      authLAxios.delete(`/departments?_id=${data._id}`, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }


  // Departments End

  // Accomodation Service Start

  // addAccomodationService(data){
  //   return new Promise((next)=>{
  //     authAxios.post('/accomodationService', data, getToken())
  //     .then((d)=>{
  //       next(d.data)
  //     })
  //     .catch((err)=>{
  //       this.error(err)
  //     })
  //   })
  // }
  addAccomodationService(data) {
    return new Promise((next) => {
      authLAxios.post('/accomodationService', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getAllAccomodationServices(data){
  //   return new Promise((next)=>{
  //     authAxios.get("/accomodationService", {params:{...data}, ...getToken()})
  //     .then((d)=>{
  //       next(d.data)
  //     })
  //     .catch((err)=>{
  //       this.error(err)
  //     })
  //   })
  // }

  getAllAccomodationServices(data) {
    return new Promise((next) => {
      authLAxios.get("/accomodationService", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getAccomodationServiceById(data){
  //   return new Promise((next)=>{
  //     authAxios.get(`/accomodationServiceById/${data.id}`, getToken())
  //     .then((d)=>{
  //       next(d.data)
  //     })
  //     .catch((err)=>{
  //       this.error(err)
  //     })
  //   })
  // }
  getAccomodationServiceById(data) {
    return new Promise((next) => {
      authLAxios.get(`/accomodationServiceById/${data.id}`, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // deleteAccomodationService(data) {
  //   return new Promise((next)=>{
  //     authAxios.delete(`/accomodationService?_id=${data._id}`, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  deleteAccomodationService(data) {
    return new Promise((next) => {
      authLAxios.delete(`/accomodationService?_id=${data._id}`, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // updateAccomodationService(data){
  //   return new Promise((next)=>{
  //     authAxios.put('/accomodationService', data, getToken())
  //     .then((d)=>{
  //       next(d.data)
  //     })
  //     .catch((err)=>{
  //       this.error(err)
  //     })
  //   })
  // }
  updateAccomodationService(data) {
    return new Promise((next) => {
      authLAxios.put('/accomodationService', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // Accomodation Service End

  // Shift Timing

  // addShiftTiming(data) {
  //   return new Promise((next) => {
  //     authAxios.post("/shiftTiming", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  addShiftTiming(data) {
    return new Promise((next) => {
      authLAxios.post("/shiftTiming", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getAllShiftTimings(data) {
  //   return new Promise((next) => {
  //     authAxios.get("/shiftTiming", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getAllShiftTimings(data) {
    return new Promise((next) => {
      authLAxios.get("/shiftTiming", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getShiftTimingById(data) {
  //   return new Promise((next) => {
  //     authAxios.get("/shiftTimingById/" + data.id, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getShiftTimingById(data) {
    return new Promise((next) => {
      authLAxios.get("/shiftTimingById/" + data.id, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // updateShiftTiming(data) {
  //   return new Promise((next) => {
  //     authAxios.put("/shiftTiming", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  updateShiftTiming(data) {
    return new Promise((next) => {
      authLAxios.put("/shiftTiming", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // deleteShiftTimingDetail(data) {
  //   return new Promise((next) => {
  //     authAxios.delete(`/shiftTiming?_id=${data._id}`, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  deleteShiftTimingDetail(data) {
    return new Promise((next) => {
      authLAxios.delete(`/shiftTiming?_id=${data._id}`, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // Job Role Section START
  // addJobRole(data){
  //   return new Promise((next)=>{
  //     authAxios.post("/jobRoles", data, getToken())
  //     .then((d)=>{
  //       next(d.data)
  //     })
  //     .catch((err)=>{
  //       this.error(err)
  //     })
  //   })
  // }
  addJobRole(data) {
    return new Promise((next) => {
      authLAxios.post("/jobRoles", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // updateOnCarrerPageJobRole(data){
  //   return new Promise((next)=>{
  //     authAxios.post("/showJobRoleOnWebsite", data, getToken())
  //     .then((d)=>{
  //       next(d.data)
  //     })
  //     .catch((err)=>{
  //       this.error(err)
  //     })
  //   })
  // }


  updateOnCarrerPageJobRole(data) {
    return new Promise((next) => {
      authLAxios.post("/showJobRoleOnWebsite", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getAllJobRoles(data) {
  //   return new Promise((next)=>{
  //     authAxios.get("/jobRoles", {params:{...data}, ...getToken()})
  //     .then((d)=>{
  //       next(d.data)
  //     })
  //     .catch((err)=>{
  //       this.error(err)
  //     })
  //   })
  // }
  getAllJobRoles(data) {
    return new Promise((next) => {
      authLAxios.get("/jobRoles", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getJobRole(data) {
  //   return new Promise((next)=>{
  //     authAxios.get("/jobRolesById/" + data.id, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getJobRole(data) {
    return new Promise((next) => {
      authLAxios.get("/jobRolesById/" + data.id, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }
  // updateJobRole(data) {
  //   return new Promise((next) => {
  //     authAxios.put("/jobRoles", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  updateJobRole(data) {
    return new Promise((next) => {
      authLAxios.put("/jobRoles", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // deleteJobRole(data) {
  //   return new Promise((next) => {
  //     authAxios.delete(`/jobRoles?_id=${data._id}`, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  deleteJobRole(data) {
    return new Promise((next) => {
      authLAxios.delete(`/jobRoles?_id=${data._id}`, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // Job Role Section END


  // getDealingCountries(data) {
  //   return new Promise((next) => {
  //     authAxios.get('/getDealingCountries', { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   })
  // }
  getDealingCountries(data) {
    return new Promise((next) => {
      authLAxios.get('/getDealingCountries', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  // getCountriesWithoutAuth(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/countryWithoutAuth", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getCountriesWithoutAuth(data) {
    return new Promise((next) => {
      authLAxios
        .get("/countryWithoutAuth", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getCountriesWithoutBusinessAuth(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/countryWithoutBusinessAuth", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getCountriesWithoutBusinessAuth(data) {
    return new Promise((next) => {
      authLAxios
        .get("/countryWithoutBusinessAuth", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getIncentiveAmounts(data) {
  //   return new Promise((next) => {
  //     authAxios.get("/getIncentiveAmount", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getIncentiveAmounts(data) {
    return new Promise((next) => {
      authLAxios.get("/getIncentiveAmount", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getWalletAmount(data) {
  //   return new Promise((next) => {
  //     authAxios.get("/getWalletAmount", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getWalletAmount(data) {
    return new Promise((next) => {
      authLAxios.get("/getWalletAmount", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getDisburseAmount(data) {
  //   return new Promise((next) => {
  //     authAxios.get("/getDisburseAmount", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getDisburseAmount(data) {
    return new Promise((next) => {
      authLAxios.get("/getDisburseAmount", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getIncentiveDeskAmounts(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/getIncentiveDeskAmounts", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getIncentiveDeskAmounts(data) {
    return new Promise((next) => {
      authLAxios
        .get("/getIncentiveDeskAmounts", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // loadStates(id) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/country/allStates/${id}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadStates(id) {
    return new Promise((next) => {
      authLAxios
        .get(`/country/allStates/${id}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // loadStatesByCountry(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/country/allStates", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadStatesByCountry(data) {
    return new Promise((next) => {
      authLAxios
        .post("/country/allStates", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getCountry(countryId) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/country/${countryId}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getCountry(countryId) {
    return new Promise((next) => {
      authLAxios
        .get(`/country/${countryId}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getCountryFact(countryId) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/country/factSheet/${countryId}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getCountryFact(countryId) {
    return new Promise((next) => {
      authLAxios
        .get(`/country/factSheet/${countryId}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // exportCountryCoursesCsv(_id) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/country/exportCountryCoursesCsv/${_id}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  exportCountryCoursesCsv(_id) {
    return new Promise((next) => {
      authLAxios
        .get(`/country/exportCountryCoursesCsv/${_id}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // exportCountryUniversityCsv(_id) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/country/exportCountryUniversityCsv/${_id}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  exportCountryUniversityCsv(_id) {
    return new Promise((next) => {
      authLAxios
        .get(`/country/exportCountryUniversityCsv/${_id}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // importCountryCoursesCsv(data = {}, _id) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/country/importCountryCoursesCsv/${_id}`, data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  importCountryCoursesCsv(data = {}, _id) {
    return new Promise((next) => {
      authLAxios
        .post(`/country/importCountryCoursesCsv/${_id}`, data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // importCountryUniversityCsv(data = {}, _id) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/country/importCountryUniversityCsv/${_id}`, data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  importCountryUniversityCsv(data = {}, _id) {
    return new Promise((next) => {
      authLAxios
        .post(`/country/importCountryUniversityCsv/${_id}`, data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  //endregion

  //region States

  // addState(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/states", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  addState(data) {
    return new Promise((next) => {
      authLAxios
        .post("/states", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // updateState(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put(`/states`, data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  updateState(data) {
    return new Promise((next) => {
      authLAxios
        .put(`/states`, data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // deleteState(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .delete(`/states?stateId=${data.stateId}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  deleteState(data) {
    return new Promise((next) => {
      authLAxios
        .delete(`/states?stateId=${data.stateId}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  //endregion

  //region City

  // addCity(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/city", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  addCity(data) {
    return new Promise((next) => {
      authLAxios
        .post("/city", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }


  // updateCity(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put(`/city`, data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  updateCity(data) {
    return new Promise((next) => {
      authLAxios
        .put(`/city`, data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // loadCities(id) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/state/allCities/${id}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadCities(id) {
    return new Promise((next) => {
      authLAxios
        .get(`/state/allCities/${id}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // loadCitiesForCourseFinder(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/state/allCitiesByStateOrCountry`, data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadCitiesForCourseFinder(data) {
    return new Promise((next) => {
      authLAxios
        .post(`/state/allCitiesByStateOrCountry`, data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // loadCitiesByCountry(countryId) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/country/allCities/${countryId}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadCitiesByCountry(countryId) {
    return new Promise((next) => {
      authLAxios
        .get(`/country/allCities/${countryId}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // deleteCity(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .delete(`/city/${data.cityId}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  deleteCity(data) {
    return new Promise((next) => {
      authLAxios
        .delete(`/city/${data.cityId}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  //endregion

  //region Campus
  // addCampus(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/university/addCampus`, data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  addCampus(data) {
    return new Promise((next) => {
      authLAxios
        .post(`/university/addCampus`, data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // deleteCampus(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/universityById/${data._id}/${data.campusId}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  deleteCampus(data) {
    return new Promise((next) => {
      authLAxios
        .get(`/universityById/${data._id}/${data.campusId}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // updateCampus(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put(`/university/updateCampus`, data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  updateCampus(data) {
    return new Promise((next) => {
      authLAxios
        .put(`/university/updateCampus`, data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getCampus(campusId) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/university/singleCampus/${campusId}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getCampus(campusId) {
    return new Promise((next) => {
      authLAxios
        .get(`/university/singleCampus/${campusId}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // loadUniCampus(uniId) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/university/allCampus/${uniId}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadUniCampus(uniId) {
    return new Promise((next) => {
      authLAxios
        .get(`/university/allCampus/${uniId}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getAllCampus(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/university/allCampus", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getAllCampus(data) {
    return new Promise((next) => {
      authLAxios
        .get("/university/allCampus", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  //endregion

  // region Course
  // addCourse(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/university/addCourse`, data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  addCourse(data) {
    return new Promise((next) => {
      authLAxios
        .post(`/university/addCourse`, data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // deleteCourse(courseId) {
  //   return new Promise((next) => {
  //     authAxios
  //       .delete(`/deleteCourse/${courseId}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  deleteCourse(courseId) {
    return new Promise((next) => {
      authLAxios
        .delete(`/deleteCourse/${courseId}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // restoreCourse(courseId) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/restoreCourse/${courseId}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  restoreCourse(courseId) {
    return new Promise((next) => {
      authLAxios
        .get(`/restoreCourse/${courseId}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getCourse(courseId) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/university/singleCourse/${courseId}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getCourse(courseId) {
    return new Promise((next) => {
      authLAxios
        .get(`/university/singleCourse/${courseId}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  getCourseByIds(data) {
    return new Promise((next) => {
      authLAxios.post('/getCourseByIds', data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  // updateCourse(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put(`/university/updateCourse`, data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  updateCourse(data) {
    return new Promise((next) => {
      authLAxios
        .put(`/university/updateCourse`, data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // exportUniversityCoursesCsv(_id) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/university/exportUniversityCoursesCsv/${_id}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  exportUniversityCoursesCsv(_id) {
    return new Promise((next) => {
      authLAxios
        .get(`/university/exportUniversityCoursesCsv/${_id}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // importUniversityCoursesCsv(data = {}, _id) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/university/importUniversityCoursesCsv/${_id}`, data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  importUniversityCoursesCsv(data = {}, _id) {
    return new Promise((next) => {
      authLAxios
        .post(`/university/importUniversityCoursesCsv/${_id}`, data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getAllCourse(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/university/allCourse", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getAllCourse(data) {
    return new Promise((next) => {
      authLAxios
        .get("/university/allCourse", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  exportAllCourses(data) {
    return new Promise((next) => {
      authLAxios.post('/university/allCourseExport', data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  // getAllCommissionCountryWiseReport(data) {
  //   return new Promise((next) => {
  //     authAxios.get('/getstatsCountryWise', { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getAllCommissionCountryWiseReport(data) {
    return new Promise((next) => {
      authLAxios.get('/getstatsCountryWise', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getAllUniversityWiseStudentReport(data) {
  //   return new Promise((next) => {
  //     authAxios.get(`/getstatsStudentList?countryId=${data.countryId}&universityId=${data.universityId}&invoiceStatus=${data.invoiceStatus}`, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getAllUniversityWiseStudentReport(data) {
    return new Promise((next) => {
      authLAxios.get(`/getstatsStudentList?countryId=${data.countryId}&universityId=${data.universityId}&invoiceStatus=${data.invoiceStatus}`, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getAllCommissionUniversityWiseReport(data) {
  //   return new Promise((next) => {
  //     authAxios.get('/getstatsUniversityWise?countryId=' + data.countryId, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getAllCommissionUniversityWiseReport(data) {
    return new Promise((next) => {
      authLAxios.get('/getstatsUniversityWise?countryId=' + data.countryId, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getAllCourseForCoursesReport(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/university/allCourse/coursesReport", {
  //         params: { ...data },
  //         ...getToken(),
  //       })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getAllCourseForCoursesReport(data) {
    return new Promise((next) => {
      authLAxios
        .get("/university/allCourse/coursesReport", {
          params: { ...data },
          ...getToken(),
        })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getAllCourseForCounselling(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/university/allCourseForCounselling", {
  //         params: { ...data },
  //         ...getToken(),
  //       })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getAllCourseForCounselling(data) {
    return new Promise((next) => {
      authLAxios
        .get("/university/allCourseForCounselling", {
          params: { ...data },
          ...getToken(),
        })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getAllSuggestedCourse(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/suggested/course/list", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getAllSuggestedCourse(data) {
    return new Promise((next) => {
      authLAxios
        .get("/suggested/course/list", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // loadSuggestFilterData(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/loadSuggestFilterData", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadSuggestFilterData(data) {
    return new Promise((next) => {
      authLAxios
        .get("/loadSuggestFilterData", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getCourseCampus(_id) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/university/course/campus", { _id: _id }, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getCourseCampus(_id) {
    return new Promise((next) => {
      authLAxios
        .post("/university/course/campus", { _id: _id }, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  //endregion

  // region Partner
  // addPartner(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/channelPartner`, data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  addPartner(data) {
    return new Promise((next) => {
      authLAxios
        .post(`/channelPartner`, data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // deleteChannelPartner(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .delete("/ChannelPartner", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  deleteChannelPartner(data) {
    return new Promise((next) => {
      authLAxios
        .delete("/channelPartner", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // updatePartner(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put(`/channelPartner`, data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  updatePartner(data) {
    return new Promise((next) => {
      authLAxios
        .put(`/channelPartner`, data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // updateUniCommInCP(data) {
  //   return new Promise((next) => {
  //     authAxios.post('/updateUniCommInCP', data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   })
  // }
  updateUniCommInCP(data) {
    return new Promise((next) => {
      authLAxios.post('/updateUniCommInCP', data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  exportChannelPartnerComm(data) {
    return new Promise((next) => {
      authLAxios.post('/exportChannelPartnerComm', data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  importChannelPartnerComm(data) {
    return new Promise((next) => {
      authLAxios.post('/importChannelPartnerComm', data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  importUniversitiesComm(data) {
    return new Promise((next) => {
      authLAxios.post('/importUniversitiesComm', data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }


  changeEmployeeIncentiveInCP(data) {
    return new Promise((next) => {
      authLAxios.post('/changeEmployeeIncentiveInCP', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getPartner(partId) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/channelPartner/${partId}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getPartner(partId) {
    return new Promise((next) => {
      authLAxios
        .get(`/channelPartner/${partId}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // changeEmployeeIncentive(data) {
  //   return new Promise((next) => {
  //     authAxios.post("/channelPartner/changeEmployeeIncentive", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  changeEmployeeIncentive(data) {
    return new Promise((next) => {
      authLAxios.post("/channelPartner/changeEmployeeIncentive", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  changeChannelPartnerStatus(data) {
    return new Promise((next) => {
      authLAxios.post('/changeChannelPartnerStatus', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // loadChannelPartners(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/loadChannelPartner", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadChannelPartners(data) {
    return new Promise((next) => {
      authLAxios
        .get("/loadChannelPartner", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getUniversityChannelPartners(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/getUniversityChannelPartners", {
  //         params: { ...data },
  //         ...getToken(),
  //       })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getUniversityChannelPartners(data) {
    return new Promise((next) => {
      authLAxios
        .get("/getUniversityChannelPartners", {
          params: { ...data },
          ...getToken(),
        })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  getChannelPartnerUniversities(channelPartnerId) {
    return new Promise((next) => {
      authLAxios.get(`/getChannelPartnerUniversities/${channelPartnerId}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // loadChannelPartnerByUniversityID(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/loadChannelPartnerByUniversityID", {
  //         params: { ...data },
  //         ...getToken(),
  //       })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadChannelPartnerByUniversityID(data) {
    return new Promise((next) => {
      authLAxios
        .get("/loadChannelPartnerByUniversityID", {
          params: { ...data },
          ...getToken(),
        })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  loadChannelPartnerByPriority(data) {
    return new Promise((next) => {
      authLAxios
        .get("/loadChannelPartnerByPriority", {
          params: { ...data },
          ...getToken(),
        })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getPartners(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/channelPartner", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getPartners(data) {
    return new Promise((next) => {
      authLAxios
        .get("/channelPartner", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getSimplePartners(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/simpleChannelPartner", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getSimplePartners(data) {
    return new Promise((next) => {
      authLAxios
        .get("/simpleChannelPartner", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  //endregion


  // Account Payment Update Request

  addAccountPaymentUpdateRequest(data) {
    return new Promise((next) => {
      authLAxios.post('/updatePaymentRequest', data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  fetchPendingPaymentUpdateRequest(data) {
    return new Promise((next) => {
      authLAxios.get('/updatePaymentRequest', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  changeUpdateRequestStatus(data) {
    return new Promise((next) => {
      authLAxios.put('/updatePaymentRequest', data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  //region Visa Categories

  // addVisaCategories(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/visaCategory", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  addVisaCategories(data) {
    return new Promise((next) => {
      authLAxios
        .post("/visaCategory", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // deleteVisaCategory(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .delete(`/visaCategory/${data._id}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  deleteVisaCategory(data) {
    return new Promise((next) => {
      authLAxios
        .delete(`/visaCategory/${data._id}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // updateVisaCategories(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put(`/visaCategory`, data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  updateVisaCategories(data) {
    return new Promise((next) => {
      authLAxios
        .put(`/visaCategory`, data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // loadVisaCategories(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/visaCategory", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  loadVisaCategories(data) {
    return new Promise((next) => {
      authLAxios
        .get("/visaCategory", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getVisaCategories(partId) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/visaCategory/${partId}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  getVisaCategories(partId) {
    return new Promise((next) => {
      authLAxios
        .get(`/visaCategory/${partId}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  //endregion

  // region Faculty

  // addFaculty(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/faculty`, data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  addFaculty(data) {
    return new Promise((next) => {
      authLAxios
        .post(`/faculty`, data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // deleteFaculty(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .delete(`/faculty/${data._id}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  deleteFaculty(data) {
    return new Promise((next) => {
      authLAxios
        .delete(`/faculty/${data._id}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // updateFaculty(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put(`/faculty`, data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  updateFaculty(data) {
    return new Promise((next) => {
      authLAxios
        .put(`/faculty`, data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getFaculty(partId) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/faculty/${partId}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getFaculty(partId) {
    return new Promise((next) => {
      authLAxios
        .get(`/faculty/${partId}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // loadFaculties(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/faculty", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadFaculties(data) {
    return new Promise((next) => {
      authLAxios
        .get("/faculty", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // loadSimpleFaculties(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/simpleFaculty", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadSimpleFaculties(data) {
    return new Promise((next) => {
      authLAxios
        .get("/simpleFaculty", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // facultyWiseCourse(facultyId) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/allCourse/faculty/${facultyId}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  facultyWiseCourse(facultyId) {
    return new Promise((next) => {
      authLAxios
        .get(`/allCourse/faculty/${facultyId}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  //endregion

  // region Levels

  // loadLevels(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/levels", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadLevels(data) {
    return new Promise((next) => {
      authLAxios
        .get("/levels", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // loadSimpleLevels(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/loadSimpleLevels", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadSimpleLevels(data) {
    return new Promise((next) => {
      authLAxios
        .get("/loadSimpleLevels", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // addLevel(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/levels`, data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  addLevel(data) {
    return new Promise((next) => {
      authLAxios
        .post(`/levels`, data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // deleteLevel(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .delete(`/level/${data._id}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  deleteLevel(data) {
    return new Promise((next) => {
      authLAxios
        .delete(`/level/${data._id}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // updateLevel(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put(`/levels`, data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  updateLevel(data) {
    return new Promise((next) => {
      authLAxios
        .put(`/levels`, data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getLevel(partId) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/level/${partId}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getLevel(partId) {
    return new Promise((next) => {
      authLAxios
        .get(`/level/${partId}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  //endregion

  // region Branch

  // changeStudentBranch(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/changeStudentBranch", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  changeStudentBranch(data) {
    return new Promise((next) => {
      authLAxios
        .post("/changeStudentBranch", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // Start Branch Cruds
  // addBranch(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/branch", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  addBranch(data) {
    return new Promise((next) => {
      authLAxios
        .post("/branch", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // addSubAgent(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/subAgent", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  addSubAgent(data) {
    return new Promise((next) => {
      authLAxios
        .post("/subAgent", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // deleteBranch(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .delete(`/branch/${data}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  deleteBranch(data) {
    return new Promise((next) => {
      authLAxios
        .delete(`/branch/${data}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // deleteBranchUsers(data) {
  //   return new Promise((next) => {
  //     authAxios.post('/deleteBranchUsers', data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  deleteBranchUsers(data) {
    return new Promise((next) => {
      authLAxios.post('/deleteBranchUsers', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // updateBranch(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put("/branch", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  updateBranch(data) {
    return new Promise((next) => {
      authLAxios
        .put("/branch", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // updateSubAgent(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put("/subAgent", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  updateSubAgent(data) {
    return new Promise((next) => {
      authLAxios
        .put("/subAgent", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // loadBranch(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/branch", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadBranch(data) {
    return new Promise((next) => {
      authLAxios
        .get("/branch", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // getBranch(partId) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/branch/${partId}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getBranch(partId) {
    return new Promise((next) => {
      authLAxios
        .get(`/branch/${partId}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // getSubAgent(partId) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/subAgent/${partId}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getSubAgent(partId) {
    return new Promise((next) => {
      authLAxios
        .get(`/subAgent/${partId}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getAllSimpleBranch(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/getAllSimpleBranch", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getAllSimpleBranch(data) {
    return new Promise((next) => {
      authLAxios
        .get("/getAllSimpleBranch", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // loadSimpleBranch(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/getSimpleBranch", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadSimpleBranch(data) {
    return new Promise((next) => {
      authLAxios
        .get("/getSimpleBranch", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // listSimpleBranch(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/branch/simple/List", getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  listSimpleBranch(data) {
    return new Promise((next) => {
      authLAxios
        .get("/branch/simple/List", getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  changeBranchStatus(data) {
    return new Promise((next) => {
      authLAxios
        .post("/branch/branchStatus", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // changeBranchRightTOViewChannelPartner(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/branch/branchViewChannelPartner", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  changeBranchRightTOViewChannelPartner(data) {
    return new Promise((next) => {
      authLAxios
        .post("/branch/branchViewChannelPartner", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // changeBranchRightTOShowStaffToOtherBranch(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(
  //         "/branch/changeBranchRightTOShowStaffToOtherBranch",
  //         data,
  //         getToken()
  //       )
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  changeBranchRightTOShowStaffToOtherBranch(data) {
    return new Promise((next) => {
      authLAxios
        .post(
          "/branch/changeBranchRightTOShowStaffToOtherBranch",
          data,
          getToken()
        )
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // End Branch

  // Start Boards
  // addBoard(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/boards", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  addBoard(data) {
    return new Promise((next) => {
      authLAxios
        .post("/boards", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // deleteBoard(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .delete(`/boards/${data}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  deleteBoard(data) {
    return new Promise((next) => {
      authLAxios
        .delete(`/boards/${data}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // updateBoard(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put("/boards", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  updateBoard(data) {
    return new Promise((next) => {
      authLAxios
        .put("/boards", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // loadBoards(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/boards", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadBoards(data) {
    return new Promise((next) => {
      authLAxios
        .get("/boards", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // getBoard(partId) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/board/${partId}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getBoard(partId) {
    return new Promise((next) => {
      authLAxios
        .get(`/board/${partId}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // End Boards

  // Start restrictedLocation
  // addRestrictedLocation(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/restrictedLocations", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  addRestrictedLocation(data) {
    return new Promise((next) => {
      authLAxios
        .post("/restrictedLocations", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // deleteRestrictedLocation(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .delete(`/restrictedLocations/${data}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  deleteRestrictedLocation(data) {
    return new Promise((next) => {
      authLAxios
        .delete(`/restrictedLocations/${data}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // updateRestrictedLocation(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put("/restrictedLocations", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  updateRestrictedLocation(data) {
    return new Promise((next) => {
      authLAxios
        .put("/restrictedLocations", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // loadRestrictedLocations(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/restrictedLocations", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadRestrictedLocations(data) {
    return new Promise((next) => {
      authLAxios
        .get("/restrictedLocations", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // getRestrictedLocation(partId) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/restrictedLocation/${partId}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getRestrictedLocation(partId) {
    return new Promise((next) => {
      authLAxios
        .get(`/restrictedLocation/${partId}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // End restrictedLocation

  // Start restrictedUniversity
  // addRestrictedUniversity(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/restrictedUniversities", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  addRestrictedUniversity(data) {
    return new Promise((next) => {
      authLAxios
        .post("/restrictedUniversities", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // deleteRestrictedUniversity(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .delete(`/restrictedUniversities/${data}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  deleteRestrictedUniversity(data) {
    return new Promise((next) => {
      authLAxios
        .delete(`/restrictedUniversities/${data}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // updateRestrictedUniversity(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put("/restrictedUniversities", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  updateRestrictedUniversity(data) {
    return new Promise((next) => {
      authLAxios
        .put("/restrictedUniversities", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // loadRestrictedUniversities(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/restrictedUniversities", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadRestrictedUniversities(data) {
    return new Promise((next) => {
      authLAxios
        .get("/restrictedUniversities", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // getRestrictedUniversity(partId) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/restrictedUniversity/${partId}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getRestrictedUniversity(partId) {
    return new Promise((next) => {
      authLAxios
        .get(`/restrictedUniversity/${partId}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // End restrictedUniversity

  //endregion

  //region Student
  // checkDuplicateLead(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/inquiry/checkDuplicate", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  // changeAssociativePartner(data) {
  //   return new Promise((next) => {
  //     authAxios.post("/changeAssociativePartner", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  changeAssociativePartner(data) {
    return new Promise((next) => {
      authLAxios.post("/changeAssociativePartner", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // changeChannelPartner(data) {
  //   return new Promise((next) => {
  //     authAxios.post('/changeChannelPartner', data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  changeChannelPartner(data) {
    return new Promise((next) => {
      authLAxios.post('/changeChannelPartner', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  removeChannelPartner(data) {
    return new Promise((next) => {
      authLAxios.post('/removeChannelPartner', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // sendOTPOnMobile(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/sendInquiryOtp", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  sendOTPOnMobile(data) {
    return new Promise((next) => {
      authLAxios
        .post("/sendInquiryOtp", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // sendVisitorOtpOnMobile(data) {
  //   return new Promise((next) => {
  //     authAxios.post("/sendVisitorOtp", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   })
  // }
  sendVisitorOtpOnMobile(data) {
    return new Promise((next) => {
      authLAxios.post("/sendVisitorOtp", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }
  // verifyOTP(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/verifyOTP", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  verifyOTP(data) {
    return new Promise((next) => {
      authLAxios
        .post("/verifyOTP", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // addInquiry(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/inquiry", data, {
  //         headers: {
  //           authorization: "Bearer " + localStorage.getItem("token"),
  //           Accept: "application/json",
  //           "Content-Type": "multipart/form-data",
  //         },
  //       })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  addInquiry(data) {
    return new Promise((next) => {
      authLAxios
        .post("/inquiry", data, {
          headers: {
            authorization: "Bearer " + localStorage.getItem("token"),
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
        })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  addBasicInquiryV2(data) {
    return new Promise((next) => {
      authLAxios
        .post("/inquiry/v2/basic", data, {
          headers: {
            authorization: "Bearer " + localStorage.getItem("token"),
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
        })
        .then((d) => next(d.data))
        .catch((err) => this.error(err));
    });
  }

  getInquiryV2(id) {
    return new Promise((next) => {
      authLAxios
        .get(`/inquiry/v2/${id}`, {
          headers: { authorization: "Bearer " + localStorage.getItem("token") },
        })
        .then((d) => next(d.data))
        .catch((err) => this.error(err));
    });
  }

  updateInquiryV2(id, data) {
    return new Promise((next) => {
      authLAxios
        .post(`/inquiry/v2/${id}`, data, {
          headers: {
            authorization: "Bearer " + localStorage.getItem("token"),
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
        })
        .then((d) => next(d.data))
        .catch((err) => this.error(err));
    });
  }


  // fetchDroppedInquiries(data) {
  //   return new Promise((next) => {
  //     authAxios.get("/fetchDroppedLeads", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  fetchDroppedInquiries(data) {
    return new Promise((next) => {
      authLAxios.get("/fetchDroppedLeads", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getDroppedLeads(data) {
  //   return new Promise((next) => {
  //     authAxios.get("/droppedLeadsData", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  getDroppedLeads(data) {
    return new Promise((next) => {
      authLAxios.get("/droppedLeadsData", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  getDroppedLeadsList(data) {
    return new Promise((next) => {
      authLAxios.get('/droppedLeadsList', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }


  updateDroppedLeadStatus(data) {
    return new Promise((next) => {
      authLAxios.post('/updateDroppedLeadStatus', data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  // getMyStudentList(data) {
  //   return new Promise((next) => {
  //     authAxios.get('/myStudentList', { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   })
  // }
  getMyStudentList(data) {
    return new Promise((next) => {
      authLAxios.get('/myStudentList', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  // getListOfStudents(data) {
  //   return new Promise((next) => {
  //     authAxios.get('/getListOfStudents', { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   })
  // }

  // verifyStudentEntry(data) {
  //   return new Promise((next) => {
  //     authAxios.post('/verifyStudentEntry', data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   })
  // }
  verifyStudentEntry(data) {
    return new Promise((next) => {
      authLAxios.post('/verifyStudentEntry', data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  // restoreWithDrawRequest(data) {
  //   return new Promise((next) => {
  //     authAxios.post('/restoreWithDrawRequest', data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   })
  // }
  restoreWithDrawRequest(data) {
    return new Promise((next) => {
      authLAxios.post('/restoreWithDrawRequest', data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  // getAllStudentList(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/studentList", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getAllStudentList(data) {
    return new Promise((next) => {
      authLAxios
        .get("/studentList", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getAllSearchStudent(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/searchStudent", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getAllSearchStudent(data) {
    return new Promise((next) => {
      authLAxios
        .get("/searchStudent", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getAllStudentListForUplaodingDocuments(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/studentListForUploadingDocuments", {
  //         params: { ...data },
  //         ...getToken(),
  //       })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getAllStudentListForUplaodingDocuments(data) {
    return new Promise((next) => {
      authLAxios
        .get("/studentListForUploadingDocuments", {
          params: { ...data },
          ...getToken(),
        })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  //endregion

  //region followUp

  // moveEnquiryToDead(data) {
  //   return new Promise((next) => {
  //     authAxios.post("/moveVisitorToDead", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  moveEnquiryToDead(data) {
    return new Promise((next) => {
      authLAxios.post("/moveVisitorToDead", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  moveEnquiryToParked(data) {
    return new Promise((next) => {
      authLAxios.post('/moveVisitorToParked', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // recoverVisaEnquiry(data) {
  //   return new Promise((next) => {
  //     authAxios.post("/recoverVisitorVisaLead", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  recoverVisaEnquiry(data) {
    return new Promise((next) => {
      authLAxios.post("/recoverVisitorVisaLead", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // loadVisitorVisaFollowUps(_id) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/inquiry/visitorVisa/${_id}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  loadVisitorVisaFollowUps(_id) {
    return new Promise((next) => {
      authLAxios
        .get(`/inquiry/visitorVisa/${_id}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // loadStudentFollowUps(_id) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/inquiry/allFollowUp/${_id}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadStudentFollowUps(_id) {
    return new Promise((next) => {
      authLAxios
        .get(`/inquiry/allFollowUp/${_id}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // loadUserFollowUps(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/user/followUp/list`, { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadUserFollowUps(data) {
    return new Promise((next) => {
      authLAxios
        .get(`/user/followUp/list`, { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // rawInquiryFollowUps(data) {
  //   return new Promise((next) => {
  //     authAxios.get('/rawInquiry/followUp/list', { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   })
  // }
  rawInquiryFollowUps(data) {
    return new Promise((next) => {
      authLAxios.get('/rawInquiry/followUp/list', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  // getVisitorVisaFollowUps(data) {
  //   return new Promise((next) => {
  //     authAxios.get('/visitor/followUp/list', { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   })
  // }


  getVisitorVisaFollowUps(data) {
    return new Promise((next) => {
      authLAxios.get('/visitor/followUp/list', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }
  // loadUserAssignedLeads(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/user/assign/leads`, { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadUserAssignedLeads(data) {
    return new Promise((next) => {
      authLAxios
        .get(`/user/assign/leads`, { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // loadUserFollowUpsCount(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/user/followUp/list/count`, {
  //         params: { ...data },
  //         ...getToken(),
  //       })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadUserFollowUpsCount(data) {
    return new Promise((next) => {
      authLAxios
        .get(`/user/followUp/list/count`, {
          params: { ...data },
          ...getToken(),
        })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // loadFollowUpsWithCount(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/followUps/count`, { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  // addFollowUp(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/followUp", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  addFollowUp(data) {
    return new Promise((next) => {
      authLAxios
        .post("/followUp", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  addMultipleFollowUps(data) {
    return new Promise((next) => {
      authLAxios.post('/addMultipleFollowUps', data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  // loadStudentPaymentFollowUps(_id) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/loadStudentPaymentFollowUps/${_id}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadStudentPaymentFollowUps(_id) {
    return new Promise((next) => {
      authLAxios
        .get(`/loadStudentPaymentFollowUps/${_id}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // addPaymentFollowUp(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/addPaymentFollowUp", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  addPaymentFollowUp(data) {
    return new Promise((next) => {
      authLAxios
        .post("/addPaymentFollowUp", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // loadRawInquiryFollowUps(_id) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/get/rawInquiry/followUp/${_id}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadRawInquiryFollowUps(_id) {
    return new Promise((next) => {
      authLAxios
        .get(`/get/rawInquiry/followUp/${_id}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // loadUniversityFollowUps(_id) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/get/university/followUp/${_id}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadUniversityFollowUps(_id) {
    return new Promise((next) => {
      authLAxios
        .get(`/get/university/followUp/${_id}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getNotAddedCommissionUniversity(data) {
  //   return new Promise((next) => {
  //     authAxios.get("/getNotAddedCommissionUniversity", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getNotAddedCommissionUniversity(data) {
    return new Promise((next) => {
      authLAxios.get("/getNotAddedCommissionUniversity", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // exportNotAddedCommissionUniversities(data) {
  //   return new Promise((next) => {
  //     authAxios.get("/exportNotAddedCommissionUniversities", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  exportNotAddedCommissionUniversities(data) {
    return new Promise((next) => {
      authLAxios.get("/exportNotAddedCommissionUniversities", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // addRawInquiryFollowUp(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/save/rawInquiry/followUp", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  addRawInquiryFollowUp(data) {
    return new Promise((next) => {
      authLAxios
        .post("/save/rawInquiry/followUp", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // addUniversityFollowUp(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/save/university/followUp", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  addUniversityFollowUp(data) {
    return new Promise((next) => {
      authLAxios
        .post("/save/university/followUp", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // addVisaFollowUp(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/visaFollowUp", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  addVisaFollowUp(data) {
    return new Promise((next) => {
      authLAxios
        .post("/visaFollowUp", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getGoogleSpreadsheetData(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/getGoogleSpreadsheetData", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getGoogleSpreadsheetData(data) {
    return new Promise((next) => {
      authLAxios
        .post("/getGoogleSpreadsheetData", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getEmployeeDetailsFromSheet(data) {
  //   return new Promise((next) => {
  //     authAxios.post("/getEmployeeDetailsFromSheet", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getEmployeeDetailsFromSheet(data) {
    return new Promise((next) => {
      authLAxios.post("/getEmployeeDetailsFromSheet", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // setGoogleSpreadsheetData(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/setGoogleSpreadsheetData", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  setGoogleSpreadsheetData(data) {
    return new Promise((next) => {
      authLAxios
        .post("/setGoogleSpreadsheetData", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // setEmployeeDetailsFromSheet(data) {
  //   return new Promise((next) => {
  //     authAxios.post("/setEmployeeDetailsFromSheet", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  setEmployeeDetailsFromSheet(data) {
    return new Promise((next) => {
      authLAxios.post("/setEmployeeDetailsFromSheet", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // Get All Facebook Campaigns
  // getFacebookCampaigns() {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/getAllFacebookCampaigns", getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getFacebookCampaigns() {
    return new Promise((next) => {
      authLAxios
        .get("/getAllFacebookCampaigns", getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // Get All Facebook Adsets
  // getFacebookAdSets(campaignId) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/getAllFacebookAdSets", { params: campaignId, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getFacebookAdSets(campaignId) {
    return new Promise((next) => {
      authLAxios
        .get("/getAllFacebookAdSets", { params: { campaignId }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // Get All Ads
  // getAllAds(adSetId) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/getAllFacebookAds", { params: adSetId, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });getAllLeads
  //   });
  // }
  getAllAds(adSetId) {
    return new Promise((next) => {
      authLAxios
        .get("/getAllFacebookAds", { params: { adSetId }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // Get All Leads
  // getAllLeads(adId) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/getAllLeads", { params: adId, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getAllLeads(adId) {
    return new Promise((next) => {
      authLAxios
        .get("/getAllLeads", { params: { adId }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // Set facebook leads
  // setFacebookLeadsData(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/setFacebookLeads", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  setFacebookLeadsData(data) {
    return new Promise((next) => {
      authLAxios
        .post("/setFacebookLeads", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // addCounsellingfollowUp(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/addCounsellingfollowUp", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  addCounsellingfollowUp(data) {
    return new Promise((next) => {
      authLAxios
        .post("/addCounsellingfollowUp", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  //end region

  // region Counselling

  // getCounsellorsUsers(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/getCounsellorsUsers", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getCounsellorsUsers(data) {
    return new Promise((next) => {
      authLAxios
        .get("/getCounsellorsUsers", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // loadCounselling(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/counsellingDesk", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadCounselling(data) {
    return new Promise((next) => {
      authLAxios
        .get("/counsellingDesk", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  getClaimDeskStats(data) {
    return new Promise((next) => {
      authLAxios
        .get("/counsellingDesk/stats", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // updateInvoiceStatus(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/updateInvoiceStatus", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  //endregion

  //region Application
  // updateApplicationDeskCourse(data) {
  //   return new Promise((next) => {
  //     authAxios.post("/inquiry/application/updateApplicationCourse", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   })
  // }

  updateApplicationDeskCourse(data) {
    return new Promise((next) => {
      authLAxios.post("/inquiry/application/updateApplicationCourse", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }
  // addApplicationIntake(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/inquiry/application/saveIntake", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  addApplicationIntake(data) {
    return new Promise((next) => {
      authLAxios
        .post("/inquiry/application/saveIntake", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // saveApplicationStatus(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/inquiry/application/saveStatus", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  saveApplicationStatus(data) {
    return new Promise((next) => {
      authLAxios
        .post("/inquiry/application/saveStatus", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  changeOfAgentInAdmission(data) {
    return new Promise((next) => {
      authAxios.post("/inquiry/application/changeAgent", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getUniversityContacts(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/University/contactByCourse", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getUniversityContacts(data) {
    return new Promise((next) => {
      authLAxios
        .post("/University/contactByCourse", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getUniversityMailTemplate(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/University/mailTemplate", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getUniversityMailTemplate(data) {
    return new Promise((next) => {
      authLAxios
        .post("/University/mailTemplate", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // saveApplicationMail(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/inquiry/application/saveApplicationMail", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  saveApplicationMail(data) {
    return new Promise((next) => {
      authLAxios
        .post("/inquiry/application/saveApplicationMail", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // studentApplicationDone(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/inquiry/application/applicationDone", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  // removeApplicationCourse(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/inquiry/application/removeCourse", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  removeApplicationCourse(data) {
    return new Promise((next) => {
      authLAxios
        .post("/inquiry/application/removeCourse", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // updateApplicationOfferExpectedDate(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/inquiry/application/updateApplicationExpDate", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  updateApplicationOfferExpectedDate(data) {
    return new Promise((next) => {
      authLAxios
        .post("/inquiry/application/updateApplicationExpDate", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  //endregion

  //region User

  addUser(data) {
    return new Promise((next) => {
      authLAxios
        .post("/user", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }


  addMultiUsers(data) {
    return new Promise((next) => {
      authLAxios.post('/addMultiUser', data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  // getUserById(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/user/" + data.id, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  getUserById(data) {
    return new Promise((next) => {
      authLAxios
        .get("/user/" + data.id, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // updateUser(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put(`/updateUser`, data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  updateUser(data) {
    return new Promise((next) => {
      authLAxios
        .put(`/updateUser`, data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  /*deleteUser (data) {
  return new Promise((next, error) => {
    authAxios
  .delete('/user/' + data._id, getToken())
  .then(d => {
    next(d.data)
  })
  .catch(err => {
    error(err)
  this.error(err)
  })
  })
  }*/

  // changeUserPassword(data) {
  //   return new Promise((next, error) => {
  //     authAxios
  //       .post("/changeUserPassword", { ...data }, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  changeUserPassword(data) {
    return new Promise((next, error) => {
      authLAxios
        .post("/changeUserPassword", { ...data }, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }


  // loadRights(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/rights", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadRights(data) {
    return new Promise((next) => {
      authLAxios
        .get("/rights", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // loadGroupedRights(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/groupedRights", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadGroupedRights(data) {
    return new Promise((next) => {
      authLAxios
        .get("/groupedRights", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // loadStudentCommunicationHistory(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/communication-history", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadStudentCommunicationHistory(data) {
    return new Promise((next) => {
      authLAxios
        .get("/communication-history", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // loadStudentActivities(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/activity", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadStudentActivities(data) {
    return new Promise((next) => {
      authLAxios
        .get("/activity", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // loadStudentMovedReasons(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/studentMovedReasonNotes", { params: { data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadStudentMovedReasons(data) {
    return new Promise((next) => {
      authLAxios
        .get("/studentMovedReasonNotes", { params: { data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // loadAllSms(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/allSms", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadAllSms(data) {
    return new Promise((next) => {
      authLAxios
        .get("/allSms", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // loadAllEmails(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/allEmails", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadAllEmails(data) {
    return new Promise((next) => {
      authLAxios
        .get("/allEmails", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // loadUser(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/user", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadUser(data) {
    return new Promise((next) => {
      authLAxios
        .get("/user", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  loadEmployeeMasterData(data) {
    return new Promise((next) => {
      authLAxios.post('/loadEmployeeMasterData', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  // loadEmployeeUser(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/loadEmployeeUser", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadEmployeeUser(data) {
    return new Promise((next) => {
      authLAxios
        .get("/loadEmployeeUser", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // loadDeskUser(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/loadDeskUser", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadDeskUser(data) {
    return new Promise((next) => {
      authLAxios
        .get("/loadDeskUser", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // loadUserBranchWise(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/userBranchWise", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadUserBranchWise(data) {
    return new Promise((next) => {
      authLAxios
        .get("/userBranchWise", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // loadGroups(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/userGroup", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadGroups(data) {
    return new Promise((next) => {
      authLAxios
        .get("/userGroup", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getCountryWithUniversities(data) {
  //   return new Promise((next) => {
  //     authAxios.post('/getCountryWithUniversities', data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   })
  // }
  getCountryWithUniversities(data) {
    return new Promise((next) => {
      authLAxios.post('/getCountryWithUniversities', data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  // printCountryDetails(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/printCountry`, data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  printCountryDetails(data) {
    return new Promise((next) => {
      authLAxios
        .post(`/printCountry`, data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // printUniversityDetails(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/printUniversity`, data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  printUniversityDetails(data) {
    return new Promise((next) => {
      authLAxios
        .post(`/printUniversity`, data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  //endregion

  //region Templates
  // addTemplate(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/templates", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  addTemplate(data) {
    return new Promise((next) => {
      authLAxios
        .post("/templates", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // updateTemplate(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put("/templates", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  updateTemplate(data) {
    return new Promise((next) => {
      authLAxios
        .put("/templates", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getTemplateById(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/email/" + data.id, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  getTemplateById(data) {
    return new Promise((next) => {
      authLAxios
        .get("/template/" + data.id, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // loadTemplates(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/templates", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadTemplates(data) {
    return new Promise((next) => {
      authLAxios
        .get("/templates", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // deleteTemplate(data) {
  //   return new Promise((next, error) => {
  //     authAxios
  //       .delete("/email/" + data._id, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  deleteTemplate(data) {
    return new Promise((next, error) => {
      authLAxios
        .delete("/template/" + data._id, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // addCounselling(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/inquiry/add/counselingDetails`, data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  addCounselling(data) {
    return new Promise((next) => {
      authLAxios
        .post(`/inquiry/add/counselingDetails`, data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getInquiry(inquiryId) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/inquiry/${inquiryId}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  getInquiry(inquiryId) {
    return new Promise((next) => {
      authLAxios
        .get(`/inquiry/${inquiryId}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  getInquiryVerificationDetails(data) {
    return new Promise((next) => {
      authLAxios.get('/getInquiryVerificationDetails', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  addRegistration(data) {
    return new Promise((next) => {
      authLAxios
        .put("/inquiry/registrationPayments/registration", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // addRegistration(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put("/inquiry/registrationPayments/registration", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  // addFamilyAndFinance(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put("/inquiry/add/fullDetails", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  addFamilyAndFinance(data) {
    return new Promise((next) => {
      authLAxios
        .post("/inquiry/add/fullDetails", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // addTask(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/tasks", { ...data }, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  addTask(data) {
    return new Promise((next) => {
      authLAxios
        .post("/tasks", { ...data }, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // saveNote(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/saveNote", { ...data }, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  saveNote(data) {
    return new Promise((next) => {
      authLAxios
        .post("/saveNote", { ...data }, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // saveMoreAaaignee(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/saveMoreAaaignee", { ...data }, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  saveMoreAaaignee(data) {
    return new Promise((next) => {
      authLAxios
        .post("/saveMoreAaaignee", { ...data }, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // deleteTask(data) {
  //   return new Promise((next, error) => {
  //     authAxios
  //       .delete("/task/" + data._id, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         error(err);
  //         this.error(err);
  //       });
  //   });
  // }
  deleteTask(data) {
    return new Promise((next, error) => {
      authLAxios
        .delete("/task/" + data._id, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          error(err);
          this.error(err);
        });
    });
  }

  // getSingleTask(data) {
  //   return new Promise((next, error) => {
  //     authAxios
  //       .get("/getSingleTask/" + data._id, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         error(err);
  //         this.error(err);
  //       });
  //   });
  // }
  getSingleTask(data) {
    return new Promise((next, error) => {
      authLAxios
        .get("/getSingleTask/" + data._id, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          error(err);
          this.error(err);
        });
    });
  }

  // getAllTasksAssignByUser(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/taskAssignedByUser", data, getToken())
  //       .then((d) => {
  //         next(d);
  //       })
  //       .catch((err) => { });
  //   });
  // }
  getAllTasksAssignByUser(data) {
    return new Promise((next) => {
      authLAxios
        .post("/taskAssignedByUser", data, getToken())
        .then((d) => {
          next(d);
        })
        .catch((err) => { });
    });
  }

  // getAllTasksAssignByUser2(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/taskAssignedByUser2", data, getToken())
  //       .then((d) => {
  //         next(d);
  //       })
  //       .catch((err) => { });
  //   });
  // }
  getAllTasksAssignByUser2(data) {
    return new Promise((next) => {
      authLAxios
        .post("/taskAssignedByUser2", data, getToken())
        .then((d) => {
          next(d);
        })
        .catch((err) => { });
    });
  }

  // getAllCompleteTasks(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/task/completeTask", data, getToken())
  //       .then((d) => {
  //         next(d);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getAllCompleteTasks(data) {
    return new Promise((next) => {
      authLAxios
        .post("/task/completeTask", data, getToken())
        .then((d) => {
          next(d);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getAllTasksAssignToUser(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/taskAssignedToUser", data, getToken())
  //       .then((d) => {
  //         next(d);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getAllTasksAssignToUser(data) {
    return new Promise((next) => {
      authLAxios
        .post("/taskAssignedToUser", data, getToken())
        .then((d) => {
          next(d);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getAllTaskListAssignToUser(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/taskListAssignedToUser", data, getToken())
  //       .then((d) => {
  //         next(d);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getAllTaskListAssignToUser(data) {
    return new Promise((next) => {
      authLAxios
        .post("/taskListAssignedToUser", data, getToken())
        .then((d) => {
          next(d);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }


  // getAllTasksList(data) {
  //   return new Promise((next) => {
  //     authAxios.post("/getAllTasksList", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  getAllTasksList(data) {
    return new Promise((next) => {
      authLAxios.post("/getAllTasksList", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }
  // getAllAssignedTrainings(data) {
  //   return new Promise((next) => {
  //     authAxios.post("/trainingAssignedToUser", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getAllAssignedTrainings(data) {
    return new Promise((next) => {
      authLAxios.post("/trainingAssignedToUser", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // changeStatus(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put("/updateStatus", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  changeStatus(data) {
    return new Promise((next) => {
      authLAxios
        .put("/updateStatus", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // taskFullStatus(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put("/taskFullStatus", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  taskFullStatus(data) {
    return new Promise((next) => {
      authLAxios
        .put("/taskFullStatus", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // updatePostponDate(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put("/updatePostponDate", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  updatePostponDate(data) {
    return new Promise((next) => {
      authLAxios
        .put("/updatePostponDate", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // reopenTask(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put("/reopenTask", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  reopenTask(data) {
    return new Promise((next) => {
      authLAxios
        .put("/reopenTask", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  //endregion

  // addRights(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/rights`, data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  addRights(data) {
    return new Promise((next) => {
      authLAxios
        .post(`/rights`, data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // giveRightsToAll(data) {
  //   return new Promise((next) => {
  //     authAxios.post('/giveRightsToAll', data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       })
  //   })
  // }
  giveRightsToAll(data) {
    return new Promise((next) => {
      authLAxios.post('/giveRightsToAll', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err);
        })
    })
  }

  /*  getAllRights(data) {
   
  return new Promise((next) => {
    authAxios
  .get('/rights', { params: { ...data } })
  .then((d) => {
    next(d.data)
  })
  .catch((err) => {
    
  this.error(err)
  })
   
  })
  }*/

  // updateRight(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put("/rights", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  updateRight(data) {
    return new Promise((next) => {
      authLAxios
        .put("/rights", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getRightById(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/rights/" + data._id, {}, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getRightById(data) {
    return new Promise((next) => {
      authLAxios
        .get("/rights/" + data._id, {}, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // addUserGroup(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/userGroup`, data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  addUserGroup(data) {
    return new Promise((next) => {
      authLAxios
        .post(`/userGroup`, data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getAllGroups(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/userGroup", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getAllGroups(data) {
    return new Promise((next) => {
      authLAxios
        .get("/userGroup", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // loadAllAllowedRights(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/loadAllAllowedRights", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadAllAllowedRights(data) {
    return new Promise((next) => {
      authLAxios
        .get("/loadAllAllowedRights", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getUserGroupById(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/userGroup/" + data._id, {}, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getUserGroupById(data) {
    return new Promise((next) => {
      authLAxios
        .get("/userGroup/" + data._id, {}, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // deleteUserGroup(data) {
  //   return new Promise((next, error) => {
  //     authAxios
  //       .delete("/userGroup/" + data._id, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  deleteUserGroup(data) {
    return new Promise((next, error) => {
      authLAxios
        .delete("/userGroup/" + data._id, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // replicaUserGroup(data) {
  //   return new Promise((next, error) => {
  //     authAxios
  //       .post("/replicaUserGroup", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  replicaUserGroup(data) {
    return new Promise((next, error) => {
      authLAxios
        .post("/replicaUserGroup", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // updateUserGroup(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put("/userGroup", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  updateUserGroup(data) {
    return new Promise((next) => {
      authLAxios
        .put("/userGroup", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // approveUser(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/user/approve", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  approveUser(data) {
    return new Promise((next) => {
      authLAxios
        .post("/user/approve", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // changeUserCounsellor(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/user/changeCounsellor", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  changeUserCounsellor(data) {
    return new Promise((next) => {
      authLAxios
        .post("/user/changeCounsellor", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // assignUserTelecaller(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/user/assignTelecaller", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  assignUserTelecaller(data) {
    return new Promise((next) => {
      authLAxios
        .post("/user/assignTelecaller", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // changeLoginByOTPOnly(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/user/changeLoginByOTPOnly", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  changeLoginByOTPOnly(data) {
    return new Promise((next) => {
      authLAxios
        .post("/user/changeLoginByOTPOnly", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // changeVerifyIPOnly(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/user/changeVerifyIPOnly", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  changeVerifyIPOnly(data) {
    return new Promise((next) => {
      authLAxios
        .post("/user/changeVerifyIPOnly", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // changeEditedByUser(data) {
  //   return new Promise((next) => {
  //     authAxios.post('/user/changeEditedByUser', data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  changeEditedByUser(data) {
    return new Promise((next) => {
      authLAxios.post('/user/changeEditedByUser', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // changeIsOperationManager(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/user/changeIsOperationManager", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  changeIsOperationManager(data) {
    return new Promise((next) => {
      authLAxios
        .post("/user/changeIsOperationManager", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // movedToRegistrationDesk(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put("/student/moveToRegistrationDesk", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  movedToRegistrationDesk(data) {
    return new Promise((next) => {
      authLAxios
        .put("/student/moveToRegistrationDesk", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // movedToVisaDesk(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put("/student/movedToVisaDesk", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  movedToVisaDesk(data) {
    return new Promise((next) => {
      authLAxios
        .put("/student/movedToVisaDesk", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // changeAggreementSignedStatus(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/student/aggrementSignedStatus", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  changeAggreementSignedStatus(data) {
    return new Promise((next) => {
      authLAxios
        .post("/student/aggrementSignedStatus", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // movedToApplicationDesk(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put("/student/movedToApplicationDesk", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  movedToApplicationDesk(data) {
    return new Promise((next) => {
      authLAxios
        .put("/student/movedToApplicationDesk", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // movedToClaimDesk(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put("/student/movedToClaimDesk", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  movedToClaimDesk(data) {
    return new Promise((next) => {
      authLAxios
        .put("/student/movedToClaimDesk", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // updateInquiry(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put(`/inquiry/${data._id}`, data.valData, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  updateInquiry(data) {
    return new Promise((next) => {
      authLAxios
        .put(`/inquiry/${data._id}`, data.valData, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // updateInquiryTab1(data, inquiryId) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put(`/inquiry_updateTab1/${inquiryId}`, data, {
  //         headers: {
  //           authorization: "Bearer " + localStorage.getItem("token"),
  //           Accept: "application/json",
  //           "Content-Type": "multipart/form-data",
  //         },
  //       })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  updateInquiryTab1(data, inquiryId) {
    return new Promise((next) => {
      authLAxios
        .post(`/inquiry_updateTab1/${inquiryId}`, data, {
          headers: {
            authorization: "Bearer " + localStorage.getItem("token"),
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
        })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }



  // updateInquiryPassportDetails(data, inquiryId) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`inquiry_passport_details/${inquiryId}`, data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  updateInquiryPassportDetails(data, inquiryId) {
    return new Promise((next) => {
      authLAxios
        .post(`inquiry_passport_details/${inquiryId}`, data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // changeDesk(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/inquiry/changeDesk`, { ...data }, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  changeDesk(data) {
    return new Promise((next) => {
      authLAxios
        .post(`/inquiry/changeDesk`, { ...data }, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // deleteStudent(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/inquiry/deleteStudent`, { ...data }, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  deleteStudent(data) {
    return new Promise((next) => {
      authLAxios
        .post(`/inquiry/deleteStudent`, { ...data }, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // addContactDetails(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/contactDetails", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  addContactDetails(data) {
    return new Promise((next) => {
      authLAxios
        .post("/contactDetails", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // loadContactDetails(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/contactDetails", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadContactDetails(data) {
    return new Promise((next) => {
      authLAxios
        .get("/contactDetails", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // contactDetailsById(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/contactDetails/" + data._id, {}, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  contactDetailsById(data) {
    return new Promise((next) => {
      authLAxios
        .get("/contactDetails/" + data._id, {}, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // updateContactDetails(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put(`/contactDetails/${data._id}`, data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  updateContactDetails(data) {
    return new Promise((next) => {
      authLAxios
        .put(`/contactDetails/${data._id}`, data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // deleteContactDetails(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .delete("/contactDetails/" + data._id, {}, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  deleteContactDetails(data) {
    return new Promise((next) => {
      authLAxios
        .delete("/contactDetails/" + data._id, {}, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // addCourierDetails(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/inquiry/add/courierDetails", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  addCourierDetails(data) {
    return new Promise((next) => {
      authLAxios
        .post("/inquiry/add/courierDetails", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  fundRequirementApi(data) {
    const courseIdString = data.courseId.$oid != undefined ? data.courseId.$oid : data.courseId;

    let linkValue = "";
    if (data.pathwayId) {
      linkValue =
        MEDIA_URL +
        `fundRequirement?_id=${data._id}&pathway_Id=${data.pathwayId
        }&course_Id=${courseIdString}`;
    } else {
      linkValue =
        MEDIA_URL + `fundRequirement?_id=${data._id}&course_Id=${courseIdString}`;
    }
    window.open(linkValue, "_blank");
  }

  courseFactSheetApit(courseId) {
    const courseIdString = courseId.$oid != undefined ? courseId.$oid : courseId;
    let linkValue = MEDIA_URL + `courseFactSheet/${courseIdString}`;
    window.open(linkValue, "_blank");
  }

  sendCourseFactSheetLink(data) {
    const courseIdString = data.courseId.$oid != undefined ? data.courseId.$oid : data.courseId;
    let linkValue = MEDIA_URL + `sendCourseFactSheetLink/${data.studentId}/${courseIdString}`;
    window.open(linkValue, "_blank");
  }

  downloadCourseFactSheet(data) {
    const courseIdString = data.courseId.$oid != undefined ? data.courseId.$oid : data.courseId;
    let linkValue = MEDIA_URL + `printCourse/${courseIdString}`;
    window.open(linkValue, "_blank");
  }

  // changeCourseStatus(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/course/changeStatus", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  changeCourseStatus(data) {
    return new Promise((next) => {
      authLAxios
        .post("/course/changeStatus", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getTemplatesForCommunication(type) {
  //   return new Promise((next, error) => {
  //     authAxios
  //       .post("/getTemplateByType", { type: type }, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getTemplatesForCommunication(type) {
    return new Promise((next, error) => {
      authLAxios
        .post("/getTemplateByType", { type: type }, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getWhatsappTemplates(type) {
  //   return new Promise((next, error) => {
  //     authAxios
  //       .post("/getWhatsappTemplates", { type: type }, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getWhatsappTemplates(type) {
    return new Promise((next, error) => {
      authLAxios
        .post("/getWhatsappTemplates", { type: type }, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getMailersendEmailTemplates(type) {
  //   return new Promise((next, error) => {
  //     authAxios
  //       .post("/getMailersendEmailTemplates", { type: type }, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getMailersendEmailTemplates(type) {
    return new Promise((next, error) => {
      authLAxios
        .post("/getMailersendEmailTemplates", { type: type }, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // sendSmsByTemplate(data) {
  //   return new Promise((next, error) => {
  //     authAxios
  //       .post("/sendSmsByTemplate", { obj: data }, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  sendSmsByTemplate(data) {
    return new Promise((next, error) => {
      authLAxios
        .post("/sendSmsByTemplate", { obj: data }, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // sendWhatsAppSmsByTemplate(data) {
  //   return new Promise((next, error) => {
  //     authAxios
  //       .post("/sendWhatsAppSmsByTemplate", { obj: data }, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  sendWhatsAppSmsByTemplate(data) {
    return new Promise((next, error) => {
      authLAxios
        .post("/sendWhatsAppSmsByTemplate", { obj: data }, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  sendEmailByTemplate(data) {
    return new Promise((next, error) => {
      authLAxios
        .post("/sendEmailByTemplate", { obj: data }, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // visaProcessFileStatus(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/inquiry/visaProcessFileStatus", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  visaProcessFileStatus(data) {
    return new Promise((next) => {
      authLAxios
        .post("/inquiry/visaProcessFileStatus", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // visaProcessApi(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/inquiry/visaProcess", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  visaProcessApi(data) {
    return new Promise((next) => {
      authLAxios
        .post("/inquiry/visaProcess", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // visaDocumentProcessApi(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/inquiry/visaDocument", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  visaDocumentProcessApi(data) {
    return new Promise((next) => {
      authLAxios
        .post("/inquiry/visaDocument", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // visaPayment(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/inquiry/paymentDesk", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  visaPayment(data) {
    return new Promise((next) => {
      authLAxios
        .post("/inquiry/paymentDesk", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  courseQuotationApi(inquiryId, data) {
    var pathway =
      data.pathways && data.pathways.length ? data.pathways[0] : null;
    let linkValue = null;
    if (pathway) {
      linkValue =
        MEDIA_URL + `initialCost/${inquiryId}/${data.courseId}/${pathway._id}`;
    } else {
      linkValue = MEDIA_URL + `initialCost/${inquiryId}/${data.courseId}`;
    }
    window.open(linkValue, "_blank");
  }

  // getCity(cityId) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/city/${cityId}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getCity(cityId) {
    return new Promise((next) => {
      authLAxios
        .get(`/city/${cityId}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // sendReferenceCode(inquiryId) {
  //   return new Promise((next, error) => {
  //     authAxios
  //       .post("/sendReferenceCode", { inquiryId: inquiryId }, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  sendReferenceCode(inquiryId) {
    return new Promise((next, error) => {
      authLAxios
        .post("/sendReferenceCode", { inquiryId: inquiryId }, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // checkReferenceCode(data) {
  //   return new Promise((next, error) => {
  //     authAxios
  //       .post("/checkReferenceCode", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  checkReferenceCode(data) {
    return new Promise((next, error) => {
      authLAxios
        .post("/checkReferenceCode", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // resendReferenceCode(inquiryId) {
  //   return new Promise((next, error) => {
  //     authAxios
  //       .post("/resendReferenceCode", { inquiryId: inquiryId }, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  resendReferenceCode(inquiryId) {
    return new Promise((next, error) => {
      authLAxios
        .post("/resendReferenceCode", { inquiryId: inquiryId }, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // courseListByIds(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/course/courseListByIds`, data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  courseListByIds(data) {
    return new Promise((next) => {
      authLAxios
        .post(`/course/courseListByIds`, data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // postponedFollowups(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/followUp/postponed`, data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  postponedFollowups(data) {
    return new Promise((next) => {
      authLAxios
        .post(`/followUp/postponed`, data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // loadCounsellor(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/getCounsellorList", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadCounsellor(data) {
    return new Promise((next) => {
      authLAxios
        .get("/getCounsellorList", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // loadAllCounsellors(data) {
  //   return new Promise((next) => {
  //     authAxios.get('/loadAllCounsellors', { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   })
  // }
  loadAllCounsellors(data) {
    return new Promise((next) => {
      authLAxios.get('/loadAllCounsellors', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  // loadCounsellorListForStudentRights(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/getCounsellorListForStudentRights", {
  //         params: { ...data },
  //         ...getToken(),
  //       })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadCounsellorListForStudentRights(data) {
    return new Promise((next) => {
      authLAxios
        .get("/getCounsellorListForStudentRights", {
          params: { ...data },
          ...getToken(),
        })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getOperationManagerListForStudentRights(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/getOperationManagerListForStudentRights", {
  //         params: { ...data },
  //         ...getToken(),
  //       })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getOperationManagerListForStudentRights(data) {
    return new Promise((next) => {
      authLAxios
        .get("/getOperationManagerListForStudentRights", {
          params: { ...data },
          ...getToken(),
        })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // loadSimpleCounsellor(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/simpleCounsellorList", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadSimpleCounsellor(data) {
    return new Promise((next) => {
      authLAxios
        .get("/simpleCounsellorList", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // emailCheckList(data) {
  //   return new Promise((next, error) => {
  //     authAxios
  //       .post("/emailCheckList", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  emailCheckList(data) {
    return new Promise((next, error) => {
      authLAxios
        .post("/emailCheckList", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getUserProfileByUserId() {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/getUserProfileByUserId`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getUserProfileByUserId() {
    return new Promise((next) => {
      authLAxios
        .get(`/getUserProfileByUserId`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // updateUserPassword(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/updateUserPassword`, data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  updateUserPassword(data) {
    return new Promise((next) => {
      authLAxios
        .post(`/updateUserPassword`, data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // loadAllNotAllowedIps(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/allNotAllowedIps", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadAllNotAllowedIps(data) {
    return new Promise((next) => {
      authLAxios
        .get("/allNotAllowedIps", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // addIpToIpsCollection(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/addNotAllowedIpToCollection`, data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  addIpToIpsCollection(data) {
    return new Promise((next) => {
      authLAxios
        .post(`/addNotAllowedIpToCollection`, data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // deleteNotAllowedIp(data) {
  //   return new Promise((next, error) => {
  //     authAxios
  //       .delete(
  //         `/removeNotAllowedIps/` + data.ip,

  //         {
  //           headers: {
  //             Authorization: "Bearer " + localStorage.getItem("token"),
  //           },
  //         }
  //       )
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  deleteNotAllowedIp(data) {
    return new Promise((next, error) => {
      authLAxios.delete(`/removeNotAllowedIps/` + data.ip, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }



  // deleteAllNotAllowedIps() {
  //   return new Promise((next, error) => {
  //     authAxios
  //       .delete(`/delete/allNotAllowedIps`, {
  //         headers: {
  //           Authorization: "Bearer " + localStorage.getItem("token"),
  //         },
  //       })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  deleteAllNotAllowedIps() {
    return new Promise((next, error) => {
      authLAxios
        .delete(`/delete/allNotAllowedIps`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // addIp(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/addIp`, data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  addIp(data) {
    return new Promise((next) => {
      authLAxios
        .post(`/addIp`, data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // loadAllowedIps(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/allAllowedIps", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadAllowedIps(data) {
    return new Promise((next) => {
      authLAxios
        .get("/allAllowedIps", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // deleteAllowedIp(data) {
  //   return new Promise((next, error) => {
  //     authAxios
  //       .delete(
  //         `/allowedIps/` + data.ipAddress,

  //         {
  //           headers: {
  //             Authorization: "Bearer " + localStorage.getItem("token"),
  //           },
  //         }
  //       )
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  deleteAllowedIp(data) {
    return new Promise((next, error) => {
      authLAxios
        .delete(
          `/allowedIps/` + data.ipAddress, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // deleteMultipleAllowedIp(data) {
  //   return new Promise((next, error) => {
  //     authAxios
  //       .post(
  //         `/deleteMultipleAllowedIps`,
  //         { params: { ...data } },
  //         {
  //           headers: {
  //             Authorization: "Bearer " + localStorage.getItem("token"),
  //           },
  //         }
  //       )
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  deleteMultipleAllowedIp(data) {
    return new Promise((next, error) => {
      authLAxios
        .post(`/deleteMultipleAllowedIps`, data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // addVisaEnquiry(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/visaEnquiry", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  addVisaEnquiry(data) {
    return new Promise((next) => {
      authLAxios
        .post("/visaEnquiry", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  getAllVisaEnquiryList(data) {
    return new Promise((next) => {
      authLAxios.get('/allVisaEnquiry', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  // getAllVisaEnquiryList(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/visaEnquiry", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  // getStatusByUniversityCountry(data) {
  //   return new Promise((next) => {
  //     authAxios.get("/getStatusByCountry", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getStatusByUniversityCountry(data) {
    return new Promise((next) => {
      authLAxios.get("/getStatusByCountry", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // moveRawToVisitorVisa(data) {
  //   return new Promise((next) => {
  //     authAxios.post("/visaEnquiry/moveRawToVisitorVisa", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   })
  // }
  moveRawToVisitorVisa(data) {
    return new Promise((next) => {
      authLAxios.post("/visaEnquiry/moveRawToVisitorVisa", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  // moveStudentToVisitorVisa(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/visaEnquiry/moveToVisitorVisa", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  moveStudentToVisitorVisa(data) {
    return new Promise((next) => {
      authLAxios
        .post("/visaEnquiry/moveToVisitorVisa", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // moveStudentToStudy(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/moveStudentToStudy", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  moveStudentToStudy(data) {
    return new Promise((next) => {
      authLAxios
        .post("/moveStudentToStudy", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // deleteVisaEnquiry(data) {
  //   return new Promise((next, error) => {
  //     authAxios
  //       .delete(`/visaEnquiry/` + data._id, {
  //         headers: {
  //           Authorization: "Bearer " + localStorage.getItem("token"),
  //         },
  //       })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  deleteVisaEnquiry(data) {
    return new Promise((next, error) => {
      authLAxios
        .delete(`/visaEnquiry/` + data._id, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // editVisaEnquiry(data) {
  //   return new Promise((next, error) => {
  //     authAxios
  //       .put(`/visaEnquiry`, data, {
  //         headers: {
  //           Authorization: "Bearer " + localStorage.getItem("token"),
  //         },
  //       })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  editVisaEnquiry(data) {
    return new Promise((next, error) => {
      authLAxios
        .put(`/visaEnquiry`, data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getVisaEnquiryDetail(data) {
  //   return new Promise((next, error) => {
  //     authAxios
  //       .get(`/visaEnquiry/` + data._id, {
  //         headers: {
  //           Authorization: "Bearer " + localStorage.getItem("token"),
  //         },
  //       })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getVisaEnquiryDetail(data) {
    return new Promise((next, error) => {
      authLAxios.get('/visaEnquiry/' + data._id, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // addRawInquiry(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/rawInquiry", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  addRawInquiry(data) {
    return new Promise((next) => {
      authLAxios
        .post("/rawInquiry", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // deleteMultipleRawInquiries(data) {
  //   return new Promise((next) => {
  //     authAxios.post("/deleteMultipleRawInquiries", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  deleteMultipleRawInquiries(data) {
    return new Promise((next) => {
      authLAxios.post("/deleteMultipleRawInquiries", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getAllRawInquiryList(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/rawInquiry", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getAllRawInquiryList(data) {
    return new Promise((next) => {
      authLAxios
        .get("/rawInquiry", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // getAllFacebookInquiryList(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/getFacebookInquiry", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  // getAllFacebookInquiryList(data) {
  //   return new Promise((next) => {
  //     authLAxios
  //       .get("/getFacebookInquiry", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  // getAllGlobalExpoLeads(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/globalExpoLeads", { params: { ...data }, ...getToken() })

  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  // saveCounsellor(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/saveCounsellor/rawInquiry", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  saveCounsellor(data) {
    return new Promise((next) => {
      authLAxios
        .post("/saveCounsellor/rawInquiry", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // dropRawInquiry(data) {
  //   return new Promise((next)=>{
  //     authAxios.post('/rawInquiry/dropRawInquiry', data, getToken())
  //     .then((d) => {
  //       next(d.data);
  //     })
  //     .catch((err) => {
  //       this.error(err);
  //     });
  //   })
  // }
  dropRawInquiry(data) {
    return new Promise((next) => {
      authLAxios.post('/rawInquiry/dropRawInquiry', data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  // restoreRawDroppedLead(data) {
  //   return new Promise((next)=>{
  //     authAxios.post('/rawInquiry/restoreRawInquiry', data, getToken())
  //     .then((d) => {
  //       next(d.data);
  //     })
  //     .catch((err) => {
  //       this.error(err);
  //     });
  //   })
  // }
  restoreRawDroppedLead(data) {
    return new Promise((next) => {
      authLAxios.post('/rawInquiry/restoreRawInquiry', data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }


  // moveAndDeleteRawInquiry(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/moveAndDelete/rawInquiry", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  moveAndDeleteRawInquiry(data) {
    return new Promise((next) => {
      authLAxios
        .post("/moveAndDelete/rawInquiry", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  moveRawInquiry(data) {
    return new Promise((next) => {
      authLAxios
        .post("/rawInquiry/move", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // moveMultipleRawInquiries(data) {
  //   return new Promise((next) => {
  //     authAxios.post("/moveMultipleRawInquiry", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  moveMultipleRawInquiries(data) {
    return new Promise((next) => {
      authLAxios.post("/moveMultipleRawInquiry", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // assignCounsellors(data) {
  //   return new Promise((next) => {
  //     authAxios.post("/assignCounsellorToInquiries", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  assignCounsellors(data) {
    return new Promise((next) => {
      authLAxios.post("/assignCounsellorToInquiries", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // updateRawInquiry(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put("/rawInquiry", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  updateRawInquiry(data) {
    return new Promise((next) => {
      authLAxios
        .put("/rawInquiry", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // deleteRawInquiry(data) {
  //   return new Promise((next, error) => {
  //     authAxios
  //       .delete(`/rawInquiry/` + data._id, {
  //         headers: {
  //           Authorization: "Bearer " + localStorage.getItem("token"),
  //         },
  //       })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  deleteRawInquiry(data) {
    return new Promise((next, error) => {
      authLAxios
        .delete(`/rawInquiry/` + data._id, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getRawInquiryIdDetail(data) {
  //   return new Promise((next, error) => {
  //     authAxios
  //       .get(`/rawInquiry/` + data._id, {
  //         headers: {
  //           Authorization: "Bearer " + localStorage.getItem("token"),
  //         },
  //       })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getRawInquiryIdDetail(data) {
    return new Promise((next, error) => {
      authLAxios
        .get(`/rawInquiry/` + data._id, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // addExcelData(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/excelRawInquiryData", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  addExcelData(data) {
    return new Promise((next) => {
      authLAxios
        .post("/excelRawInquiryData", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // addUniversityThroughExcel(data) {
  //   return new Promise((next) => {
  //     authAxios.post("/excelUniversityData", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  addUniversityThroughExcel(data) {
    return new Promise((next) => {
      authLAxios.post("/excelUniversityData", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // addInquiryThroughExcel(data) {
  //   return new Promise((next) => {
  //     authAxios.post('/excelInquiryData', data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  addInquiryThroughExcel(data) {
    return new Promise((next) => {
      authLAxios.post('/excelInquiryData', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // addChannelPartnerExcelData(data) {
  //   return new Promise((next) => {
  //     authAxios.post('/excelChannelPartnerData', data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  addChannelPartnerExcelData(data) {
    return new Promise((next) => {
      authLAxios.post('/excelChannelPartnerData', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // addCourseFromExcelData(data) {
  //   return new Promise((next) => {
  //     authAxios.post('/excelCourseData', data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  addCourseFromExcelData(data) {
    return new Promise((next) => {
      authLAxios.post('/excelCourseData', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }
  // transferCounsellor(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/changeCounsellor/inquiry`, data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  transferCounsellor(data) {
    return new Promise((next) => {
      authLAxios
        .post(`/changeCounsellor/inquiry`, data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // getLeadTransferHistory(data) {
  //   return new Promise((next) => {
  //     authAxios.get("/changeCounsellor/inquiry", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getLeadTransferHistory(data) {
    return new Promise((next) => {
      authLAxios.get("/changeCounsellor/inquiry", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  changeMultipleCounsellors(data) {
    return new Promise((next) => {
      authLAxios.post('/inquiry/changeMultipleCounsellors', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  changeMultipleCounsellorAndDesk(data) {
    return new Promise((next) => {
      authLAxios.post('/inquiry/changeMultipleCounsellorAndDesk', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getTellecallerDashboardCount(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/tellecaller/dashboard/count`, {
  //         params: { ...data },
  //         ...getToken(),
  //       })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getTellecallerDashboardCount(data) {
    return new Promise((next) => {
      authLAxios
        .get(`/tellecaller/dashboard/count`, {
          params: { ...data },
          ...getToken(),
        })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // getRelationShipGraphData(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/getRelationShipGraphData`, {
  //         params: { ...data },
  //         ...getToken(),
  //       })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getRelationShipGraphData(data) {
    return new Promise((next) => {
      authLAxios
        .get(`/getRelationShipGraphData`, {
          params: { ...data },
          ...getToken(),
        })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // getTelecallerGraphData(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/getTelecallerGraphData`, { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getTelecallerGraphData(data) {
    return new Promise((next) => {
      authLAxios
        .get(`/getTelecallerGraphData`, { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // getFollowupsData(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/followupsTypes/count`, { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getFollowupsData(data) {
    return new Promise((next) => {
      authLAxios
        .get(`/followupsTypes/count`, { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // getTodayFollowupsData(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/followupsTypes/todayCount`, {
  //         params: { ...data },
  //         ...getToken(),
  //       })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getTodayFollowupsData(data) {
    return new Promise((next) => {
      authLAxios
        .get(`/followupsTypes/todayCount`, {
          params: { ...data },
          ...getToken(),
        })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // getOverdueFollowupsData(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/followupsTypes/overdueCount`, {
  //         params: { ...data },
  //         ...getToken(),
  //       })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getOverdueFollowupsData(data) {
    return new Promise((next) => {
      authLAxios
        .get(`/followupsTypes/overdueCount`, {
          params: { ...data },
          ...getToken(),
        })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getcountData(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/registrationCountForDays`, {
  //         params: { ...data },
  //         ...getToken(),
  //       })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getcountData(data) {
    return new Promise((next) => {
      authLAxios
        .get(`/registrationCountForDays`, {
          params: { ...data },
          ...getToken(),
        })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getFrontOfficeData(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/getFrontOfficeData`, { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getFrontOfficeData(data) {
    return new Promise((next) => {
      authLAxios
        .get(`/getFrontOfficeData`, { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // getAppointmentStates(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/getAppointmentStates`, { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getAppointmentStates(data) {
    return new Promise((next) => {
      authLAxios
        .get(`/getAppointmentStates`, { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // getOfficeManagerData(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/getOfficeManagerData`, { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getOfficeManagerData(data) {
    return new Promise((next) => {
      authLAxios
        .get(`/getOfficeManagerData`, { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  getDashboardTaskAppointments(data) {
    return new Promise((next) => {
      authLAxios.get('/getDashboardTaskAppointments', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  loadCounsellorDashboardData(data) {
    return new Promise((next) => {
      authLAxios.get('/getCounsellorDashboard', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  getDashboardCalenderFollowup(data) {
    return new Promise((next) => {
      authLAxios.get('/getDashboardCalenderFollowup', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  getRegistrationDashboardData(data) {
    return new Promise((next) => {
      authLAxios.get('/getRegistrationDashboard', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  loadAdmissionDashboardData(data) {
    return new Promise((next) => {
      authLAxios.get('/loadAdmissionDashboardData', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  loadVisaSupportDashboard(data) {
    return new Promise((next) => {
      authLAxios.get('/loadVisaSupportDashboard', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  getVisaFillingDashboardData(data) {
    return new Promise((next) => {
      authLAxios.get('/getVisaFillingDashboardData', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  // monthWeakCount(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/deskWise/monthWeak/count`, {
  //         params: { ...data },
  //         ...getToken(),
  //       })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  monthWeakCount(data) {
    return new Promise((next) => {
      authLAxios
        .get(`/deskWise/monthWeak/count`, {
          params: { ...data },
          ...getToken(),
        })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // pendingProcessedAndOffersCount(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/applicationDesk/pendingProcessed/offers/count`, {
  //         params: { ...data },
  //         ...getToken(),
  //       })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  pendingProcessedAndOffersCount(data) {
    return new Promise((next) => {
      authLAxios
        .get(`/applicationDesk/pendingProcessed/offers/count`, {
          params: { ...data },
          ...getToken(),
        })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // consultancyReceivedData(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/consultancyRecieved`, { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  consultancyReceivedData(data) {
    return new Promise((next) => {
      authLAxios
        .get(`/consultancyRecieved`, { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // getTodayRegistrationsReceipts(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/getTodayRegistrationsReceipt`, {
  //         params: { ...data },
  //         ...getToken(),
  //       })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getTodayRegistrationsReceipts(data) {
    return new Promise((next) => {
      authLAxios
        .get(`/getTodayRegistrationsReceipt`, {
          params: { ...data },
          ...getToken(),
        })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // getTodaySubmittedReceipts(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/getTodaySubmittedReceipts`, {
  //         params: { ...data },
  //         ...getToken(),
  //       })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getTodaySubmittedReceipts(data) {
    return new Promise((next) => {
      authLAxios
        .get(`/getTodaySubmittedReceipts`, {
          params: { ...data },
          ...getToken(),
        })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // getTodaysSubmitFeesCount(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/getTodaysSubmitFeesCount`, {
  //         params: { ...data },
  //         ...getToken(),
  //       })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getTodaysSubmitFeesCount(data) {
    return new Promise((next) => {
      authLAxios
        .get(`/getTodaysSubmitFeesCount`, {
          params: { ...data },
          ...getToken(),
        })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // getTodaysSubmitFees(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/getTodaysSubmitFees`, { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getTodaysSubmitFees(data) {
    return new Promise((next) => {
      authLAxios
        .get(`/getTodaysSubmitFees`, { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // submitTodaysPayments(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/submitTodaysPayments`, data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  submitTodaysPayments(data) {
    return new Promise((next) => {
      authLAxios
        .post(`/submitTodaysPayments`, data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // approveTodayFees(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/approveTodayFees`, data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  approveTodayFees(data) {
    return new Promise((next) => {
      authLAxios
        .post(`/approveTodayFees`, data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // approveAccountPayment(data) {
  //   return new Promise((next) => {
  //     authAxios.post('/approveAccountPayment', data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   })
  // }
  approveAccountPayment(data) {
    return new Promise((next) => {
      authLAxios.post('/approveAccountPayment', data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  // getPendingConsultancyFollowups(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/getPendingConsultancyFollowups`, {
  //         params: { ...data },
  //         ...getToken(),
  //       })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getPendingConsultancyFollowups(data) {
    return new Promise((next) => {
      authLAxios
        .get(`/getPendingConsultancyFollowups`, {
          params: { ...data },
          ...getToken(),
        })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // exportTodaysPayments(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/exportTodaysPayments`, { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  exportTodaysPayments(data) {
    return new Promise((next) => {
      authLAxios
        .get(`/exportTodaysPayments`, { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // visaFillingCounts(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/visadesk/counts`, { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  visaFillingCounts(data) {
    return new Promise((next) => {
      authLAxios
        .get(`/visadesk/counts`, { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // visaStatusCounts(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/visastatus/counts`, { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  visaStatusCounts(data) {
    return new Promise((next) => {
      authLAxios
        .get(`/visastatus/counts`, { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // leadIndividualCount(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/leadIndividualCount`, { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  // leadIndividualCountByRating(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/leadIndividualCountByRating`, {
  //         params: { ...data },
  //         ...getToken(),
  //       })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  leadIndividualCountByRating(data) {
    return new Promise((next) => {
      authLAxios
        .get(`/leadIndividualCountByRating`, {
          params: { ...data },
          ...getToken(),
        })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // getFeePaymentStatus(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/getFeePaymentStatus`, { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getFeePaymentStatus(data) {
    return new Promise((next) => {
      authLAxios
        .get(`/getFeePaymentStatus`, { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // getUntouchLeads(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/getUntouchLeads`, { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getUntouchLeads(data) {
    return new Promise((next) => {
      authLAxios
        .get(`/getUntouchLeads`, { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // pieChartData(params) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/pieChartData", { params: { ...params }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  // dateWiseNewApplicationsCount(params) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/admission/pending/applicationCount`, {
  //         params: { ...params },
  //         ...getToken(),
  //       })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  dateWiseNewApplicationsCount(params) {
    return new Promise((next) => {
      authLAxios
        .get(`/admission/pending/applicationCount`, {
          params: { ...params },
          ...getToken(),
        })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  dateWiseProcessedApplicationCount(params) {
    return new Promise((next) => {
      authLAxios
        .get(`/admission/processed/applicationCount`, {
          params: { ...params },
          ...getToken(),
        })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // offerReceivedApplicationsCount(params) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/admission/offerReceived/applicationCount`, {
  //         params: { ...params },
  //         ...getToken(),
  //       })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  offerReceivedApplicationsCount(params) {
    return new Promise((next) => {
      authLAxios
        .get(`/admission/offerReceived/applicationCount`, {
          params: { ...params },
          ...getToken(),
        })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // admissionDashboardPieChart(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/admissionDashboard/pieChart`, {
  //         params: { ...data },
  //         ...getToken(),
  //       })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  admissionDashboardPieChart(data) {
    return new Promise((next) => {
      authLAxios
        .get(`/admissionDashboard/pieChart`, {
          params: { ...data },
          ...getToken(),
        })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // dateWiseOfferReceivedVisaCount(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/visaCounsellar/visaOfferReceivedCount`, {
  //         params: { ...data },
  //         ...getToken(),
  //       })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  dateWiseOfferReceivedVisaCount(data) {
    return new Promise((next) => {
      authLAxios
        .get(`/visaCounsellar/visaOfferReceivedCount`, {
          params: { ...data },
          ...getToken(),
        })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // fileStatusWiseCount(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/visaCounsellar/fileStatusWiseCount`, {
  //         params: { ...data },
  //         ...getToken(),
  //       })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  fileStatusWiseCount(data) {
    return new Promise((next) => {
      authLAxios
        .get(`/visaCounsellar/fileStatusWiseCount`, {
          params: { ...data },
          ...getToken(),
        })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getVisaFillingData(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/visaCounsellar/getVisaFillingData`, {
  //         params: { ...data },
  //         ...getToken(),
  //       })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getVisaFillingData(data) {
    return new Promise((next) => {
      authLAxios
        .get(`/visaCounsellar/getVisaFillingData`, {
          params: { ...data },
          ...getToken(),
        })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getCliamDeskData(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/getCliamDeskData`, { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getCliamDeskData(data) {
    return new Promise((next) => {
      authLAxios
        .get(`/getCliamDeskData`, { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  getClaimAccountDashboardData(data) {
    return new Promise((next) => {
      authLAxios.get('/getClaimAccountData', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  getDashboardOutstandingCommission(data) {
    return new Promise((next) => {
      authLAxios.get('/getDashboardOutstandingCommission', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }
  getDashboardReceivedCommission(data) {
    return new Promise((next) => {
      authLAxios.get('/getDashboardReceivedCommission', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  // feeDueByStudents(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/visaCounsellar/feeDueByStudents`, {
  //         params: { ...data },
  //         ...getToken(),
  //       })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  feeDueByStudents(data) {
    return new Promise((next) => {
      authLAxios
        .get(`/visaCounsellar/feeDueByStudents`, {
          params: { ...data },
          ...getToken(),
        })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // pendingByCountriesCount(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/admission/pendingByCountriesCount`, {
  //         params: { ...data },
  //         ...getToken(),
  //       })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  // applicationStageWiseCount(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/admission/offerStatusWiseCount`, {
  //         params: { ...data },
  //         ...getToken(),
  //       })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  // applicationStageWiseCount(data) {
  //   return new Promise((next) => {
  //     authLAxios
  //       .get(`/admission/offerStatusWiseCount`, {
  //         params: { ...data },
  //         ...getToken(),
  //       })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  // applicationBranchWiseCount(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/admission/pendingByBranch`, {
  //         params: { ...data },
  //         ...getToken(),
  //       })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  applicationBranchWiseCount(data) {
    return new Promise((next) => {
      authLAxios
        .get(`/admission/pendingByBranch`, {
          params: { ...data },
          ...getToken(),
        })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // applicationCounsellorWiseCount(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/admission/pendingByCounsellor`, {
  //         params: { ...data },
  //         ...getToken(),
  //       })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  applicationCounsellorWiseCount(data) {
    return new Promise((next) => {
      authLAxios
        .get(`/admission/pendingByCounsellor`, {
          params: { ...data },
          ...getToken(),
        })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // saveFileLibraryData(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/fileLibrary`, data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  saveFileLibraryData(data) {
    return new Promise((next) => {
      authLAxios
        .post(`/fileLibrary`, data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // handleSearchStudent(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/handleSearchStudent`, data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  handleSearchStudent(data) {
    return new Promise((next) => {
      authLAxios
        .post(`/handleSearchStudent`, data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  handleSearchUniversity(data) {
    return new Promise((next) => {
      authLAxios.post('/handleSearchUniversity', data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  handleSearchChannelPartner(data) {
    return new Promise((next) => {
      authLAxios.post('/handleSearchChannelPartner', data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  getUniversityCpStudentDetails(data) {
    return new Promise((next) => {
      authLAxios.post('/getUniversityCpStudentDetails', data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  exportUniversityCpStudentDetails(data) {
    return new Promise((next) => {
      authLAxios.post('/exportUniversityCpStudentDetails', data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  // getStudentDetails(inquiryId) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/getStudentDetails/${inquiryId}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getStudentDetails(inquiryId) {
    return new Promise((next) => {
      authLAxios
        .get(`/getStudentDetails/${inquiryId}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getFileLibraryByCourseId(courseId) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/fileLibrary/${courseId}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getFileLibraryByCourseId(courseId) {
    return new Promise((next) => {
      authLAxios
        .get(`/fileLibrary/${courseId}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getUniversityInvoiceCount(data) {
  //   return new Promise((next) => {
  //     authAxios.get('/invoiceCountByUniversity', { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   })
  // }

  // addInvoice(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/add/invoice`, data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  addInvoice(data) {
    return new Promise((next) => {
      authLAxios
        .post(`/add/invoice`, data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // generatedInvoicesList(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/generated/invoicesList`, { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  generatedInvoicesList(data) {
    return new Promise((next) => {
      authLAxios
        .get(`/generated/invoicesList`, { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // dueInvoicesList(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/due/invoicesList`, { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  dueInvoicesList(data) {
    return new Promise((next) => {
      authLAxios
        .get(`/due/invoicesList`, { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  getDueInvoiceList(data) {
    return new Promise((next) => {
      authLAxios.get('/getDueInvoiceList', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  // updateInvoice(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/update/invoice`, data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  updateInvoice(data) {
    return new Promise((next) => {
      authLAxios
        .post(`/update/invoice`, data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // updateDueInvoiceStatus(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/update/dueInvoiceStatus`, data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  updateDueInvoiceStatus(data) {
    return new Promise((next) => {
      authLAxios
        .post(`/update/dueInvoiceStatus`, data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  updateDueInvoiceBranchStatus(data) {
    return new Promise((next) => {
      authLAxios
        .post(`/update/dueInvoiceBranchStatus`, data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // updateClaimData(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put(`/claim/update/${data._id}`, data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  updateClaimData(data) {
    return new Promise((next) => {
      authLAxios
        .put(`/claim/update/${data._id}`, data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // updateStudentEnrollment(data) {
  //   return new Promise((next) => {
  //     authAxios.post('/updateEnrollmentStatus', data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   })
  // }
  updateStudentEnrollment(data) {
    return new Promise((next) => {
      authLAxios.post('/updateEnrollmentStatus', data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  // checkTodayStudentEnrollment(data) {
  //   return new Promise((next) => {
  //     authAxios.get('/getTodayEnrollment', { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  checkTodayStudentEnrollment(data) {
    return new Promise((next) => {
      authLAxios.get('/getTodayEnrollment', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getTodaysEnrollment(data) {
  //   return new Promise((next) => {
  //     authAxios.get("/getTodaysEnrollmentDetails", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getTodaysEnrollment(data) {
    return new Promise((next) => {
      authLAxios.get("/getTodaysEnrollmentDetails", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // sendStudentEnrollmentMail(data) {
  //   return new Promise((next) => {
  //     authAxios.post("/sendStudentEnrollmentMail", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  sendStudentEnrollmentMail(data) {
    return new Promise((next) => {
      authLAxios.post("/sendStudentEnrollmentMail", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // saveInvoiceDate(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/saveInvoiceDate`, data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  saveInvoiceDate(data) {
    return new Promise((next) => {
      authLAxios
        .post(`/saveInvoiceDate`, data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // saveChannelPartner(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/visaDesk/save/channelPartner", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  saveChannelPartner(data) {
    return new Promise((next) => {
      authLAxios
        .post("/visaDesk/save/channelPartner", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // checkPendingTaskAndFollowupAtLogout(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/pendingTask/pendingFollowup/logout", {params:{...data}, ...getToken()})
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  checkPendingTaskAndFollowupAtLogout(data) {
    return new Promise((next) => {
      authLAxios
        .get("/pendingTask/pendingFollowup/logout", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // exportCountryDataToExcel(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/export/countryData", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  exportCountryDataToExcel(data) {
    return new Promise((next) => {
      authLAxios
        .post("/export/countryData", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // exportUniversityDataToExcel(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/export/universityData", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  exportUniversityDataToExcel(data) {
    return new Promise((next) => {
      authLAxios
        .post("/export/universityData", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  exportStudentDataToExcel(data) {
    return new Promise((next) => {
      authAxios
        .post("/export/studentReportData", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // paymentdeskPDF(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/paymentGeneratePDF", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  exportCourseDataToExcel(data) {
    return new Promise((next) => {
      authAxios
        .post("/export/courseData", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getAllStudentReport(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/studentReportData", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  // getallActivityReport(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/activityReportData", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  // getBuisnessReport(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/buisnessReportData", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  // studentList(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/filteredstudentData", { params: { data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  studentList(data) {
    return new Promise((next) => {
      authLAxios
        .get("/filteredstudentData", { params: { data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // exportBuisnessDataToExcel(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/export/buisnessReport", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  // exportActivityDataToExcel(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/export/activityReport", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  // graphicalReportData(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/graphicaldesksReport", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  // userwiseReportData(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/userGraphReport", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  // searchData(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/search/typeaheadData", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  // getLibraryReport(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/libraryReportFilters", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  // getUniversitiesReportData(params) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/universityReportData`, { params: { ...params }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  // getCountryReportData(params) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/countryReportData`, { params: { ...params }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  // deleteCountry(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .delete("/country", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  deleteCountry(data) {
    return new Promise((next) => {
      authLAxios
        .delete("/country", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // deleteMasterMediaFiles(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .delete("/master/media/delete", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  deleteMasterMediaFiles(data) {
    return new Promise((next) => {
      authLAxios
        .delete("/master/media/delete", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  deleteMasterDocumentFiles(data) {
    return new Promise((next) => {
      authLAxios.delete('/master/document/delete', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  // deleteStudentMediaFiles(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .delete("/student/media/delete", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  deleteStudentMediaFiles(data) {
    return new Promise((next) => {
      authLAxios
        .delete("/student/media/delete", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // deleteCourseMediaFiles(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .delete("/course/media/delete", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  deleteCourseMediaFiles(data) {
    return new Promise((next) => {
      authLAxios
        .delete("/course/media/delete", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // loadDashboardStudentList(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/dashboard/student/list", { arr: data }, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadDashboardStudentList(data) {
    return new Promise((next) => {
      authLAxios
        .post("/dashboard/student/list", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // loadDashboardCallLogs(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/dashboard/loadDashboardCallLogs", { arr: data }, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadDashboardCallLogs(data) {
    return new Promise((next) => {
      authLAxios
        .post("/dashboard/loadDashboardCallLogs", { arr: data }, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // addAppointment(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/appointment", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  addAppointment(data) {
    return new Promise((next) => {
      authLAxios
        .post("/appointment", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getCallHistory(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/getStudentCallHistory", { params: { data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getCallHistory(data) {
    return new Promise((next) => {
      authLAxios
        .get("/getStudentCallHistory", { params: { data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // loadAppointments(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/appointment", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadAppointments(data) {
    return new Promise((next) => {
      authLAxios
        .get("/appointment", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // searchStudentFilteredData(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/search/studentFiltered/typeaheadData", {
  //         params: { ...data },
  //         ...getToken(),
  //       })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  searchStudentFilteredData(data) {
    return new Promise((next) => {
      authLAxios
        .get("/search/studentFiltered/typeaheadData", {
          params: { ...data },
          ...getToken(),
        })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // deleteAppointment(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .delete(`/appointment/${data._id}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  deleteAppointment(data) {
    return new Promise((next) => {
      authLAxios
        .delete(`/appointment/${data._id}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // saveAppointmentDateAndTime(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/update/postponed/dateandtime`, data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  saveAppointmentDateAndTime(data) {
    return new Promise((next) => {
      authLAxios
        .post(`/update/postponed/dateandtime`, data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getVisaFeeMainApplicantFilter() {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/api/getVisaFeeMainApplicantFilter", {}, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getVisaFeeMainApplicantFilter() {
    return new Promise((next) => {
      authLAxios
        .post("/api/getVisaFeeMainApplicantFilter", {}, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // exportCountriesToExcel(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/countries/export", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  exportCountriesToExcel(data) {
    return new Promise((next) => {
      authLAxios
        .post("/countries/export", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // exportUniversitiesToExcel(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/universities/export", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  exportUniversitiesToExcel(data) {
    return new Promise((next) => {
      authLAxios
        .post("/universities/export", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // exportServiceProviderAgreementToExcel(data) {
  //   return new Promise((next) => {
  //     authAxios.post('/serviceProviderAgreement/export', data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  exportServiceProviderAgreementToExcel(data) {
    return new Promise((next) => {
      authLAxios.post('/serviceProviderAgreement/export', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // exportStaffSalariesToExcel(data) {
  //   return new Promise((next) => {
  //     authAxios.post('/salaries/export', data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  exportStaffSalariesToExcel(data) {
    return new Promise((next) => {
      authLAxios.post('/salaries/export', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // exportUsersToExcel(data) {
  //   return new Promise((next) => {
  //     authAxios.post("/employees/export", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  exportUsersToExcel(data) {
    return new Promise((next) => {
      authLAxios.post("/employees/export", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }
  // exportRawInquiryToExcel(data) {
  //   return new Promise((next) => {
  //     authAxios.post('/rawInquiry/export', data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  exportRawInquiryToExcel(data) {
    return new Promise((next) => {
      authLAxios.post('/rawInquiry/export', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }
  // exportCounsellingDeskToExcel(data) {
  //   return new Promise((next) => {
  //     authAxios.get('/counsellingDesk/export', { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  exportCounsellingDeskToExcel(data) {
    return new Promise((next) => {
      authLAxios.get('/counsellingDesk/export', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // exportOperationDeskToExcel(data) {
  //   return new Promise((next) => {
  //     authAxios.get('/operationDesk/export', { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  // exportVisaEnquiryToExcel(data) {
  //   return new Promise((next) => {
  //     authAxios.post('/visaEnquiry/export', data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  exportVisaEnquiryToExcel(data) {
    return new Promise((next) => {
      authLAxios.post('/visaEnquiry/export', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // exportSalarySheet(data) {
  //   return new Promise((next) => {
  //     authAxios.post("/salary/export", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  exportSalarySheet(data) {
    return new Promise((next) => {
      authLAxios.post("/salary/export", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }
  // exportFinanceExcelToExcel(data) {
  //   return new Promise((next) => {
  //     authAxios.post("/exportFinanceExcelToExcel", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  exportFinanceExcelToExcel(data) {
    return new Promise((next) => {
      authLAxios.post("/exportFinanceExcelToExcel", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }
  // deleteSalaryRequest(data) {
  //   return new Promise((next) => {
  //     authAxios.delete("/deleteSalaryRequest/" + data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  deleteSalaryRequest(data) {
    return new Promise((next) => {
      authLAxios.delete("/deleteSalaryRequest/" + data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // exportChannelPartnersToExcel(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/channelPartners/export", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  exportChannelPartnersToExcel(data) {
    return new Promise((next) => {
      authLAxios
        .post("/channelPartners/export", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // exportBranchesToExcel(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/branches/export", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  exportBranchesToExcel(data) {
    return new Promise((next) => {
      authLAxios
        .post("/branches/export", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // generateInvoice(data) {
  //   return new Promise((next, reject) => {
  //     authAxios
  //       .post(`/generateInvoice`, data, {
  //         responseType: "arraybuffer",
  //         ...getToken(),
  //       })
  //       .then((res) => {
  //         const file = new Blob([res.data], { type: "application/pdf" });
  //         const fileURL = URL.createObjectURL(file);
  //         next(fileURL);
  //       })
  //       .catch((err) => {
  //         if (err.response && err.response.data) {
  //           let message = String.fromCharCode.apply(
  //             null,
  //             new Uint8Array(err.response.data)
  //           );
  //           this.error(err);
  //           reject(JSON.parse(message));
  //         }
  //         reject(err);
  //       });
  //   });
  // }

  //-------------------------- Notifications APIS ----

  // fetchAllNotifications(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/getAllNotifications", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       });
  //   });
  // }
  fetchAllNotifications(data) {
    return new Promise((next) => {
      authLAxios
        .get("/getAllNotifications", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        });
    });
  }

  // fetchUnreadNotifications(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/getNotifications", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  fetchUnreadNotifications(data) {
    return new Promise((next) => {
      authLAxios
        .get("/getNotifications", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // fetchNewFiles(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/fetchNewFiles", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  fetchNewFiles(data) {
    return new Promise((next) => {
      authLAxios
        .get("/fetchNewFiles", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }


  getMoveToClaimRequest(data) {
    return new Promise((next) => {
      authLAxios.get('/getMoveToClaimRequest', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }


  // fetchNewIncentiveInvoices(data) {
  //   return new Promise((next) => {
  //     authAxios.get("/fetchNewIncentiveInvoices", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   })
  // }
  fetchNewIncentiveInvoices(data) {
    return new Promise((next) => {
      authLAxios.get("/fetchNewIncentiveInvoices", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  // fetchTodayPaymentFollowups(data) {
  //   return new Promise((next) => {
  //     authAxios.get('/fetchTodayPaymentFollowups', { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   })
  // }
  fetchTodayPaymentFollowups(data) {
    return new Promise((next) => {
      authLAxios.get('/fetchTodayPaymentFollowups', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  // fetchMoveToArchiveDeskRequests(data) {
  //   return new Promise((next) => {
  //     authAxios.get('/fetchMoveToArchiveDeskRequests', { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   })
  // }
  fetchMoveToArchiveDeskRequests(data) {
    return new Promise((next) => {
      authLAxios.get('/fetchMoveToArchiveDeskRequests', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  // approveApplication(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/approveApplication", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  approveApplication(data) {
    return new Promise((next) => {
      authLAxios
        .post("/approveApplication", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // approveMoveArchiveRequest(data) {
  //   return new Promise((next) => {
  //     authAxios.post('/approveMoveArchiveRequest', data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   })
  // }
  approveMoveArchiveRequest(data) {
    return new Promise((next) => {
      authLAxios.post('/approveMoveArchiveRequest', data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  rejectMoveToClaimRequest(data) {
    return new Promise((next) => {
      authLAxios.post('/rejectMoveToClaimRequest', data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  approveMoveToClaimRequest(data) {
    return new Promise((next) => {
      authLAxios.post('/approveMoveToClaimRequest', data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }
  // rejectMoveArchiveRequest(data) {
  //   return new Promise((next) => {
  //     authAxios.post('/rejectMoveArchiveRequest', data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   })
  // }
  rejectMoveArchiveRequest(data) {
    return new Promise((next) => {
      authLAxios.post('/rejectMoveArchiveRequest', data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  // acceptIncentiveInvoice(data) {
  //   return new Promise((next) => {
  //     authAxios.post('/acceptIncentiveInvoice', data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   })
  // }
  acceptIncentiveInvoice(data) {
    return new Promise((next) => {
      authLAxios.post('/acceptIncentiveInvoice', data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  // rejectApplication(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/rejectApplication", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  rejectApplication(data) {
    return new Promise((next) => {
      authLAxios
        .post("/rejectApplication", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // markAsReadNotify(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/viewNotification", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  markAsReadNotify(data) {
    return new Promise((next) => {
      authLAxios
        .post("/viewNotification", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // markAsReadAllNotify(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/markAsReadAllNotify", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  markAsReadAllNotify(data) {
    return new Promise((next) => {
      authLAxios
        .post("/markAsReadAllNotify", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  //-------------------------- Telecaller APIS ----

  // loadTelecaller(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/telecaller", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadTelecaller(data) {
    return new Promise((next) => {
      authLAxios
        .get("/telecaller", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // addTelecaller(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/telecaller", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  addTelecaller(data) {
    return new Promise((next) => {
      authLAxios
        .post("/telecaller", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // deleteTelecaller(data) {
  //   return new Promise((next, error) => {
  //     authAxios
  //       .delete("/telecaller/" + data._id, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  deleteTelecaller(data) {
    return new Promise((next, error) => {
      authLAxios
        .delete("/telecaller/" + data._id, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  //-------------------------- Knowledge base category

  // loadKnowledgeBaseCategory(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/knowledgeBaseCategory", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadKnowledgeBaseCategory(data) {
    return new Promise((next) => {
      authLAxios
        .get("/knowledgeBaseCategory", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getKnowledgeBaseCategory(partId) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/knowledgeBaseCategory/${partId}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getKnowledgeBaseCategory(partId) {
    return new Promise((next) => {
      authLAxios
        .get(`/knowledgeBaseCategory/${partId}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // addKnowledgeBaseCategory(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/knowledgeBaseCategory`, data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  addKnowledgeBaseCategory(data) {
    return new Promise((next) => {
      authLAxios
        .post(`/knowledgeBaseCategory`, data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // deleteKnowledgeBaseCategory(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .delete(`/knowledgeBaseCategory/${data._id}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  deleteKnowledgeBaseCategory(data) {
    return new Promise((next) => {
      authLAxios
        .delete(`/knowledgeBaseCategory/${data._id}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // updateKnowledgeBaseCategory(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put(`/knowledgeBaseCategory`, data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  updateKnowledgeBaseCategory(data) {
    return new Promise((next) => {
      authLAxios
        .put(`/knowledgeBaseCategory`, data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  //------------------------- knowledge base
  // addKnowledgeBase(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/knowledgeBase`, data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  addKnowledgeBase(data) {
    return new Promise((next) => {
      authLAxios
        .post(`/knowledgeBase`, data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // updateKnowledgeBase(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put(`/knowledgeBase`, data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  updateKnowledgeBase(data) {
    return new Promise((next) => {
      authLAxios
        .put(`/knowledgeBase`, data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // loadKnowledgeBase(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/knowledgeBase", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadKnowledgeBase(data) {
    return new Promise((next) => {
      authLAxios
        .get("/knowledgeBase", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getKnowledgeBase(knowledgeBaseId) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/knowledgeBase/${knowledgeBaseId}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getKnowledgeBase(knowledgeBaseId) {
    return new Promise((next) => {
      authLAxios
        .get(`/knowledgeBase/${knowledgeBaseId}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // deleteKnowledgeBase(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .delete(`/knowledgeBase/${data._id}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  deleteKnowledgeBase(data) {
    return new Promise((next) => {
      authLAxios
        .delete(`/knowledgeBase/${data._id}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // addKnowledgeBaseFile(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/fileLibrary_knowledgeBase`, data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  addKnowledgeBaseFile(data) {
    return new Promise((next) => {
      authLAxios
        .post(`/fileLibrary_knowledgeBase`, data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // deleteKnowledgeBaseMediaFiles(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .delete("/fileLibrary_knowledgeBase/", {
  //         params: { ...data },
  //         ...getToken(),
  //       })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  deleteKnowledgeBaseMediaFiles(data) {
    return new Promise((next) => {
      authLAxios
        .delete("/fileLibrary_knowledgeBase/", {
          params: { ...data },
          ...getToken(),
        })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // updateKnowledgeBaseFile(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/updatefileLibrary_knowledgeBase/", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  updateKnowledgeBaseFile(data) {
    return new Promise((next) => {
      authLAxios
        .post("/updatefileLibrary_knowledgeBase/", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // showKnowledgeBase(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/showKnowledgeBaseData`, { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  showKnowledgeBase(data) {
    return new Promise((next) => {
      authLAxios
        .get(`/showKnowledgeBaseData`, { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  /* Auto follow up request */

  // loadAllAutoFollowUp(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/autoFollowUps", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadAllAutoFollowUp(data) {
    return new Promise((next) => {
      authLAxios
        .get("/autoFollowUps", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // addAutoFollowUp(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/autoFollowUps`, data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  addAutoFollowUp(data) {
    return new Promise((next) => {
      authLAxios
        .post(`/autoFollowUps`, data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // getAutoFollowUp(autoFollowUpID) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/autoFollowUps/${autoFollowUpID}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getAutoFollowUp(autoFollowUpID) {
    return new Promise((next) => {
      authLAxios
        .get(`/autoFollowUps/${autoFollowUpID}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // updateAutoFollowUp(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put(`/autoFollowUps`, data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  updateAutoFollowUp(data) {
    return new Promise((next) => {
      authLAxios
        .put(`/autoFollowUps`, data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // deleteAutoFollowUp(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .delete(`/autoFollowUps/${data._id}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  deleteAutoFollowUp(data) {
    return new Promise((next) => {
      authLAxios
        .delete(`/autoFollowUps/${data._id}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // updateRating(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/inquiry/updateRating`, data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  updateRating(data) {
    return new Promise((next) => {
      authLAxios
        .post(`/inquiry/updateRating`, data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }


  // dropInquiry(data) {
  //   return new Promise((next)=>{
  //     authAxios.post("/inquiry/dropInquiry", data, getToken())
  //     .then((d) => {
  //       next(d.data);
  //     })
  //     .catch((err) => {
  //       this.error(err);
  //     });
  //   })
  // }

  dropInquiry(data) {
    return new Promise((next) => {
      authLAxios.post('/inquiry/dropInquiry', data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }


  // restoreDroppedLead(data) {
  //   return new Promise((next)=>{
  //     authAxios.post("/inquiry/restoreDroppedInquiry", data, getToken())
  //     .then((d)=>{
  //       next(d.data)
  //     })
  //     .catch((err)=>{
  //       this.error(err)
  //     })
  //   })
  // }
  restoreDroppedLead(data) {
    return new Promise((next) => {
      authLAxios.post("/inquiry/restoreDroppedInquiry", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // moveToDeadInquiry(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/inquiry/moveToDeadInquiry`, data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  moveToDeadInquiry(data) {
    return new Promise((next) => {
      authLAxios
        .post(`/inquiry/moveToDeadInquiry`, data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  //------------------------- Incentive

  // getIncentives(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/getIncentives", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getIncentives(data) {
    return new Promise((next) => {
      authLAxios
        .get("/getIncentives", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getAllIncentiveDetails(data) {
  //   return new Promise((next) => {
  //     authAxios.get("/getAllIncentives", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getAllIncentiveDetails(data) {
    return new Promise((next) => {
      authLAxios.get("/getAllIncentives", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // exportIncentiveInExcel(data) {
  //   return new Promise((next) => {
  //     authAxios.post('/exportIncentiveInExcel', data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  exportIncentiveInExcel(data) {
    return new Promise((next) => {
      authLAxios.post('/exportIncentiveInExcel', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getInvoicePayments(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/getInvoicePayments", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  // loadWalletUsers(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/getWalletUsers", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadWalletUsers(data) {
    return new Promise((next) => {
      authLAxios
        .get("/getWalletUsers", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // loadCallUsers(data) {
  //   return new Promise((next) => {
  //     authAxios.get('/getCallUsers', { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  loadCallUsers(data) {
    return new Promise((next) => {
      authLAxios.get('/getCallUsers', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // loadWalletInvoiceUsers(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/getWalletUsersByInvoiceUnderReviewed", {
  //         params: { ...data },
  //         ...getToken(),
  //       })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadWalletInvoiceUsers(data) {
    return new Promise((next) => {
      authLAxios
        .get("/getWalletUsersByInvoiceUnderReviewed", {
          params: { ...data },
          ...getToken(),
        })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getPaymentDeskUsers(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/getPaymentDeskUsers", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getPaymentDeskUsers(data) {
    return new Promise((next) => {
      authLAxios
        .get("/getPaymentDeskUsers", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // loadUniversities(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/getWalletUniversities", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  loadUniversityByIds(data) {
    return new Promise((next) => {
      authLAxios.get('/loadUniversityByIds', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }
  loadUniversities(data) {
    return new Promise((next) => {
      authLAxios
        .get("/getWalletUniversities", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // generateInvoiceIncentive() {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/generateInvoiceIncentive`, {}, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  generateInvoiceIncentive() {
    return new Promise((next) => {
      authLAxios
        .post(`/generateInvoiceIncentive`, {}, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // updateIncentivePreviousPayment(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/incentiveInvoicePreviousPayment`, data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  updateIncentivePreviousPayment(data) {
    return new Promise((next) => {
      authLAxios
        .post(`/incentiveInvoicePreviousPayment`, data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // generatePendingIncentiveInvoice() {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/generatePendingIncentiveInvoice`, {}, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  generatePendingIncentiveInvoice() {
    return new Promise((next) => {
      authLAxios
        .post(`/generatePendingIncentiveInvoice`, {}, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }


  // getConvertedInquiryReportStates(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/getConvertedInquiryReportStates`, data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getConvertedInquiryReportStates(data) {
    return new Promise((next) => {
      authLAxios
        .post(`/getConvertedInquiryReportStates`, data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  /* Counseller targets details Details */

  // getTargetDetails(params) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/reportTargetDetails`, { params: { ...params }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getTargetDetails(params) {
    return new Promise((next) => {
      authLAxios
        .get(`/reportTargetDetails`, { params: { ...params }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // addTargetDetails(obj) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/reportTargetDetails`, obj, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  addTargetDetails(obj) {
    return new Promise((next) => {
      authLAxios
        .post(`/reportTargetDetails`, obj, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // updateTargetDetails(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put("/reportTargetDetails", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  updateTargetDetails(data) {
    return new Promise((next) => {
      authLAxios
        .put("/reportTargetDetails", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // deleteTargetDetails(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .delete(`/reportTargetDetails?_id=${data._id}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  deleteTargetDetails(data) {
    return new Promise((next) => {
      authLAxios
        .delete(`/reportTargetDetails?_id=${data._id}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // financeTargetDetailsByID(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/financeTargetDetailsByID/" + data.id, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  financeTargetDetailsByID(data) {
    return new Promise((next) => {
      authLAxios
        .get("/financeTargetDetailsByID/" + data.id, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  /**Counseller targets details end */

  /* Plan Details */

  // getPlanDetails(params) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/planDetails`, { params: { ...params }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getPlanDetails(params) {
    return new Promise((next) => {
      authLAxios
        .get(`/planDetails`, { params: { ...params }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // addPlanDetails(obj) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/planDetails`, obj, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  addPlanDetails(obj) {
    return new Promise((next) => {
      authLAxios
        .post(`/planDetails`, obj, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // updatePlanDetails(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put("/planDetails", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  updatePlanDetails(data) {
    return new Promise((next) => {
      authLAxios
        .put("/planDetails", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // deletePlanDetails(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .delete(`/planDetails?_id=${data._id}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  deletePlanDetails(data) {
    return new Promise((next) => {
      authLAxios
        .delete(`/planDetails?_id=${data._id}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // planDetailsByID(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/planDetailsByID/" + data.id, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  planDetailsByID(data) {
    return new Promise((next) => {
      authLAxios
        .get("/planDetailsByID/" + data.id, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // getAgentTypePlans(agentType) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/planDetailsByAgentType/" + agentType, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getAgentTypePlans(agentType) {
    return new Promise((next) => {
      authLAxios
        .get("/planDetailsByAgentType/" + agentType, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  /* Plan Details */

  /* Vendor Details */

  // getVendorsDetails(params) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/vendorDetails`, { params: { ...params }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }


  getVendorsDetails(params) {
    return new Promise((next) => {
      authLAxios
        .get(`/vendorDetails`, { params: { ...params }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // addVendorsDetails(obj) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/vendorDetails`, obj, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  addVendorsDetails(obj) {
    return new Promise((next) => {
      authLAxios
        .post(`/vendorDetails`, obj, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // updateVendorsDetails(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put("/vendorDetails", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  updateVendorsDetails(data) {
    return new Promise((next) => {
      authLAxios
        .put("/vendorDetails", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // deleteVendorsDetails(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .delete(`/vendorDetails?_id=${data._id}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  deleteVendorsDetails(data) {
    return new Promise((next) => {
      authLAxios
        .delete(`/vendorDetails?_id=${data._id}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getVendorsByID(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/getVendorsByID/" + data.id, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  getVendorsByID(data) {
    return new Promise((next) => {
      authLAxios
        .get("/getVendorsByID/" + data.id, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getAllVendorWithOutAuth(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/getAllVendorWithOutAuth/", getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }


  getAllVendorWithOutAuth(data) {
    return new Promise((next) => {
      authLAxios
        .get("/getAllVendorWithOutAuth", getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  /* Vendor Details */

  // getAccountPaymentDetails(params) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/accountPaymentDetails`, { params: { ...params }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getAccountPaymentDetails(params) {
    return new Promise((next) => {
      authLAxios
        .get(`/accountPaymentDetails`, { params: { ...params }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getAccountPaymentDetailByReceipt(params) {
  //   return new Promise((next) => {
  //     authAxios.get('/getAccountPaymentDetailByReceipt', { params: { ...params }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   })
  // }
  getAccountPaymentDetailByReceipt(params) {
    return new Promise((next) => {
      authLAxios.get('/getAccountPaymentDetailByReceipt', { params: { ...params }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  // addAccountPaymentDetails(obj) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/accountPaymentDetails`, obj, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  addAccountPaymentDetails(obj) {
    return new Promise((next) => {
      authLAxios
        .post(`/accountPaymentDetails`, obj, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // updateAccountPaymentDetails(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put("/accountPaymentDetails", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  updateAccountPaymentDetails(data) {
    return new Promise((next) => {
      authLAxios
        .put("/accountPaymentDetails", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // deleteAccountPaymentDetails(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .delete(`/accountPaymentDetails?_id=${data._id}&deleteReason=${data.deleteReason}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  deleteAccountPaymentDetails(data) {
    return new Promise((next) => {
      authLAxios
        .delete(`/accountPaymentDetails?_id=${data._id}&deleteReason=${data.deleteReason}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // sendAccountPaymentDetails(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/sendAccountPaymentDetails/${data._id}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  sendAccountPaymentDetails(data) {
    return new Promise((next) => {
      authLAxios
        .get(`/sendAccountPaymentDetails/${data._id}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // accountPaymentDetailsByID(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/accountPaymentDetailsByID/" + data.id, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  accountPaymentDetailsByID(data) {
    return new Promise((next) => {
      authLAxios
        .get("/accountPaymentDetailsByID/" + data.id, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  /**Counseller targets details end */

  // addUpdateCompanySetting(data) {
  //   return new Promise((next) => {
  //     authAxios.post('/companySetting', data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  addUpdateCompanySetting(data) {
    return new Promise((next) => {
      authLAxios.post('/companySetting', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getCompanySetting(data) {
  //   return new Promise((next) => {
  //     authAxios.get('/companySetting', { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getCompanySetting(data) {
    return new Promise((next) => {
      authLAxios.get('/companySetting', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getBusinessDetails(businessId) {
  //   return new Promise((next) => {
  //     authAxios.get(`/companySetting?businessId=${businessId}`, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getBusinessDetails(businessId) {
    return new Promise((next) => {
      authLAxios.get(`/companySetting?businessId=${businessId}`, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  /* Start Rating Details */

  // getRatingsDetails(params) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/ratingDetails`, { params: { ...params }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  getRatingsDetails(params) {
    return new Promise((next) => {
      authLAxios
        .get(`/ratingDetails`, { params: { ...params }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // addRatingsDetails(obj) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/ratingDetails`, obj, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  addRatingsDetails(obj) {
    return new Promise((next) => {
      authLAxios
        .post(`/ratingDetails`, obj, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // updateRatingsDetails(data) {
  //   return new Promise((next) => {
  //     authLAxios
  //       .put("/ratingDetails", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  updateRatingsDetails(data) {
    return new Promise((next) => {
      authLAxios
        .put("/ratingDetails", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // deleteRatingsDetails(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .delete(`/ratingDetails?_id=${data._id}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  deleteRatingsDetails(data) {
    return new Promise((next) => {
      authLAxios
        .delete(`/ratingDetails?_id=${data._id}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // ratingDetailsByID(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/ratingDetailsByID/" + data.id, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  ratingDetailsByID(data) {
    return new Promise((next) => {
      authLAxios
        .get("/ratingDetailsByID/" + data.id, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // End Rating Operations

  /* Start Source Details */

  // getSourceDetails(params) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/sourceDetails`, { params: { ...params }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  getSourceDetails(params) {
    return new Promise((next) => {
      authLAxios
        .get(`/sourceDetails`, { params: { ...params }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // addSourceDetails(obj) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/sourceDetails", obj, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  addSourceDetails(obj) {
    return new Promise((next) => {
      authLAxios
        .post("/sourceDetails", obj, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // deleteSourceDetails(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .delete(`/sourceDetails?_id=${data._id}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  deleteSourceDetails(data) {
    return new Promise((next) => {
      authLAxios
        .delete(`/sourceDetails?_id=${data._id}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // sourceDetailByID(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/sourceDetailsByID/" + data.id, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  sourceDetailByID(data) {
    return new Promise((next) => {
      authLAxios
        .get("/sourceDetailsByID/" + data.id, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // updateSourceDetails(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put("/sourceDetails", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  updateSourceDetails(data) {
    return new Promise((next) => {
      authLAxios
        .put("/sourceDetails", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }


  updateSourceStatus(data) {
    return new Promise((next) => {
      authLAxios.post('/updateSourceStatus', data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  /* Source Details End */


  // Request Update Tution Fee



  // 


  // University Partnership Start

  // addUniversityPartnershipDetails(data) {
  //   return new Promise((next) => {
  //     authAxios.post("/universityPartnership", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  addUniversityPartnershipDetails(data) {
    return new Promise((next) => {
      authLAxios.post("/universityPartnership", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getAllUniversityPartnership(data) {
  //   return new Promise((next) => {
  //     authAxios.get("/universityPartnership", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getAllUniversityPartnership(data) {
    return new Promise((next) => {
      authLAxios.get("/universityPartnership", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // partnershipDetailById(data) {
  //   return new Promise((next) => {
  //     authAxios.get("/universityPartnershipById/" + data.id, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  partnershipDetailById(data) {
    return new Promise((next) => {
      authLAxios.get("/universityPartnershipById/" + data.id, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // updateUniversityPartnershipDetail(data) {
  //   return new Promise((next) => {
  //     authAxios.put("/universityPartnership", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  updateUniversityPartnershipDetail(data) {
    return new Promise((next) => {
      authLAxios.put("/universityPartnership", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // deletePartnershipDetail(data) {
  //   return new Promise((next) => {
  //     authAxios.delete(`/universityPartnership?_id=${data._id}`, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  deletePartnershipDetail(data) {
    return new Promise((next) => {
      authLAxios.delete(`/universityPartnership?_id=${data._id}`, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }


  // University Partnership End

  /* Visa Type Details */


  // addVisaTypeDetail(data) {
  //   return new Promise((next) => {
  //     authAxios.post("/visitorVisaType", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  addVisaTypeDetail(data) {
    return new Promise((next) => {
      authLAxios.post("/visitorVisaType", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getAllVisitorVisaType(data) {
  //   return new Promise((next) => {
  //     authAxios.get("/visitorVisaType", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  getAllVisitorVisaType(data) {
    return new Promise((next) => {
      authLAxios.get("/visitorVisaType", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  addVisitorConsultancyCharges(data) {
    return new Promise((next) => {
      authLAxios.post('/visitorVisaConsultancy', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  getVisitorVisaReport(data) {
    return new Promise((next) => {
      authLAxios.get('/getVisitorVisaReport', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  getVisitorReportFilters(data) {
    return new Promise((next) => {
      authLAxios.get('/getVisitorReportFilters', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  exportVisitorVisaReport(data) {
    return new Promise((next) => {
      authLAxios.post('/exportVisitorVisaReport', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getVisitorVisaDetailById(data) {
  //   return new Promise((next) => {
  //     authAxios.get("/visitorVisaTypeById/" + data.id, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getVisitorVisaDetailById(data) {
    return new Promise((next) => {
      authLAxios.get("/visitorVisaTypeById/" + data.id, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }



  // updateVisaTypeDetail(data) {
  //   return new Promise((next) => {
  //     authAxios.put("/visitorVisaType", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  updateVisaTypeDetail(data) {
    return new Promise((next) => {
      authLAxios.put("/visitorVisaType", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // deleteVisitorVisaTypeDetail(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .delete(`/visitorVisaType?_id=${data._id}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  deleteVisitorVisaTypeDetail(data) {
    return new Promise((next) => {
      authLAxios
        .delete(`/visitorVisaType?_id=${data._id}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  /* Status Details Start */

  // addStatusDetails(obj) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/statusDetails", obj, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  addStatusDetails(obj) {
    return new Promise((next) => {
      authLAxios
        .post("/statusDetails", obj, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getStatusDetails(params) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/statusDetails", { params: { ...params }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getStatusDetails(params) {
    return new Promise((next) => {
      authLAxios
        .get("/statusDetails", { params: { ...params }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // statusDetailByID(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/statusDetailsByID/" + data.id, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  statusDetailByID(data) {
    return new Promise((next) => {
      authLAxios
        .get("/statusDetailsByID/" + data.id, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // updateStatusDetails(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put("/statusDetails", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  updateStatusDetails(data) {
    return new Promise((next) => {
      authLAxios
        .put("/statusDetails", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // deleteStatusDetails(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .delete(`/statusDetails?_id=${data._id}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  deleteStatusDetails(data) {
    return new Promise((next) => {
      authLAxios
        .delete(`/statusDetails?_id=${data._id}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  /* Status Details End */


  // Document Types Start

  // addDocumentType(data) {
  //   return new Promise((next) => {
  //     authAxios.post("/documentTypes", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  addDocumentType(data) {
    return new Promise((next) => {
      authLAxios.post("/documentTypes", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getAllDocumentTypes(params) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/documentTypes`, { params: { ...params }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  getAllDocumentTypes(params) {
    return new Promise((next) => {
      authLAxios
        .get(`/documentTypes`, { params: { ...params }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getDocumentTypeById(data) {
  //   return new Promise((next) => {
  //     authAxios.get("/documentTypesById/" + data.id, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  getDocumentTypeById(data) {
    return new Promise((next) => {
      authLAxios.get("/documentTypesById/" + data.id, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // updateDocumentType(data) {
  //   return new Promise((next) => {
  //     authAxios.put('/documentTypes', data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  updateDocumentType(data) {
    return new Promise((next) => {
      authLAxios.put('/documentTypes', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // deleteDocumentType(data) {
  //   return new Promise((next) => {
  //     authAxios.delete(`/documentTypes?_id=${data._id}`, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  deleteDocumentType(data) {
    return new Promise((next) => {
      authLAxios.delete(`/documentTypes?_id=${data._id}`, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }


  // Document Types End

  /* Start Gender Details    */

  // getGenderDetails(params) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/genderDetails`, { params: { ...params }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  getGenderDetails(params) {
    return new Promise((next) => {
      authLAxios
        .get(`/genderDetails`, { params: { ...params }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // addGenderDetails(obj) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/genderDetails", obj, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  addGenderDetails(obj) {
    return new Promise((next) => {
      authLAxios
        .post("/genderDetails", obj, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // deleteGenderDetails(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .delete(`/genderDetails?_id=${data._id}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  deleteGenderDetails(data) {
    return new Promise((next) => {
      authLAxios
        .delete(`/genderDetails?_id=${data._id}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // genderDetailByID(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/genderDetailsByID/" + data.id, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  genderDetailByID(data) {
    return new Promise((next) => {
      authLAxios
        .get("/genderDetailsByID/" + data.id, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // updateGenderDetails(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put("/genderDetails", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  updateGenderDetails(data) {
    return new Promise((next) => {
      authLAxios
        .put("/genderDetails", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  /*  Gender Details End   */

  /* Marital Status Start */

  // getMaritalStatusDetails(params) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/maritalStatusDetails`, { params: { ...params }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }


  getMaritalStatusDetails(params) {
    return new Promise((next) => {
      authLAxios
        .get(`/maritalStatusDetails`, { params: { ...params }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // Follow up Types

  // addFollowUpType(obj) {
  //   return new Promise((next) => {
  //     authAxios.post('/followUpTypes', obj, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  addFollowUpType(obj) {
    return new Promise((next) => {
      authLAxios.post('/followUpTypes', obj, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // updateFollowUpType(obj) {
  //   return new Promise((next) => {
  //     authAxios.put('/followUpTypes', obj, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  updateFollowUpType(obj) {
    return new Promise((next) => {
      authLAxios.put('/followUpTypes', obj, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getFollowUpTypes(params) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/followUpTypes`, { params: { ...params }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  getFollowUpTypes(params) {
    return new Promise((next) => {
      authLAxios
        .get(`/followUpTypes`, { params: { ...params }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // followUpTypeById(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/followUpDetailsById/" + data.id, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  followUpTypeById(data) {
    return new Promise((next) => {
      authLAxios
        .get("/followUpDetailsById/" + data.id, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // deleteFollowUpDetail(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .delete(`/followUpTypes?_id=${data._id}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  deleteFollowUpDetail(data) {
    return new Promise((next) => {
      authLAxios
        .delete(`/followUpTypes?_id=${data._id}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // addMaritalStatusDetails(obj) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/maritalStatusDetails", obj, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  addMaritalStatusDetails(obj) {
    return new Promise((next) => {
      authLAxios
        .post("/maritalStatusDetails", obj, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // deleteMaritalStatusDetails(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .delete(`/maritalStatusDetails?_id=${data._id}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  deleteMaritalStatusDetails(data) {
    return new Promise((next) => {
      authLAxios
        .delete(`/maritalStatusDetails?_id=${data._id}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // maritalStatusDetailByID(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/maritalStatusDetailsByID/" + data.id, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }


  maritalStatusDetailByID(data) {
    return new Promise((next) => {
      authLAxios
        .get("/maritalStatusDetailsByID/" + data.id, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // updateMaritalStatusDetails(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put("/maritalStatusDetails", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  updateMaritalStatusDetails(data) {
    return new Promise((next) => {
      authLAxios
        .put("/maritalStatusDetails", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  /* Marital Status End */

  /* Test Types Start */

  // getAllTestTypes(params) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/testTypesDetails`, { params: { ...params }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  getAllTestTypes(params) {
    return new Promise((next) => {
      authLAxios
        .get(`/testTypesDetails`, { params: { ...params }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // addTestTypesDetails(obj) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/testTypesDetails", obj, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  addTestTypesDetails(obj) {
    return new Promise((next) => {
      authLAxios
        .post("/testTypesDetails", obj, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // deleteTestTypesDetails(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .delete(`/testTypesDetails?_id=${data._id}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  deleteTestTypesDetails(data) {
    return new Promise((next) => {
      authLAxios
        .delete(`/testTypesDetails?_id=${data._id}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // testTypesDetailByID(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/testTypesDetailByID/" + data.id, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  testTypesDetailByID(data) {
    return new Promise((next) => {
      authLAxios
        .get("/testTypesDetailByID/" + data.id, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // updateTestTypesDetails(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put("/testTypesDetails", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  updateTestTypesDetails(data) {
    return new Promise((next) => {
      authLAxios
        .put("/testTypesDetails", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  /* Test Types End */

  /*  Board Rankings Start */

  // getBoardRankingDetails(params) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/boardRankings`, { params: { ...params }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  getBoardRankingDetails(params) {
    return new Promise((next) => {
      authLAxios
        .get(`/boardRankings`, { params: { ...params }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getBoardRankingDetailsByType(obj) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/boardRankingsByType", obj, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  getBoardRankingDetailsByType(obj) {
    return new Promise((next) => {
      authLAxios
        .post("/boardRankingsByType", obj, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // addBoardRankingDetails(obj) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/boardRankings", obj, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  addBoardRankingDetails(obj) {
    return new Promise((next) => {
      authLAxios
        .post("/boardRankings", obj, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // deleteBoardRankingDetails(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .delete(`/boardRankings?_id=${data._id}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  deleteBoardRankingDetails(data) {
    return new Promise((next) => {
      authLAxios
        .delete(`/boardRankings?_id=${data._id}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // boardRankingDetailByID(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/boardRankingDetailsByID/" + data.id, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  boardRankingDetailByID(data) {
    return new Promise((next) => {
      authLAxios
        .get("/boardRankingDetailsByID/" + data.id, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // updateBoardRankingDetails(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put("/boardRankings", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  updateBoardRankingDetails(data) {
    return new Promise((next) => {
      authLAxios
        .put("/boardRankings", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  /* Board Rankings End */

  /*  Board Categories Start */

  // getBoardCategoryDetails(params) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/boardCategories`, { params: { ...params }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  getBoardCategoryDetails(params) {
    return new Promise((next) => {
      authLAxios
        .get(`/boardCategories`, { params: { ...params }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // getBoardCategoryDetailsByType(obj) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/boardCategoriesByType", obj, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  getBoardCategoryDetailsByType(obj) {
    return new Promise((next) => {
      authLAxios
        .post("/boardCategoriesByType", obj, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // addBoardCategoryDetails(obj) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/boardCategories", obj, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  addBoardCategoryDetails(obj) {
    return new Promise((next) => {
      authLAxios
        .post("/boardCategories", obj, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // deleteBoardCategoryDetails(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .delete(`/boardCategories?_id=${data._id}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  deleteBoardCategoryDetails(data) {
    return new Promise((next) => {
      authLAxios
        .delete(`/boardCategories?_id=${data._id}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // boardCategoryDetailByID(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/boardCategoryDetailsByID/" + data.id, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  boardCategoryDetailByID(data) {
    return new Promise((next) => {
      authLAxios
        .get("/boardCategoryDetailsByID/" + data.id, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // updateBoardCategoryDetails(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put("/boardCategories", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  updateBoardCategoryDetails(data) {
    return new Promise((next) => {
      authLAxios
        .put("/boardCategories", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  /* Board Categories End */


  // Whatsapp Trigger Start

  // addUpdateWhatsappTrigger(data) {
  //   return new Promise((next) => {
  //     authAxios.post("/whatsappTrigger", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  // getWhatsappTriggers(data) {
  //   return new Promise((next) => {
  //     authAxios.get('/whatsappTrigger', { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }


  // Loyalty Program Settings Start

  // addUpdateLoyalitySettings(data) {
  //   return new Promise((next) => {
  //     authAxios.post("/loyalityProgramSettings", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  addUpdateLoyalitySettings(data) {
    return new Promise((next) => {
      authLAxios.post("/loyalityProgramSettings", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getLoyalityProgramSettings(data) {
  //   return new Promise((next) => {
  //     authAxios.get("/loyalityProgramSettings", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getLoyalityProgramSettings(data) {
    return new Promise((next) => {
      authLAxios.get("/loyalityProgramSettings", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }


  // Loyalty Program Members Start

  // addProgramMember(data) {
  //   return new Promise((next) => {
  //     authAxios.post("/loyalityMember", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  addProgramMember(data) {
    return new Promise((next) => {
      authLAxios.post("/loyalityMember", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getProgramMembers(data) {
  //   return new Promise((next) => {
  //     authAxios.get("/loyalityMember", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getProgramMembers(data) {
    return new Promise((next) => {
      authLAxios.get("/loyalityMember", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // updateProgramMember(data) {
  //   return new Promise((next) => {
  //     authAxios.put("/loyalityMember", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  updateProgramMember(data) {
    return new Promise((next) => {
      authLAxios.put("/loyalityMember", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getProgramMemberById(data) {
  //   return new Promise((next) => {
  //     authAxios.get('/programMemberById/' + data.id, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getProgramMemberById(data) {
    return new Promise((next) => {
      authLAxios.get('/programMemberById/' + data.id, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // deleteProgramMember(data) {
  //   return new Promise((next) => {
  //     authAxios.delete(`/loyalityMember?_id=${data._id}`, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  deleteProgramMember(data) {
    return new Promise((next) => {
      authLAxios.delete(`/loyalityMember?_id=${data._id}`, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }


  // Loyalty Program Codes Start

  // generateLoyalityCodes(data) {
  //   return new Promise((next) => {
  //     authAxios.post("/generateRandomLoyalityCodes", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  generateLoyalityCodes(data) {
    return new Promise((next) => {
      authLAxios.post("/generateRandomLoyalityCodes", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getAllLoyalityCodes(data) {
  //   return new Promise((next) => {
  //     authAxios.get('/loyalityCodes', { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getAllLoyalityCodes(data) {
    return new Promise((next) => {
      authLAxios.get('/loyalityCodes', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // Loyalty Program Details Start

  // addProgramDetail(data) {
  //   return new Promise((next) => {
  //     authAxios.post('/loyalityDetail', data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  addProgramDetail(data) {
    return new Promise((next) => {
      authLAxios.post('/loyalityDetail', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getProgramDetails(data) {
  //   return new Promise((next) => {
  //     authAxios.get("/loyalityDetail", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getProgramDetails(data) {
    return new Promise((next) => {
      authLAxios.get("/loyalityDetail", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getProgramDetailById(data) {
  //   return new Promise((next) => {
  //     authAxios.get('/programDetailById/' + data.id, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getProgramDetailById(data) {
    return new Promise((next) => {
      authLAxios.get('/programDetailById/' + data.id, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // updateProgramDetail(data) {
  //   return new Promise((next) => {
  //     authAxios.put('/loyalityDetail', data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  updateProgramDetail(data) {
    return new Promise((next) => {
      authLAxios.put('/loyalityDetail', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // deleteProgramDetail(data) {
  //   return new Promise((next) => {
  //     authAxios.delete(`/loyalityDetail?_id=${data._id}`, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  deleteProgramDetail(data) {
    return new Promise((next) => {
      authLAxios.delete(`/loyalityDetail?_id=${data._id}`, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  /* Training Section Start */

  // addTrainingDetails(data) {
  //   return new Promise((next) => {
  //     authAxios.post("/trainings", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  addTrainingDetails(data) {
    return new Promise((next) => {
      authLAxios.post("/trainings", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }
  // updateTrainingDetails(data) {
  //   return new Promise((next) => {
  //     authAxios.put("/trainings", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  updateTrainingDetails(data) {
    return new Promise((next) => {
      authLAxios.put("/trainings", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getTrainingDetails(data) {
  //   return new Promise((next) => {
  //     authAxios.get("/trainings", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getTrainingDetails(data) {
    return new Promise((next) => {
      authLAxios.get("/trainings", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // deleteTrainingDetails(data) {
  //   return new Promise((next) => {
  //     authAxios.delete(`/trainings?_id=${data._id}`, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  deleteTrainingDetails(data) {
    return new Promise((next) => {
      authLAxios.delete(`/trainings?_id=${data._id}`, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // trainingDetailById(data) {
  //   return new Promise((next) => {
  //     authAxios.get('/trainingDetailByID/' + data.id, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  trainingDetailById(data) {
    return new Promise((next) => {
      authLAxios.get('/trainingDetailByID/' + data.id, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  /* Training Section End */

  /* Start Govt Holiday Details */

  // getGovtHolidays(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/govtHolidaysByPost", data, getToken())
  //       .then((d) => {
  //         next(d);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getGovtHolidays(data) {
    return new Promise((next) => {
      authLAxios
        .post("/govtHolidaysByPost", data, getToken())
        .then((d) => {
          next(d);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // addGovtHolidays(obj) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/govtHolidays`, obj, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  addGovtHolidays(obj) {
    return new Promise((next) => {
      authLAxios
        .post(`/govtHolidays`, obj, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // updateGovtHolidays(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put("/govtHolidays", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  updateGovtHolidays(data) {
    return new Promise((next) => {
      authLAxios
        .put("/govtHolidays", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // deleteGovtHolidays(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .delete(`/govtHolidays?_id=${data._id}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  deleteGovtHolidays(data) {
    return new Promise((next) => {
      authLAxios
        .delete(`/govtHolidays?_id=${data._id}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // govtHolidayByID(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/govtHolidayByID/" + data.id, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  govtHolidayByID(data) {
    return new Promise((next) => {
      authLAxios
        .get("/govtHolidayByID/" + data.id, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // End Govt Holiday Operations

  /* Start Staff Salary Details */

  // getStaffSalaryList(params) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/staffSallaryData`, { params: { ...params }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getStaffSalaryList(params) {
    return new Promise((next) => {
      authLAxios
        .get(`/staffSallaryData`, { params: { ...params }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // updateStaffSalaryPayment(data) {
  //   return new Promise((next) => {
  //     authAxios.post("/updateStaffSalaryPayment", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  // addStaffSalaryList(obj) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/staffSallaryData`, obj, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  addStaffSalaryList(obj) {
    return new Promise((next) => {
      authLAxios
        .post(`/staffSallaryData`, obj, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // addSupportStaffSalary(obj) {
  //   return new Promise((next) => {
  //     authAxios.post("/supportStaffSalary", obj, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  addSupportStaffSalary(obj) {
    return new Promise((next) => {
      authLAxios.post("/supportStaffSalary", obj, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getSupportStaffSalary(obj) {
  //   return new Promise((next) => {
  //     authAxios.get('/supportStaffSalary', { params: { ...obj }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  getSupportStaffSalary(obj) {
    return new Promise((next) => {
      authLAxios.get('/supportStaffSalary', { params: { ...obj }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // supportStaffSalaryById(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/supportStaffSalaryById/" + data.id, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  supportStaffSalaryById(data) {
    return new Promise((next) => {
      authLAxios
        .get("/supportStaffSalaryById/" + data.id, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }


  updateSupportStaffSalary(data) {
    return new Promise((next) => {
      authLAxios.put('/supportStaffSalary', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }
  // updateSupportStaffSalary(data) {
  //   return new Promise((next) => {
  //     authAxios.put('/supportStaffSalary', data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  // deleteSupportStaffSalary(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .delete(`/supportStaffSalary?_id=${data._id}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  deleteSupportStaffSalary(data) {
    return new Promise((next) => {
      authLAxios
        .delete(`/supportStaffSalary?_id=${data._id}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  addSupportStaffSalaryConfirmation(data) {
    return new Promise((next) => {
      authLAxios.post('/supportStaffSalaryConfirmation', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // addSupportStaffSalaryConfirmation(data) {
  //   return new Promise((next) => {
  //     authAxios.post('/supportStaffSalaryConfirmation', data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  // updateStaffSalaryList(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put("/staffSallaryData", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  updateStaffSalaryList(data) {
    return new Promise((next) => {
      authLAxios
        .put("/staffSallaryData", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // deleteStaffSalaryList(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .delete(`/staffSallaryData?_id=${data._id}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  deleteStaffSalaryList(data) {
    return new Promise((next) => {
      authLAxios
        .delete(`/staffSallaryData?_id=${data._id}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }


  // staffSalaryByID(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/staffSalaryByID/" + data.id, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  staffSalaryByID(data) {
    return new Promise((next) => {
      authLAxios
        .get("/staffSalaryByID/" + data.id, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // End Staff Salary Operations

  // Add Update Communication Setting
  // getCommunicationSettings(params) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/communicationSettings`, { params: { ...params }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getCommunicationSettings(params) {
    return new Promise((next) => {
      authLAxios
        .get(`/communicationSettings`, { params: { ...params }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // addCommunicationSettings(obj) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/communicationSettings`, obj, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  addCommunicationSettings(obj) {
    return new Promise((next) => {
      authLAxios
        .post(`/communicationSettings`, obj, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  /* Start Sub Rating Details */

  // getSubRatingsDetails(params) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/subRatingDetails`, { params: { ...params }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  getSubRatingsDetails(params) {
    return new Promise((next) => {
      authLAxios
        .get(`/subRatingDetails`, { params: { ...params }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // addSubRatingsDetails(obj) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/subRatingDetails`, obj, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  addSubRatingsDetails(obj) {
    return new Promise((next) => {
      authLAxios
        .post(`/subRatingDetails`, obj, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // updateSubRatingsDetails(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put("/subRatingDetails", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  updateSubRatingsDetails(data) {
    return new Promise((next) => {
      authLAxios
        .put("/subRatingDetails", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // deleteSubRatingsDetails(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .delete(`/subRatingDetails?_id=${data._id}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  deleteSubRatingsDetails(data) {
    return new Promise((next) => {
      authLAxios
        .delete(`/subRatingDetails?_id=${data._id}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // subRatingDetailsByID(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/subRatingDetailsByID/" + data.id, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  subRatingDetailsByID(data) {
    return new Promise((next) => {
      authLAxios
        .get("/subRatingDetailsByID/" + data.id, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // End SUb Rating Operations

  // paidPaymentDesk(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/paidPaymentDesk`, { ...data }, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  // paidPaymentDesk(data) {
  //   return new Promise((next) => {
  //     authLAxios
  //       .post(`/paidPaymentDesk`, { ...data }, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  // approveInvoice(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/approveInvoice`, { ...data }, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  approveInvoice(data) {
    return new Promise((next) => {
      authLAxios
        .post(`/approveInvoice`, { ...data }, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  /* Add Update Delete get all Help & support questions start */
  // getHelpSupport(params) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/helpSupport`, { params: { ...params }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getHelpSupport(params) {
    return new Promise((next) => {
      authLAxios
        .get(`/helpSupport`, { params: { ...params }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // addSupportRequest(obj) {
  //   return new Promise((next) => {
  //     authAxios.post('/addSupportRequest', obj, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  addSupportRequest(obj) {
    return new Promise((next) => {
      authLAxios.post('/addSupportRequest', obj, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // addHelpSupport(obj) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/helpSupport`, obj, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }


  addHelpSupport(obj) {
    return new Promise((next) => {
      authLAxios
        .post(`/helpSupport`, obj, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // updateHelpSupport(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put("/helpSupport", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  updateHelpSupport(data) {
    return new Promise((next) => {
      authLAxios
        .put("/helpSupport", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // deleteHelpSupport(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .delete(`/helpSupport?_id=${data._id}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  deleteHelpSupport(data) {
    return new Promise((next) => {
      authLAxios
        .delete(`/helpSupport?_id=${data._id}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getHelpSupportByID(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/getHelpSupportByID/" + data.id, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getHelpSupportByID(data) {
    return new Promise((next) => {
      authLAxios
        .get("/getHelpSupportByID/" + data.id, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getCompanyRules(params) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/getCompanyRules`, { params: { ...params }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getCompanyRules(params) {
    return new Promise((next) => {
      authLAxios
        .get(`/getCompanyRules`, { params: { ...params }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  /* Add Update Delete get all Help & support questions end */

  /* Add Update Delete get all Suggestions start */

  // getSuggestion(params) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/suggestions`, { params: { ...params }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getSuggestion(params) {
    return new Promise((next) => {
      authLAxios
        .get(`/suggestions`, { params: { ...params }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // addSuggestion(obj) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/suggestions`, obj, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  addSuggestion(obj) {
    return new Promise((next) => {
      authLAxios
        .post(`/suggestions`, obj, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // updateSuggestion(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put("/suggestions", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  updateSuggestion(data) {
    return new Promise((next) => {
      authLAxios
        .put("/suggestions", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // updateSuggestionStatus(data) {
  //   return new Promise((next) => {
  //     authAxios.put("/updateSuggestionStatus", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   })
  // }
  updateSuggestionStatus(data) {
    return new Promise((next) => {
      authLAxios.put("/updateSuggestionStatus", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  // deleteSuggestion(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .delete(`/suggestions?_id=${data._id}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  deleteSuggestion(data) {
    return new Promise((next) => {
      authLAxios
        .delete(`/suggestions?_id=${data._id}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getSuggestionByID(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/getSuggestionByID/" + data.id, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getSuggestionByID(data) {
    return new Promise((next) => {
      authLAxios
        .get("/getSuggestionByID/" + data.id, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // getAllSuggestions(params) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/getAllSuggestions`, { params: { ...params }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getAllSuggestions(params) {
    return new Promise((next) => {
      authLAxios
        .get(`/getAllSuggestions`, { params: { ...params }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // completeRaisedTickets(obj) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/completeRaisedTickets`, obj, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  completeRaisedTickets(obj) {
    return new Promise((next) => {
      authLAxios
        .post(`/completeRaisedTickets`, obj, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  /* Add Update Delete get all Suggestions end */

  // Save Update fetch ivr management
  // saveIVRSettings(obj) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/saveIVRSettings`, obj, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  saveIVRSettings(obj) {
    return new Promise((next) => {
      authLAxios
        .post(`/saveIVRSettings`, obj, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // getIVRSettings() {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/getIVRSettings", getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getIVRSettings() {
    return new Promise((next) => {
      authLAxios
        .get("/getIVRSettings", getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // startSyncUsers() {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/startSyncUsers", getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  startSyncUsers() {
    return new Promise((next) => {
      authLAxios
        .get("/startSyncUsers", getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // changeIVRUserStatus(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/changeIVRUserStatus", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  changeIVRUserStatus(data) {
    return new Promise((next) => {
      authLAxios
        .post("/changeIVRUserStatus", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // saveAssignTellecaller(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/saveAssignTellecaller", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  saveAssignTellecaller(data) {
    return new Promise((next) => {
      authLAxios
        .post("/saveAssignTellecaller", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // getAllIVRUsers(params) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/getAllIVRUsers`, { params: { ...params }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getAllIVRUsers(params) {
    return new Promise((next) => {
      authLAxios
        .get(`/getAllIVRUsers`, { params: { ...params }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // searchCallLogs(obj) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/searchCallLogs`, obj, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  // searchCallLogs(obj) {
  //   return new Promise((next) => {
  //     authLAxios
  //       .post(`/searchCallLogs`, obj, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  // callInitiate(obj) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/callInitiate`, obj, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  callInitiate(obj) {
    return new Promise((next) => {
      authLAxios
        .post(`/callInitiate`, obj, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // getAllIVRCallLogs(params) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/getAllIVRCallLogs`, { params: { ...params }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getAllIVRCallLogs(params) {
    return new Promise((next) => {
      authLAxios
        .get(`/getAllIVRCallLogs`, { params: { ...params }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // getUserAttendance(params) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/getUserAttendance`, { params: { ...params }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getUserAttendance(params) {
    return new Promise((next) => {
      authLAxios
        .get(`/getUserAttendance`, { params: { ...params }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  uploadSampleDocuments(data) {
    return new Promise((next) => {
      authLAxios.post('/payrollDocuments', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }
  // uploadSampleDocuments(data) {
  //   return new Promise((next) => {
  //     authAxios.post('/payrollDocuments', data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  getAllPayrollDocuments(data) {
    return new Promise((next) => {
      authLAxios.get('/payrollDocuments', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getAllPayrollDocuments(data) {
  //   return new Promise((next) => {
  //     authAxios.get('/payrollDocuments', { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  // sendPayrollForConfirmation(data) {
  //   return new Promise((next) => {
  //     authAxios.post("/payrollForConfirmation", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  sendPayrollForConfirmation(data) {
    return new Promise((next) => {
      authLAxios.post("/payrollForConfirmation", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // sendPayrollConfirmationToMany(data) {
  //   return new Promise((next) => {
  //     authAxios.post("/allPayrollConfirmation", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  // AddLetterOfIntent(data) {
  //   return new Promise((next) => {
  //     authAxios.post("/letterOfIntent", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  AddLetterOfIntent(data) {
    return new Promise((next) => {
      authLAxios.post("/letterOfIntent", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getAllLetterOfIntent(data) {
  //   return new Promise((next) => {
  //     authAxios.get("/letterOfIntent", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getAllLetterOfIntent(data) {
    return new Promise((next) => {
      authLAxios.get("/letterOfIntent", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }
  // getStaffPayrolls(data) {
  //   return new Promise((next) => {
  //     authAxios.get("/payrollForConfirmation", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getStaffPayrolls(data) {
    return new Promise((next) => {
      authLAxios.get("/payrollForConfirmation", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }
  getUserPayroll(data) {
    return new Promise((next) => {
      authLAxios.get("/getUserPayroll", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }
  // getUserPayroll(data) {
  //   return new Promise((next) => {
  //     authAxios.get("/getUserPayroll", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  // updateStaffSalaryStatus(data) {
  //   return new Promise((next) => {
  //     authAxios.put("/payrollForConfirmation", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  updateStaffSalaryStatus(data) {
    return new Promise((next) => {
      authLAxios.put("/payrollForConfirmation", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }


  // getStaffAttendance(params) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/getStaffAttendance`, { params: { ...params }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getStaffAttendance(params) {
    return new Promise((next) => {
      authLAxios
        .get(`/getStaffAttendance`, { params: { ...params }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  exportStaffAttendance(params) {
    return new Promise((next) => {
      authLAxios
        .get(`/exportStaffAttendance`, { params: { ...params }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // updateAttendence(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post("/updateAttendence", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  updateAttendence(data) {
    return new Promise((next) => {
      authLAxios
        .post("/updateAttendence", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // getUserAttendenceReports(data) {
  //   return new Promise((next) => {
  //     authAxios.get("/getUserAttendenceReports", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getUserAttendenceReports(data) {
    return new Promise((next) => {
      authLAxios.get("/getUserAttendenceReports", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // deleteAttendence(data) {
  //   return new Promise((next) => {
  //     authAxios.delete("/deleteAttendence/" + data._id, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  deleteAttendence(data) {
    return new Promise((next) => {
      authLAxios.delete("/deleteAttendence/" + data._id, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }
  // updateSelectedStaffAttendence(data) {
  //   return new Promise((next) => {
  //     authAxios.post("/updateStaffAttendence", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  updateSelectedStaffAttendence(data) {
    return new Promise((next) => {
      authLAxios.post("/updateStaffAttendence", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }
  // requestAttendenceRegularisation(data) {
  //   return new Promise((next) => {
  //     authAxios.post("/regularisationRequests", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  requestAttendenceRegularisation(data) {
    return new Promise((next) => {
      authLAxios.post("/regularisationRequests", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }
  // getUserRegularisationRequests(data) {
  //   return new Promise((next) => {
  //     authAxios.get("/getUserRegularisationRequests", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getUserRegularisationRequests(data) {
    return new Promise((next) => {
      authLAxios.get("/getUserRegularisationRequests", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }
  // getRegularisationRequests(data) {
  //   return new Promise((next) => {
  //     authAxios.get("/regularisationRequests", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getRegularisationRequests(data) {
    return new Promise((next) => {
      authLAxios.get("/regularisationRequests", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }
  // updateRegularisationRequest(data) {
  //   return new Promise((next) => {
  //     authAxios.put("/regularisationRequests", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  updateRegularisationRequest(data) {
    return new Promise((next) => {
      authLAxios.put("/regularisationRequests", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }
  // getStaffOverallReport(params) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/getStaffOverallReport`, { params: { ...params }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getStaffOverallReport(params) {
    return new Promise((next) => {
      authLAxios
        .get(`/getStaffOverallReport`, { params: { ...params }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // getUserOverallReport(params) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/getUserOverallReport`, { params: { ...params }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }

  getUserOverallReport(params) {
    return new Promise((next) => {
      authLAxios
        .get(`/getUserOverallReport`, { params: { ...params }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }


  // Resignation Section //

  // addResignation(data) {
  //   return new Promise((next) => {
  //     authAxios.post('/resignation', data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  addResignation(data) {
    return new Promise((next) => {
      authLAxios.post('/resignation', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getUserResignations(data) {
  //   return new Promise((next) => {
  //     authAxios.get('/getUserResignations', { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  getUserResignations(data) {
    return new Promise((next) => {
      authLAxios.get('/getUserResignations', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }


  // getUserApprovedResignation() {
  //   return new Promise((next) => {
  //     authAxios.get('/getUserApprovedResignation', getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }


  // getStaffResignations(data) {
  //   return new Promise((next) => {
  //     authAxios.get("/resignation", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getStaffResignations(data) {
    return new Promise((next) => {
      authLAxios.get("/resignation", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // updateResignation(data) {
  //   return new Promise((next) => {
  //     authAxios.put("/resignation", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  updateResignation(data) {
    return new Promise((next) => {
      authLAxios.put("/resignation", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getResignDataById(data) {
  //   return new Promise((next) => {
  //     authAxios.get("/resignationById/" + data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getResignDataById(data) {
    return new Promise((next) => {
      authLAxios.get("/resignationById/" + data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }


  /* Generate Expiernce Letter */
  // generateExpiernceLetter(data) {
  //   return new Promise((next) => {
  //     authAxios.post('/generateExpiernceLetter', data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  generateExpiernceLetter(data) {
    return new Promise((next) => {
      authLAxios.post('/generateExpiernceLetter', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getPoliciesFile(data) {
  //   return new Promise((next) => {
  //     authAxios.get("/getPoliciesFile", getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getPoliciesFile(data) {
    return new Promise((next) => {
      authLAxios.get("/getPoliciesFile", getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }
  // generateAppointmentLetter(data) {
  //   return new Promise((next) => {
  //     authAxios.post('/generateAppointmentLetter', data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  generateAppointmentLetter(data) {
    return new Promise((next) => {
      authLAxios.post('/generateAppointmentLetter', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // generateAppraisalLetter(data) {
  //   return new Promise((next) => {
  //     authAxios.post('/generateAppraisalLetter', data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  generateAppraisalLetter(data) {
    return new Promise((next) => {
      authLAxios.post('/generateAppraisalLetter', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }
  // generateEmployeeAgreement(data) {
  //   return new Promise((next) => {
  //     authAxios.post('/generateEmployeeAgreement', data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  generateEmployeeAgreement(data) {
    return new Promise((next) => {
      authLAxios.post('/generateEmployeeAgreement', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }
  /* Add Update Delete get all Consouritum  start */

  // getConsortiumsDetails(params) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get(`/consortiums`, { params: { ...params }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  getConsortiumsDetails(params) {
    return new Promise((next) => {
      authLAxios
        .get(`/consortiums`, { params: { ...params }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // addConsortiumDetails(obj) {
  //   return new Promise((next) => {
  //     authAxios
  //       .post(`/consortiums`, obj, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  addConsortiumDetails(obj) {
    return new Promise((next) => {
      authLAxios
        .post(`/consortiums`, obj, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // updateConsortiumDetails(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .put("/consortiums", data, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  updateConsortiumDetails(data) {
    return new Promise((next) => {
      authLAxios
        .put("/consortiums", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // deleteConsortiumDetails(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .delete(`/consortiums?_id=${data._id}`, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  deleteConsortiumDetails(data) {
    return new Promise((next) => {
      authLAxios
        .delete(`/consortiums?_id=${data._id}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  // consortiumDetailsByID(data) {
  //   return new Promise((next) => {
  //     authAxios
  //       .get("/consortiumDetailsByID/" + data.id, getToken())
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   });
  // }
  consortiumDetailsByID(data) {
    return new Promise((next) => {
      authLAxios
        .get("/consortiumDetailsByID/" + data.id, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  // End Consouritum

  // Appraisal Request Section

  // addAppraisalRequest(data) {
  //   return new Promise((next) => {
  //     authAxios.post('/appraisalRequest', data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  addAppraisalRequest(data) {
    return new Promise((next) => {
      authLAxios.post('/appraisalRequest', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getUserAppraisalRequest(data) {
  //   return new Promise((next) => {
  //     authAxios.get('/userAppraisalRequest', { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  getUserAppraisalRequest(data) {
    return new Promise((next) => {
      authLAxios.get('/userAppraisalRequest', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getTeamAppraisalRequests(data) {
  //   return new Promise((next) => {
  //     authAxios.get('/teamAppraisalRequest', { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  getTeamAppraisalRequests(data) {
    return new Promise((next) => {
      authLAxios.get('/teamAppraisalRequest', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }


  // getDepartmentHod(data) {
  //   return new Promise((next) => {
  //     authAxios.get("/getDepartmentHod", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getDepartmentHod(data) {
    return new Promise((next) => {
      authLAxios.get("/getDepartmentHod", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // updateAppraisalRequest(data) {
  //   return new Promise((next) => {
  //     authAxios.put('/appraisalRequest', data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  updateAppraisalRequest(data) {
    return new Promise((next) => {
      authLAxios.put('/appraisalRequest', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getStaffAppraisalRequests(data) {
  //   return new Promise((next) => {
  //     authAxios.get('/appraisalRequest', { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  getStaffAppraisalRequests(data) {
    return new Promise((next) => {
      authLAxios.get('/appraisalRequest', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }
  // getStaffAppraisalRequests(data) {
  //   return new Promise((next) => {
  //     authLAxios.get('/appraisalRequest', { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  //Staff Appraisals Section
  // addStaffAppraisal(data) {
  //   return new Promise((next) => {
  //     authAxios.post('/appraisal', data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  addStaffAppraisal(data) {
    return new Promise((next) => {
      authLAxios.post('/appraisal', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getAppraisalDetails(data) {
  //   return new Promise((next) => {
  //     authAxios.get('/appraisal', { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getAppraisalDetails(data) {
    return new Promise((next) => {
      authLAxios.get('/appraisal', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // updateStaffAppraisal(data) {
  //   return new Promise((next) => {
  //     authAxios.put('/appraisal', data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  updateStaffAppraisal(data) {
    return new Promise((next) => {
      authLAxios.put('/appraisal', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // addSalarySlipRequest(data) {
  //   return new Promise((next) => {
  //     authAxios.post('/salarySlip', data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  addSalarySlipRequest(data) {
    return new Promise((next) => {
      authLAxios.post('/salarySlip', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }
  // getUserSalarySlipRequests(data) {
  //   return new Promise((next) => {
  //     authAxios.get('/getUserSalarySlips', { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getUserSalarySlipRequests(data) {
    return new Promise((next) => {
      authLAxios.get('/getUserSalarySlips', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getStaffSalarySlipRequests(data) {
  //   return new Promise((next) => {
  //     authAxios.get('/salarySlip', { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getStaffSalarySlipRequests(data) {
    return new Promise((next) => {
      authLAxios.get('/salarySlip', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // updateSalarySlipRequest(data) {
  //   return new Promise((next) => {
  //     authAxios.put('/salarySlip', data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  updateSalarySlipRequest(data) {
    return new Promise((next) => {
      authLAxios.put('/salarySlip', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getIncentiveInvoices(data) {
  //   return new Promise((next) => {
  //     authAxios.get('/incentiveInvoice', { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getIncentiveInvoices(data) {
    return new Promise((next) => {
      authLAxios.get('/incentiveInvoice', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getIncentiveInvoiceById(data) {
  //   return new Promise((next) => {
  //     authAxios.get("/incentiveInvoiceById/" + data.id, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getIncentiveInvoiceById(data) {
    return new Promise((next) => {
      authLAxios.get("/incentiveInvoiceById/" + data.id, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // deleteIncentive(data) {
  //   return new Promise((next) => {
  //     authAxios.post('/deleteIncentive', data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  deleteIncentive(data) {
    return new Promise((next) => {
      authLAxios.post('/deleteIncentive', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // sendEmployeeIncentive(data) {
  //   return new Promise((next) => {
  //     authAxios.post('/sendEmployeeIncentive', data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  // sendIncentiveToEmployee(data) {
  //   return new Promise((next) => {
  //     authAxios.post('/sendIncentiveToEmployee', data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  updateIncentiveInvoice(data) {
    return new Promise((next) => {
      authLAxios.put("/incentiveInvoice", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // sendIncentiveInvoiceOnMail(data) {
  //   return new Promise((next) => {
  //     authAxios.post("/sendIncentiveInvoiceOnMail", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  sendIncentiveInvoiceOnMail(data) {
    return new Promise((next) => {
      authLAxios.post("/sendIncentiveInvoiceOnMail", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }


  // Company Assets Start
  // addCompanyAsset (data) {
  //   return new Promise((next)=>{
  //     authAxios.post("/companyAssets",data, getToken())
  //     .then((d)=>{
  //       next(d.data)
  //     })
  //     .catch((err)=>{
  //       this.error(err)
  //     })
  //   })
  // }

  addCompanyAsset(data) {
    return new Promise((next) => {
      authLAxios.post("/companyAssets", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  getAllCompanyAssets(data) {
    return new Promise((next) => {
      authLAxios.get('/companyAssets', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getAllCompanyAssets(data) {
  //   return new Promise((next)=>{
  //     authAxios.get("/companyAssets", {params:{...data}, ...getToken()})
  //     .then((d)=>{
  //       next(d.data)
  //     })
  //     .catch((err)=>{
  //       this.error(err)
  //     })
  //   })
  // }

  // updateCompanyAsset(data){
  //   return new Promise((next)=>{
  //     authAxios.put("/companyAssets", data, getToken())
  //     .then((d)=>{
  //       next(d.data)
  //     })
  //     .catch((err)=>{
  //       this.error(err)
  //     })
  //   })
  // }
  updateCompanyAsset(data) {
    return new Promise((next) => {
      authLAxios.put("/companyAssets", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // deleteCompanyAsset(data) {
  //   return new Promise((next)=>{
  //     authAxios.delete(`/companyAssets?_id=${data._id}`, getToken())
  //     .then((d)=>{
  //       next(d.data)
  //     })
  //     .catch((err)=>{
  //       this.error(err)
  //     })
  //   })
  // }
  deleteCompanyAsset(data) {
    return new Promise((next) => {
      authLAxios.delete(`/companyAssets?_id=${data._id}`, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }
  // Company Assets End


  //  Campaign Scheduler Start

  // addCampaignScheduler(data) {
  //   return new Promise((next) => {
  //     authAxios.post('/campaignScheduler', data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  addCampaignScheduler(data) {
    return new Promise((next) => {
      authLAxios.post('/campaignScheduler', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // updateCampaignScheduler(data) {
  //   return new Promise((next) => {
  //     authAxios.put("/campaignScheduler", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  updateCampaignScheduler(data) {
    return new Promise((next) => {
      authLAxios.put("/campaignScheduler", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getAllCampaignSchedulers(data) {
  //   return new Promise((next) => {
  //     authAxios.get("/campaignScheduler", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getAllCampaignSchedulers(data) {
    return new Promise((next) => {
      authLAxios.get("/campaignScheduler", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // deleteCampaignScheduler(data) {
  //   return new Promise((next) => {
  //     authAxios.delete(`/campaignScheduler?id=${data}`, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  deleteCampaignScheduler(data) {
    return new Promise((next) => {
      authLAxios.delete(`/campaignScheduler?id=${data}`, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }
  // Campaign Scheduler End


  // Type of Degrees Start


  // updateTypeOfDegree(data) {
  //   return new Promise((next) => {
  //     authAxios.put("/typeOfDegree", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  updateTypeOfDegree(data) {
    return new Promise((next) => {
      authLAxios.put("/typeOfDegree", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // addTypeOfDegree(data) {
  //   return new Promise((next) => {
  //     authAxios.post("/typeOfDegree", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  addTypeOfDegree(data) {
    return new Promise((next) => {
      authLAxios.post("/typeOfDegree", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getAllTypeOfDegrees(data) {
  //   return new Promise((next) => {
  //     authAxios.get("/typeOfDegree", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  getAllTypeOfDegrees(data) {
    return new Promise((next) => {
      authLAxios.get("/typeOfDegree", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // deleteTypeOfDegree(recordId) {
  //   return new Promise((next) => {
  //     authAxios.delete(`/typeOfDegree?id=${recordId}`, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  deleteTypeOfDegree(recordId) {
    return new Promise((next) => {
      authLAxios.delete(`/typeOfDegree?id=${recordId}`, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }


  // Type of Degrees End

  // FAQ

  // getSupportFaqs(data) {
  //   return new Promise((next) => {
  //     authAxios.get("/getSupportFaqs", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getSupportFaqs(data) {
    return new Promise((next) => {
      authLAxios.get("/getSupportFaqs", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }


  // Qualification Score Start

  // addQualificationScore(data) {
  //   return new Promise((next) => {
  //     authAxios.post("/qualificationScore", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  addQualificationScore(data) {
    return new Promise((next) => {
      authLAxios.post("/qualificationScore", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getAllQualifcationScores(data) {
  //   return new Promise((next) => {
  //     authAxios.get("/qualificationScore", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getAllQualifcationScores(data) {
    return new Promise((next) => {
      authLAxios.get("/qualificationScore", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // updateQualificationScore(data) {
  //   return new Promise((next) => {
  //     authAxios.put("/qualificationScore", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  updateQualificationScore(data) {
    return new Promise((next) => {
      authLAxios.put("/qualificationScore", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // deleteQualificationScore(data) {
  //   return new Promise((next) => {
  //     authAxios.delete(`/qualificationScore?id=${data.recordId}`, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  deleteQualificationScore(data) {
    return new Promise((next) => {
      authLAxios.delete(`/qualificationScore?id=${data.recordId}`, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getQualificationScore(data) {
  //   return new Promise((next) => {
  //     authAxios.get('/getSingleQualificationScore', { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getQualificationScore(data) {
    return new Promise((next) => {
      authLAxios.get('/getSingleQualificationScore', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }


  // Qualification Score End


  // Business Proposal Start
  // sendBusinessProposal(data) {
  //   return new Promise((next) => {
  //     authAxios.post("/businessProposal", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  sendBusinessProposal(data) {
    return new Promise((next) => {
      authLAxios.post("/businessProposal", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getBusinessProposalDetails(data) {
  //   return new Promise((next) => {
  //     authAxios.get("/businessProposal", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  getBusinessProposalDetails(data) {
    return new Promise((next) => {
      authLAxios.get("/businessProposal", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // addBusinessProposalFollowUp(data) {
  //   return new Promise((next) => {
  //     authAxios.post("/businessProposalFollowUp", data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  addBusinessProposalFollowUp(data) {
    return new Promise((next) => {
      authLAxios.post("/businessProposalFollowUp", data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }



  // loadBusinessProposalFollowUps(_id) {
  //   return new Promise((next) => {
  //     authAxios.get(`/businessProposalFollowUp/${_id}`, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  loadBusinessProposalFollowUps(_id) {
    return new Promise((next) => {
      authLAxios.get(`/businessProposalFollowUp/${_id}`, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getBusinessProposalFollowUps(data) {
  //   return new Promise((next) => {
  //     authAxios.get('/businessProposal/followUp/list', { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   })
  // }

  getBusinessProposalFollowUps(data) {
    return new Promise((next) => {
      authLAxios.get('/businessProposal/followUp/list', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  // getUniversityAgreementFollowUps(data) {
  //   return new Promise((next) => {
  //     authAxios.get('/universityAgreement/followUp/list', { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       });
  //   })
  // }
  getUniversityAgreementFollowUps(data) {
    return new Promise((next) => {
      authLAxios.get('/universityAgreement/followUp/list', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    })
  }

  // deleteBusinessProposal(_id) {
  //   return new Promise((next) => {
  //     authAxios.delete(`/businessProposal?_id=${_id}`, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  deleteBusinessProposal(_id) {
    return new Promise((next) => {
      authLAxios.delete(`/businessProposal?_id=${_id}`, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // sendBusinessProposalReminder(data) {
  //   return new Promise((next) => {
  //     authAxios.post('/sendBusinessProposalReminder', data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  sendBusinessProposalReminder(data) {
    return new Promise((next) => {
      authLAxios.post('/sendBusinessProposalReminder', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }


  // Business Proposal End

  // Campaign Start
  // addEmailCampaign(data) {
  //   return new Promise((next) => {
  //     authAxios.post('/emailCampaign', data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  addEmailCampaign(data) {
    return new Promise((next) => {
      authLAxios.post('/emailCampaign', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }


  // addWhatsappCampaign(data) {
  //   return new Promise((next) => {
  //     authAxios.post('/whatsappCampaign', data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }


  addWhatsappCampaign(data) {
    return new Promise((next) => {
      authLAxios.post('/whatsappCampaign', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  getAllCampaignDetails(data) {
    return new Promise((next) => {
      authLAxios.get('/getAllCampaigns', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }


  // getAllWhastappCampaigns(data) {
  //   return new Promise((next) => {
  //     authAxios.get("/whatsappCampaign", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data);
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       })
  //   })
  // }

  getAllWhastappCampaigns(data) {
    return new Promise((next) => {
      authLAxios.get("/whatsappCampaign", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        })
    })
  }

  // getAllEmailCampaigns(data) {
  //   return new Promise((next) => {
  //     authAxios.get("/emailCampaign", { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }

  getAllEmailCampaigns(data) {
    return new Promise((next) => {
      authLAxios.get("/emailCampaign", { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // Campaign End


  // University Merge Request Start

  // addUniversityMergeRequest(data) {
  //   return new Promise((next) => {
  //     authAxios.post('/universityMerge', data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  addUniversityMergeRequest(data) {
    return new Promise((next) => {
      authLAxios.post('/universityMerge', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err)
        })
    })
  }

  // getUniversityMergeRequests(data) {
  //   return new Promise((next) => {
  //     authAxios.get('/universityMerge', { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       }).catch((err) => {
  //         this.error(err)
  //       })
  //   })
  // }
  getUniversityMergeRequests(data) {
    return new Promise((next) => {
      authLAxios.get('/universityMerge', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        }).catch((err) => {
          this.error(err)
        })
    })
  }

  // deleteMergeRequest(data) {
  //   return new Promise((next) => {
  //     authAxios.delete(`/universityMerge?_id=${data._id}`, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       }).catch((err) => {
  //         this.error(err);
  //       })
  //   })
  // }
  deleteMergeRequest(data) {
    return new Promise((next) => {
      authLAxios.delete(`/universityMerge?_id=${data._id}`, getToken())
        .then((d) => {
          next(d.data)
        }).catch((err) => {
          this.error(err);
        })
    })
  }


  // University Merge Request End

  // Phone Submission Start
  addPhoneSubmission(data) {
    return new Promise((next) => {
      authLAxios.post('/phoneSubmission', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err);
        })
    })
  }
  // addPhoneSubmission(data) {
  //   return new Promise((next) => {
  //     authAxios.post('/phoneSubmission', data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       })
  //   })
  // }

  // getPhoneSubmission(data) {
  //   return new Promise((next) => {
  //     authAxios.get('/phoneSubmission', { params: { ...data }, ...getToken() })
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       })
  //   })
  // }
  getPhoneSubmission(data) {
    return new Promise((next) => {
      authLAxios.get('/phoneSubmission', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err);
        })
    })
  }

  // updateSubmissionStatus(data) {
  //   return new Promise((next) => {
  //     authAxios.put('/phoneSubmission', data, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       })
  //   })
  // }

  updateSubmissionStatus(data) {
    return new Promise((next) => {
      authLAxios.put('/phoneSubmission', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err);
        })
    })
  }

  // deletePhoneSubmission(data) {
  //   return new Promise((next) => {
  //     authAxios.delete(`/phoneSubmission?_id=${data._id}`, getToken())
  //       .then((d) => {
  //         next(d.data)
  //       })
  //       .catch((err) => {
  //         this.error(err);
  //       })
  //   })
  // }

  deletePhoneSubmission(data) {
    return new Promise((next) => {
      authLAxios.delete(`/phoneSubmission?_id=${data._id}`, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err);
        })
    })
  }
  // Phone Submission End


  // Counselling Conversion Report Start



  getCounsellingConversionReport(data) {
    return new Promise((next) => {
      authLAxios.get('/getCounsellorsConversionReport', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err);
        })
    })
  }

  getCounsellorPerformanceReport(data) {
    return new Promise((next) => {
      authLAxios.get('/getCounsellorPerformanceReport', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err);
        })
    })
  }


  // Counselling Conversion Report End


  // Staff In Out Timing Start
  getStaffInOutTime(data) {
    return new Promise((next) => {
      authLAxios.get('/getStaffInOutTime', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err);
        })
    })
  }

  updateInOutStatus(data) {
    return new Promise((next) => {
      authLAxios.post('/updateInOutStatus', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err);
        })
    })
  }



  // Staff In Out Timing End


  // Student Recruitment Report Start

  getStudentRecruitmentMetrics(data) {
    return new Promise((next) => {
      authLAxios.get('/getStudentRecruitmentReport', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err);
        })
    })
  }


  // Student Recruitment Report End


  // Finance Wallet Report Start

  getFinanceWalletReport(data) {
    return new Promise((next) => {
      authLAxios.get('/getFinanceWalletReport', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err);
        })
    })
  }

  getFinanceReportByInstitution(data) {
    return new Promise((next) => {
      authLAxios.get('/getFinanceReportByInstitution', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err);
        })
    })
  }
  apiCurrencyDetailRequest(data) {
    return new Promise((next) => {
      authLAxios.get('/apiCurrencyDetailRequest', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err);
        })
    })
  }

  apiYearDetailRequest(data) {
    return new Promise((next) => {
      authLAxios.get('/apiYearDetailRequest', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err);
        })
    })
  }

  apiMonthDetailRequest(data) {
    return new Promise((next) => {
      authLAxios.get('/apiMonthDetailRequest', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err);
        })
    })
  }

  exportFinanceWalletReport(data) {
    return new Promise((next) => {
      authLAxios.post('/exportFinanceWalletReport', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err);
        })
    })
  }

  getFinanceWalletStudentReport(data) {
    return new Promise((next) => {
      authLAxios.get('/getFinanceWalletStudentReport', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err);
        })
    })
  }
  exportFinanceWalletStudents(data) {
    return new Promise((next) => {
      authLAxios.post('/exportFinanceWalletStudents', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err);
        })
    })
  }


  // Finance Wallet Report End


  // Vendor Detail Report Start

  getVendorReport(data) {
    return new Promise((next) => {
      authLAxios.get('/getVendorReport', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err);
        })
    })
  }

  getVendorStudentDetails(data) {
    return new Promise((next) => {
      authLAxios.get('/getVendorStudentDetails', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err);
        })
    })
  }

  exportVendorReport(data) {
    return new Promise((next) => {
      authLAxios.post('/exportVendorReport', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err);
        })
    })
  }

  // Vendor Detail Report End


  // Apology Start
  addApology(data) {
    return new Promise((next) => {
      authLAxios.post('/apology', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err);
        })
    })
  }

  updateApology(data) {
    return new Promise((next) => {
      authLAxios.put('/apology', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err);
        })
    })
  }

  getApologies(data) {
    return new Promise((next) => {
      authLAxios.get('/apology', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err);
        })
    })
  }

  // Apology End


  // postpone Followup Request Start

  followUpPostponeRequest(data) {
    return new Promise((next) => {
      authLAxios.post('/postponeFollowup', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err);
        })
    })
  }

  loadPostponeRequests(data) {
    return new Promise((next) => {
      authLAxios.get('/postponeFollowup', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err);
        })
    })
  }

  updatePostponeRequestStatus(data) {
    return new Promise((next) => {
      authLAxios.put('/postponeFollowup', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err);
        })
    })
  }

  deletePostponeRequest(data) {
    return new Promise((next) => {
      authLAxios.delete('/postponeFollowup/' + data.id, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err);
        })
    })
  }

  // Postpone Followupo Request End


  // Consultancy Fee Report
  getConsultancyFeeReport(data) {
    return new Promise((next) => {
      authLAxios.get('/consultancyFeeReport', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err);
        })
    })
  }

  exportConsultancyFeeReport(data) {
    return new Promise((next) => {
      authLAxios.post('/exportConsultancyFeeReport', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err);
        })
    })
  }

  // Call Register Start
  addDetailInCallRegister(data) {
    return new Promise((next) => {
      authLAxios.post('/callRegister', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err);
        })
    })
  }

  // Call Register End

  // Request Upgrade Tution Fee Start
  requestUpdateTutionFeeMaster(data) {
    return new Promise((next) => {
      authLAxios.post('/requestUpdateTutionFeeMaster', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err);
        })
    })
  }

  getTutionFeeUpdateRequests(data) {
    return new Promise((next) => {
      authLAxios.get('/getTutionFeeUpdateRequests', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err);
        })
    })
  }

  updateTutionFeeRequest(data) {
    return new Promise((next) => {
      authLAxios.post('/updateTutionFeeRequest', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err);
        })
    })
  }


  // Request Upgrade Tution Fee End


  // Final Invoice Approval Section Start
  getInvoiceApprovalRequestCount(data) {
    return new Promise((next) => {
      authLAxios.get('/getInvoiceApprovalRequestCount', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err);
        })
    })
  }

  getInvoiceApprovalRequests(data) {
    return new Promise((next) => {
      authLAxios.get('/getInvoiceApprovalRequests', { params: { ...data }, ...getToken() })
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err);
        })
    })
  }

  updateInvoiceApprovalRequest(data) {
    return new Promise((next) => {
      authLAxios.post('/updateInvoiceApprovalRequest', data, getToken())
        .then((d) => {
          next(d.data)
        })
        .catch((err) => {
          this.error(err);
        })
    })
  }



  // Final Invoice Aproval Section End


  /* Start Lead Status Details */
  getLeadStatusDetails(params) {
    return new Promise((next) => {
      authLAxios
        .get(`/leadStatus`, { params: { ...params }, ...getToken() })
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  addLeadStatusDetails(obj) {
    return new Promise((next) => {
      authLAxios
        .post(`/leadStatus`, obj, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  updateLeadStatusDetails(data) {
    return new Promise((next) => {
      authLAxios
        .put("/leadStatus", data, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  deleteLeadStatusDetails(data) {
    return new Promise((next) => {
      authLAxios
        .delete(`/leadStatus?_id=${data._id}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }

  leadStatusDetailsByID(data) {
    return new Promise((next) => {
      authLAxios
        .get(`/leadStatusDetailsByID/${data.id}`, getToken())
        .then((d) => {
          next(d.data);
        })
        .catch((err) => {
          this.error(err);
        });
    });
  }
  /* End Lead Status Details */

}


export default new Request();

let getToken = () => {
  return {
    headers: { Authorization: "Bearer " + localStorage.getItem("token"), 'Content-Type': 'application/json', 'Accept': 'application/json' },
  };
  // return ({ 'headers': { 'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI1Y2M3ZjFhZGNhNWJkZTBjNTQ1OWE0MjkiLCJlbWFpbCI6InBheWFsLjk2MjFAZ21haWwuY29tIiwidXNlclR5cGUiOiJ1c2VyIiwiaWQiOiI1Y2M3ZjFhZGNhNWJkZTBjNTQ1OWE0MjkiLCJuYW1lIjoiUGF5YWwgR2FyZyIsInVzZXJCcmFuY2giOiI1YzdmYTdhMDExNmUzNjZlMDZkZjY2NjMiLCJpYXQiOjE1NTY2OTIwNDMsImV4cCI6MTU1Njc3ODQ0M30.LGrmjCncOm4z8R267cjwETr_SwgHgRff0-CBsbg1-cU' } })
};
